<template src="./index.html"></template>
<script>
	import minhead from '../../../../common/minHead/index.vue';
	import config from '../../../../../../configHttp.js';
	import SalesTaxReportTree from '../../../../common/SalesTaxReportTree/index.vue';
	import SalesTaxReportbox from '../../../../common/SalesTaxReportbox/index.vue';
	//增值税表
	import valueAddedMain from './valueAddedMain/index.vue';
	import {
		getdata as getdataval
	} from './valueAddedMain/data.js';
	//附表一
	import ScheduleI from './ScheduleI/index.vue';
	import {
		getdata as getdataI
	} from './ScheduleI/data.js';
	//附表二
	import ScheduleII from './ScheduleII/index.vue';
	import {
		getdata as getdataII
	} from './ScheduleII/data.js';
	//附表三
	import ScheduleIII from './ScheduleIII/index.vue';
	import {
		getdata as getdataIII
	} from './ScheduleIII/data.js';
	//附表四
	import ScheduleIV from './ScheduleIV/index.vue';
	import {
		getdata as getdataIV
	} from './ScheduleIV/data.js';
	//附表五
	import ScheduleV from './ScheduleV/index.vue';
	import {
		getdata as getdataV
	} from './ScheduleV/data.js';
	//增值税减免税申报明细表
	import TaxExemptionDeclaration from './TaxExemptionDeclaration/index.vue';
	import {
		getdata as getdatatax
	} from './TaxExemptionDeclaration/data.js';
	//代扣代缴税收通用缴款书抵扣清单
	import Withholding from './Withholding/index.vue';
	import {
		getdata as getdatawit
	} from './Withholding/data.js';
	import ReportSummary from './ReportSummary/index.vue';
	import {
		getdata as getdataSummary
	} from './ReportSummary/data.js';
	import OTDCertificates from './OTDCertificates/index.vue';
	import {
		getdata as getdataOTDC
	} from './OTDCertificates/data.js';
	import {
		querycell,
		writesave,
		startShenBao,
		forShengcdg,
		manuscriptqueryReportStep,
		manuscriptwriteimport,
		manuscriptUploadFile,
		annexadd
	} from '../../../../../api/Draftgeneration.js';
	import {
		querytemplatecell,
		getShuibDetailList,
		templatecellsave
	} from '../../../../../api/bbmb.js';
	import {
		reportquerytrack
	} from '../../../../../api/xggj.js';
	import {
		zcfg_fycx,
		zcfg_fetch
	} from '../../../../../api/zcfg.js';
	import {
		getReportAdditionalInfo
	} from '../../../../../api/home.js';

  import {
    get_info,
    zzs
  } from '../../../../../api/organization.js';
  import {queryCurrentPeriodExportBusinessSituation} from '../../../../../api/ckywqk.js'
  import {company} from '../../../../../api/organization.js'
  import ExportBusinessSituation from "../../../../common/SalesTaxReportbox/ExportBusinessSituation/index.vue";
	export default {
		name: '',
		components: {
      ExportBusinessSituation,
			minhead,
			SalesTaxReportTree,
			SalesTaxReportbox,
			valueAddedMain,
			ScheduleI,
			ScheduleII,
			ScheduleIII,
			ScheduleIV,
			ScheduleV,
			TaxExemptionDeclaration,
			Withholding,
			ReportSummary, //汇总表
			OTDCertificates //扣税凭证明细表
		},
		props: {
			type: {
				type: String,
				default: ''
			},
			params: {
				type: Object,
				default: {}
			},
			suosq: {
				type: String,
				default: ''
			},
			showbox: {
				type: Boolean,
				default: false
			},
			mintext: {
				type: String,
				default: '填写'
			},
			toseeUpdate: {
				type: Boolean,
				default: false
			},
			seeNow: {
				type: Boolean,
				default: false
			}
		},

		mounted() {
			this.getReportAdditionalInfo();
			if (this.toseeUpdate) {
				this.getShuibDetailList();
			} else {
				this.manuscriptqueryReportStep();
			}
      this.getAddTheDeductionRatio();
      company({
        companyId: this.params.companyId
      }).then(res => {
        if (res.data.code == 1) {
          this.baohckyw = res.data.data.company.baohckyw;
          this.chukywsmtc = res.data.data.company.chukywsmtc;
        } else {
          this.message.error(res.data.msg);
        }
      });
			window.test = this;
		},
		data: function() {
			return {
				Changed: 0,
				//左侧tree
				treestate: '', //隐藏和显示开关,
				statedata: [],
				treedata: [],
				choosetitleindex: '',
				//所有表头
				headobj: {},
				//税收分类编码（劳务）
				ssbm_lw: '',
				//主表
				tableDataZero: [],
				ZeroHead: ['zzs_0_x_1', 'zzs_0_x_2', 'zzs_0_x_3', 'zzs_0_x_4'],
				//附表一
				tableDataI: [],
				IHead: [
					'zzs_1_x_0',
					'zzs_1_x_1',
					'zzs_1_x_2',
					'zzs_1_x_3',
					'zzs_1_x_4',
					'zzs_1_x_5',
					'zzs_1_x_6',
					'zzs_1_x_7',
					'zzs_1_x_8',
					'zzs_1_x_9',
					'zzs_1_x_10',
					'zzs_1_x_11',
					'zzs_1_x_12',
					'zzs_1_x_13',
					'zzs_1_x_14'
				],
				//附表二
				tableDataII_I: [],
				tableDataII_II: [],
				tableDataII_III: [],
				tableDataII_IV: [],
				IIHead: ['zzs_2_x_1', 'zzs_2_x_2', 'zzs_2_x_3'],
				//附表三
				tableDataIII: [],
				IIIHead: ['zzs_3_x_1', 'zzs_3_x_2', 'zzs_3_x_3', 'zzs_3_x_4', 'zzs_3_x_5', 'zzs_3_x_6'],
				//附表四
				tableDataIV_I: [],
				tableDataIV_II: [],
				IVHead: ['zzs_4_x_1', 'zzs_4_x_2', 'zzs_4_x_3', 'zzs_4_x_4', 'zzs_4_x_5', 'zzs_4_x_6'],
				//附表五
				tableDataV_I: [],
				tableDataV_II: [],
				VHead: [
					'zzs_5_x_1',
					'zzs_5_x_2',
					'zzs_5_x_3',
					'zzs_5_x_4',
					'zzs_5_x_5',
					'zzs_5_x_6',
					'zzs_5_x_7',
					'zzs_5_x_8',
					'zzs_5_x_9',
					'zzs_5_x_10',
					'zzs_5_x_11',
					'zzs_5_x_12',
					'zzs_5_x_13',
					'zzs_5_x_14'
				],
				//增值税减免税申报明细表
				tableDataTax_I: [],
				tableDataTax_II: [],

				TaxHead: ['zzs_6_x_0', 'zzs_6_x_1', 'zzs_6_x_2', 'zzs_6_x_3', 'zzs_6_x_4', 'zzs_6_x_5'],
				//代扣代缴税收通用缴款书抵扣清单
				tableDatahold: [],
				holdHead: ['zzs_7_x_1', 'zzs_7_x_2', 'zzs_7_x_3', 'zzs_7_x_4', 'zzs_7_x_5', 'zzs_7_x_6'],
				choosecellCode: '',
				smtext: '',
				zcdata: [],
				choosetable: '',
				chooseindex: '',
				choosecolum: '',
				counttest: 0,
				delCells: [],
				errdiag: false,
				errarr: [],
				tableDataSummary_I: [], //汇总表
				tableDataSummary_II: [], //汇总表（拆成了两张表）
				SummaryHead: [
					'zzs_8_x_1',
					'zzs_8_x_2',
					'zzs_8_x_3',
					'zzs_8_x_4',
					'zzs_8_x_5',
					'zzs_8_x_6',
					'zzs_8_x_7',
					'zzs_8_x_8',
					'zzs_8_x_9',
					'zzs_8_x_10',
					'zzs_8_x_11',
					'zzs_8_x_12',
					'zzs_8_x_13',
					'zzs_8_x_14'
				], //汇总表
				SummaryHeadII: ['zzs_8_x_1', 'zzs_8_x_2', 'zzs_8_x_3'],
				tableDataOTDC_I: [], //扣税凭证明细表
				OTDCHead: ['zzs_9_x_1', 'zzs_9_x_2', 'zzs_9_x_3'], //扣税凭证明细表
				ruleNum: '',
				Hollysys_Beijing_Code: ['zzs_2_10_1', 'zzs_2_10_2', 'zzs_2_10_3', 'zzs_2_8b_1', 'zzs_2_8b_2',
					'zzs_2_8b_3', 'zzs_2_7_3'
				],
				Hollysys_shandon_Code: ['zzs_2_7_3'],
				Hollysys_HangZhou_Code: ['zzs_0_35_3'],
        jiaJDkBl: "",
        exportBusinessSituationDiag: false,
        exportBusinessSituationKey: 0,
        baohckyw: "",
        chukywsmtc: ""
			};
		},
		methods: {
			//政策点击预览
			zcsclick(id) {
				this.$refs.boxref.zcsclick(id);
			},
			//选中格子
			forhover(table, colum, index) {
				this.$refs.boxref.forhover(table, colum, index);
			},
			//获取选中格子
			getchoosecellCode(table, colum, index) {
				if (this.$emptyandnull(table)) {
					this.choosecellCode = '';
					return false;
				}
				this.choosetable = table;
				this.chooseindex = index;
				this.choosecolum = colum;
				this.choosecellCode = this[table][index][colum].cellCode;
				if (this.toseeUpdate) {
					this.smtext = this[table][index][colum]['map'] ? this[table][index][colum]['map']['desc'] : '';
					this.zcdata = this[table][index][colum]['map'] ? this[table][index][colum]['map']['zcs'] : [];
				} else {
					this.smtext = this[table][index][colum]['updateDesc'] || '';
				}
			},
			//更正说明
			forgengzheng(table, colum, index, smtext) {
				this[table][index][colum]['updateDesc'] = smtext;
			},
			//更正政策和说明
			forxzsm(table, colum, index, smtext, zcdata) {
				this[table][index][colum]['map'] = {
					desc: '',
					zcs: []
				};
				this[table][index][colum]['map']['desc'] = smtext;
				this[table][index][colum]['map']['zcs'] = zcdata;
			},
			//点击全部范围
			refreshhover() {
				this.$nextTick(() => {
					this.$refs.boxref.refreshhover();
				});
			},
			getShuibDetailList() {
				getShuibDetailList({
					shuizId: this.params.shuizId,
					id: this.params.shuibId
				}).then((res) => {
					if (res.data.code == 1) {
						this.treedata = res.data.data;
						if (this.treedata[0]) {
							this.getchoosetitleindex(this.treedata[0]);
						}
						this.querycell();
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			getReportAdditionalInfo() {
				getReportAdditionalInfo({
					id: this.params.id
				}).then((res) => {
					this.ruleNum = res.data.data.rule.ruleNum;
				});
			},
			manuscriptqueryReportStep() {
				manuscriptqueryReportStep({
					id: this.params.id,
					sbbm: this.params.sbbm
				}).then((res) => {
					if (res.data.code == 1) {
						this.statedata = res.data.data.statusHistory;
						this.treedata = res.data.data.detail;
						if (this.treedata[0]) {
							this.getchoosetitleindex(this.treedata[0]);
						}
						this.querycell();
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			getchoosetitleindex(item) {
				this.choosetitleindex = item.shuibNameCode;
			},
			//表格隐藏显示和返回
			forback() {
				if (this.Changed > 0) {
					this.$showConfirm({
						message: '是否不保存当前修改?',
						title: '您还未保存'
					}).then((res) => {
						if (res == 'confirm') {
							this.$emit('forback', true);
						} else {
							//取消
						}
					});
				} else {
					this.$emit('forback', true);
				}
			},
			changestate(e) {
				this.treestate = e;
			},
			elinput(e) {
				this.headobj = e;
			},
			//传给后端值处理
			filternums(data, filterlist) {
				var newlist = [];
				filterlist.forEach((ytem) => {
					let newval = data.map((item) => {
						if (
							item[ytem] != undefined &&
							item[ytem] != 'undefined' &&
							this.$notemptyandnull(item[ytem]) &&
							item[ytem].cellVal != null
						) {
							return item[ytem];
						} else {
							return 'x';
						}
					});
					newlist = [...newlist, ...newval].filter((gtem) => gtem != 'x');
				});
				return newlist;
			},
			//本栏开始替换
			//重置主表
			refreshtableDataZero() {
				this.tableDataZero.forEach((item, index) => {
					this.ZeroHead.forEach((gtem) => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});
			},
			//重置附表一
			refreshtableDataI() {
				this.tableDataI.forEach((item, index) => {
					this.IHead.forEach((gtem) => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});
			},
			//重置附表二
			refreshtableDataII() {
				this.tableDataII_I.forEach((item, index) => {
					this.IIHead.forEach((gtem) => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});
				this.tableDataII_II.forEach((item, index) => {
					this.IIHead.forEach((gtem) => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});
				this.tableDataII_III.forEach((item, index) => {
					this.IIHead.forEach((gtem) => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});
				this.tableDataII_IV.forEach((item, index) => {
					this.IIHead.forEach((gtem) => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});
			},
			//重置附表三
			refreshtableDataIII() {
				this.tableDataIII.forEach((item, index) => {
					this.IIIHead.forEach((gtem) => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});
			},
			//重置附表四
			refreshtableDataIV() {
				this.tableDataIV_I.forEach((item, index) => {
					this.IVHead.forEach((gtem) => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});
				this.tableDataIV_II.forEach((item, index) => {
					this.IVHead.forEach((gtem) => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});
			},
			//重置附表五
			refreshtableDataV() {
				this.tableDataV_I.forEach((item, index) => {
					this.VHead.forEach((gtem) => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});
				this.tableDataV_II.forEach((item, index) => {
					this.VHead.forEach((gtem) => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});
			},
			//重置增值税
			refreshtableDataTax() {
				this.tableDataTax_I.forEach((item, index) => {
					this.TaxHead.forEach((gtem) => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});
				this.tableDataTax_II.forEach((item, index) => {
					this.TaxHead.forEach((gtem) => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});
			},
			refreshtableDatahold() {
				this.tableDatahold.forEach((item, index) => {
					this.holdHead.forEach((gtem) => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});
			},
			refreshttableDataSummary() {
				this.tableDataSummary_I.forEach((item, index) => {
					this.SummaryHead.forEach((gtem) => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});
				this.tableDataSummary_II.forEach((item, index) => {
					this.SummaryHead.forEach((gtem) => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});
			},
			refreshtgetdataOTDC() {
				this.tableDataOTDC_I.forEach((item, index) => {
					this.OTDCHead.forEach((gtem) => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});
			},
			//清空相关
			commanddcrefresh(e) {
				this.Changed++;
				if (e == 'now') {
					if (this.choosetitleindex == 'zzs_0') {
						this.refreshtableDataZero();
					}
					if (this.choosetitleindex == 'zzs_1') {
						this.refreshtableDataI();
					}
					if (this.choosetitleindex == 'zzs_2') {
						this.refreshtableDataII();
					}
					if (this.choosetitleindex == 'zzs_3') {
						this.refreshtableDataIII();
					}
					if (this.choosetitleindex == 'zzs_4') {
						this.refreshtableDataIV();
					}
					if (this.choosetitleindex == 'zzs_5') {
						this.refreshtableDataV();
					}
					if (this.choosetitleindex == 'zzs_6') {
						this.refreshtableDataTax();
					}
					if (this.choosetitleindex == 'zzs_7') {
						this.refreshtableDatahold();
					}
					if (this.choosetitleindex == 'zzs_8') {
						this.refreshttableDataSummary();
					}
					if (this.choosetitleindex == 'zzs_9') {
						this.refreshtgetdataOTDC();
					}
				}
				if (e == 'all') {
					Object.keys(this.headobj).map((key) => (this.headobj[key] = ''));
					this.refreshtableDataZero();
					this.refreshtableDataI();
					this.refreshtableDataII();
					this.refreshtableDataIII();
					this.refreshtableDataIV();
					this.refreshtableDataV();
					this.refreshtableDataTax();
					this.refreshtableDatahold();
					this.refreshtgetdataOTDC();
					this.refreshttableDataSummary();
				}
			},
			//所有表格渲染
			querycell(index) {
				//编辑格子查询

				if (this.type == 'update') {
					querycell({
						companyNo: this.params.companyNo, // 公司编号
						id: this.params.id, //报表id
						shuibId: this.params.shuibId, //税种id
						sbbm: this.params.sbbm
					}).then((res) => {
						let dataarr = res.data.data;
						this.gettable(dataarr);
					});
				}
				if (this.type == 'tosee') {
					if (this.seeNow) {
						querycell({
							companyNo: this.params.companyNo, // 公司编号
							id: this.params.id, //报表id
							shuibId: this.params.shuibId, //税种id
							sbbm: this.params.sbbm
						}).then((res) => {
							let dataarr = res.data.data;
							this.gettable(dataarr);
						});
						return false;
					}
					if (this.toseeUpdate) {
						querytemplatecell({
							shuibId: this.params.shuibId,
							id: this.params.id
						}).then((res) => {
							let dataarr = res.data.data;
							this.gettable(dataarr);
						});
					} else {
						reportquerytrack({
							companyNo: this.params.companyNo, // 公司编号
							id: this.params.id, //报表id
							shuibId: this.params.shuibId, //税种id
							sbbm: this.params.sbbm,
							trackId: this.params.trackId
						}).then((res) => {
							let dataarr = res.data.data;
							this.gettable(dataarr);
						});
					}
				}
        if (this.baohckyw === "1" && this.chukywsmtc === "1" && index === "forShengcdg" && this.jiaJDkBl && this.gettableval('zzs_4_6_2', 'tableDataIV_II') !== 0) {
          // 一键生成底稿成功时 通过附表4 zzs_4_6_2 是否有值判断是否需要自动弹出出口业务情况
          this.exportBusinessSituation();
        }
			},
			gettable(dataarr) {
				this.delCells = [];
				this.headobj = dataarr.head;
				if (this.headobj.dialsb == null || this.headobj.dialsb == 0 || this.headobj.dialsb == '') {
					this.headobj.dialsb = 'N';
				}
				if (this.headobj.shenfzlx == null || this.headobj.shenfzlx == 0 || this.headobj.shenfzlx == '') {
					this.headobj.shenfzlx = '居民身份证';
					this.headobj.shenfzlxbh = '201';
				}
				// this.tableDataSummary_I = getdataSummary().getdataI 	//汇总表
				// this.tableDataSummary_II = getdataSummary().getdataII	//汇总表
				//主表
				if (this.$notemptyandnull(dataarr.zzs_0)) {
					var newtabledataZero = dataarr.zzs_0;
					var realtableDataZero = getdataval().tableData;
					realtableDataZero.forEach((item, index) => {
						if (newtabledataZero[index]) {
							this.ZeroHead.forEach((gtem) => {
								item[gtem] = newtabledataZero[index][gtem];
							});
						}
					});
					this.tableDataZero = realtableDataZero;
				}
				if (this.$notemptyandnull(dataarr.zzs_1)) {
					//附表一
					var newtabledataI = dataarr.zzs_1;
					var realtableDataI = getdataI().tableData;
					realtableDataI.forEach((item, index) => {
						if (newtabledataI[index]) {
							this.IHead.forEach((gtem) => {
								item[gtem] = newtabledataI[index][gtem];
							});
						}
					});
					this.tableDataI = realtableDataI;
					this.tableDataI.forEach((item) => {
						if (item.zzs_1_x_0 && item.zzs_1_x_0.cellVal != '- -') {
							item.zzs_1_x_0.cellVal = item.zzs_1_x_0.cellVal == '' ? 0 : this.$numMulti(item
								.zzs_1_x_0.cellVal, 100);
						}
					});
				}
				if (this.$notemptyandnull(dataarr.zzs_2)) {
					//附表二
					var newtabledataII = dataarr.zzs_2;
					var newtabledataII_I = newtabledataII.filter((item, index) => index < 13);
					var realtableDataII_I = getdataII().tableDataI;
					realtableDataII_I.forEach((item, index) => {
						if (newtabledataII_I[index]) {
							this.IIHead.forEach((gtem) => {
								item[gtem] = newtabledataII_I[index][gtem];
							});
						}
					});

					this.tableDataII_I = realtableDataII_I;
					var newtabledataII_II = newtabledataII.filter((item, index) => (index > 12) & (index < 25));
					var realtableDataII_II = getdataII().tableDataII;
					realtableDataII_II.forEach((item, index) => {
						if (newtabledataII_II[index]) {
							item.zzs_2_x_3 = newtabledataII_II[index].zzs_2_x_1;
						}
					});
					this.tableDataII_II = realtableDataII_II;
					var newtabledataII_III = newtabledataII.filter((item, index) => (index > 24) & (index < 36));
					var realtableDataII_III = getdataII().tableDataIII;
					realtableDataII_III.forEach((item, index) => {
						if (newtabledataII_III[index]) {
							this.IIHead.forEach((gtem) => {
								item[gtem] = newtabledataII_III[index][gtem];
							});
						}
					});
					this.tableDataII_III = realtableDataII_III;
					var newtabledataII_IV = newtabledataII.filter((item, index) => index > 35);
					var realtableDataII_IV = getdataII().tableDataIV;
					realtableDataII_IV.forEach((item, index) => {
						if (newtabledataII_IV[index]) {
							this.IIHead.forEach((gtem) => {
								item[gtem] = newtabledataII_IV[index][gtem];
							});
						}
					});
					this.tableDataII_IV = realtableDataII_IV;
				}
				if (this.$notemptyandnull(dataarr.zzs_3)) {
					//附表三
					var newtabledataIII = dataarr.zzs_3;
					var realtableDataIII = getdataIII().tableData;
					realtableDataIII.forEach((item, index) => {
						if (newtabledataIII[index]) {
							this.IIIHead.forEach((gtem) => {
								item[gtem] = newtabledataIII[index][gtem];
							});
						}
					});
					this.tableDataIII = realtableDataIII;
				}
				if (this.$notemptyandnull(dataarr.zzs_4)) {
					//附表四
					var newtabledataIV = dataarr.zzs_4;
					var newtabledataIV_I = newtabledataIV.filter((item, index) => index < 5);
					var realtableDataIV_I = getdataIV().tableDataI;
					realtableDataIV_I.forEach((item, index) => {
						if (newtabledataIV_I[index]) {
							this.IVHead.forEach((gtem) => {
								item[gtem] = newtabledataIV_I[index][gtem];
							});
						}
					});
					this.tableDataIV_I = realtableDataIV_I;
					var newtabledataIV_II = newtabledataIV.filter((item, index) => index > 4);
					var realtableDataIV_II = getdataIV().tableDataII;
					realtableDataIV_II.forEach((item, index) => {
						if (newtabledataIV_II[index]) {
							this.IVHead.forEach((gtem) => {
								item[gtem] = newtabledataIV_II[index][gtem];
							});
						}
					});
					this.tableDataIV_II = realtableDataIV_II;
				}
				if (this.$notemptyandnull(dataarr.zzs_5)) {
					//附表五
					var newtabledataV = dataarr.zzs_5;
					var newtabledataV_I = newtabledataV.filter((item, index) => index < 4);
					var realtableDataV_I = getdataV().tableDataI;
					realtableDataV_I.forEach((item, index) => {
						if (newtabledataV_I[index]) {
							this.VHead.forEach((gtem) => {
								item[gtem] = newtabledataV_I[index][gtem];
							});
						}
					});
					realtableDataV_I.forEach((item) => {
						if (item.zzs_5_x_5 && item.zzs_5_x_5.cellVal != '- -' && !this.toseeUpdate) {
							item.zzs_5_x_5.cellVal = item.zzs_5_x_5.cellVal == '' ? `${0}` :
								`${this.$numMulti(item.zzs_5_x_5.cellVal, 100)}`;
						}
						if (item.zzs_5_x_9 && item.zzs_5_x_9.cellVal != '- -' && !this.toseeUpdate) {
							item.zzs_5_x_9.cellVal = item.zzs_5_x_9.cellVal == '' ? `${0}` :
								`${this.$numMulti(item.zzs_5_x_9.cellVal, 100)}`;
						}
					});
					this.tableDataV_I = realtableDataV_I;
					var newtabledataV_II = newtabledataV.filter((item, index) => index > 3);
					var realtableDataV_II = getdataV().tableDataII;
					realtableDataV_II.forEach((item, index) => {
						if (newtabledataV_II[index]) {
							this.VHead.forEach((gtem) => {
								if (index == 0) {
									item['zzs_5_x_2'] = newtabledataV_II[index]['zzs_5_x_2'];
								}
								item['zzs_5_x_1'] = newtabledataV_II[index]['zzs_5_x_1'];
							});
						}
					});
					this.tableDataV_II = realtableDataV_II;
				}
				// this.tableDataV_III = getdataV().tableDataIII  附表五其他扣税凭证明细表表间关系
				//增值税减免税申报明细表
				if (this.$notemptyandnull(dataarr.zzs_6)) {
					var newtabledataTax = dataarr.zzs_6;
					var newtabledataTax_I = newtabledataTax.filter((item, index) => index < 6);
					var realtableDataTax_I = getdatatax().tableDataI;
					realtableDataTax_I.forEach((item, index) => {
						if (newtabledataTax_I[index]) {
							this.TaxHead.forEach((gtem) => {
								item[gtem] = newtabledataTax_I[index][gtem] || '';
							});
						}
					});
					this.tableDataTax_I = realtableDataTax_I;
					var newtabledataTax_II = newtabledataTax.filter((item, index) => index > 5);
					var realtableDataTax_II = getdatatax().tableDataII;
					realtableDataTax_II.forEach((item, index) => {
						if (newtabledataTax_II[index]) {
							this.TaxHead.forEach((gtem) => {
								item[gtem] = newtabledataTax_II[index][gtem] || '';
							});
						}
					});
					this.tableDataTax_II = realtableDataTax_II;
				}
				if (this.$notemptyandnull(dataarr.zzs_7)) {
					//代扣代缴
					var newtabledatahold = dataarr.zzs_7;
					var realtableDatahold = newtabledatahold;
					realtableDatahold.forEach((item, index) => {
						if (newtabledatahold[index]) {
							this.holdHead.forEach((gtem) => {
								if (index == realtableDatahold.length - 1) {
									item.zzs_7_x_6 = newtabledatahold[index].zzs_7_x_0;
									item.zzs_7_x_1 = {
										cellCode: 'zzs_7_1000_1',
										cellType: '0',
										cellVal: '- -',
										updateDesc: '',
										map: {}
									};
									item.zzs_7_x_2 = {
										cellCode: 'zzs_7_1000_2',
										cellType: '0',
										cellVal: '- -',
										updateDesc: '',
										map: {}
									};
									item.zzs_7_x_3 = {
										cellCode: 'zzs_7_1000_3',
										cellType: '0',
										cellVal: '- -',
										updateDesc: '',
										map: {}
									};
									item.zzs_7_x_4 = {
										cellCode: 'zzs_7_1000_4',
										cellType: '0',
										cellVal: '- -',
										updateDesc: '',
										map: {}
									};
									item.zzs_7_x_5 = {
										cellCode: 'zzs_7_1000_5',
										cellType: '0',
										cellVal: '- -',
										updateDesc: '',
										map: {}
									};
								} else {
									item[gtem] = newtabledatahold[index][gtem];
								}
							});
						}
					});
					this.tableDatahold = realtableDatahold;
				}
				// //汇总
				if (dataarr.zzs_8) {
					var newtableDataSummary_I = dataarr.zzs_8;
					var reatableDataSummary_I = getdataSummary().tableDataI;
					reatableDataSummary_I.forEach((item, index) => {
						this.SummaryHeadII.forEach((gtem, value) => {
							if (index * 3 + value + 1 != 11 && index * 3 + value + 1 != 12) {
								if (index * 3 + value + 1 < 12) {
									item[gtem] = newtableDataSummary_I[0][
										`zzs_8_x_${index * 3 + value + 1}`
									] || '';
								} else {
									item[gtem] = newtableDataSummary_I[0][
										`zzs_8_x_${index * 3 + value - 1}`
									] || '';
								}
							} else {
								item[gtem] = {
									cellCode: 'zzs_8_xx_1',
									cellType: '0'
								};
							}
						});
					});
					this.tableDataSummary_I = reatableDataSummary_I;

					var newtableDataSummary_II = newtableDataSummary_I.filter((item, index) => index > 0);
					var reatableDataSummary_II = newtableDataSummary_II;
					reatableDataSummary_II.forEach((item, index) => {
						this.SummaryHead.forEach((gtem) => {
							item[gtem] = newtableDataSummary_II[index][gtem] || '';
						});
					});
					this.tableDataSummary_II = reatableDataSummary_II;
				}

				// this.refreshcodeval()
				// 税控凭证表
				if (this.$notemptyandnull(dataarr.zzs_9)) {
					var newtabledataOTDC_I = dataarr.zzs_9;
					var realtableDataOTDC_I = getdataOTDC().tableDataI;
					realtableDataOTDC_I.forEach((item, index) => {
						if (newtabledataOTDC_I[index]) {
							this.OTDCHead.forEach((gtem) => {
								item[gtem] = newtabledataOTDC_I[index][gtem] || '';
							});
						}
					});
					this.tableDataOTDC_I = realtableDataOTDC_I;
				}
				// // this.refreshcodeval()
			},

			delCellsCode(e) {
				this.delCells = [...this.filternums(e, this.holdHead)];
			},
			checkerror() {
				let arr = [];
				let treeCode = this.treedata.map((item) => item.shuibNameCode);
				// if ((this.gettableval("zzs_0_12_1", 'tableDataZero') + this.gettableval("zzs_0_12_3",
				// 		'tableDataZero')) != this.gettableval("zzs_2_12_3", 'tableDataII_I')) {
				// 	arr.push("主表第12栏次第1列 应满足条件:主表第12栏次第1列+主表第12栏次第3列=附表二第12栏次第3列")
				// 	arr.push("主表第12栏次第3列 应满足条件:主表第12栏次第1列+主表第12栏次第3列=附表二第12栏次第3列")
				// }
				if (treeCode.includes('zzs_0')) {
					if (
						this.gettableval('zzs_0_16_1', 'tableDataZero') >
						this.gettableval('zzs_1_1_8', 'tableDataI') +
						this.gettableval('zzs_1_2_8', 'tableDataI') +
						this.gettableval('zzs_1_3_8', 'tableDataI') +
						this.gettableval('zzs_1_4_8', 'tableDataI') +
						this.gettableval('zzs_1_5_8', 'tableDataI') +
						this.gettableval('zzs_2_19_1', 'tableDataII_II')
					) {
						arr.push(
							'主表第16栏次第1列 不满足<=附表一第1栏次第8列+附表一第2栏次第8列+附表一第3栏次第8列+附表一第4栏次第8列+附表一第5栏次第8列+附表二第19栏次第1列'
						);
					}
					if (
						this.gettableval('zzs_2_13_1', 'tableDataII_II') - this.gettableval('zzs_0_14_3',
							'tableDataZero') !=
						this.gettableval('zzs_0_14_1', 'tableDataZero')
					) {
						arr.push('主表第14栏次第1列 应满足条件:主表第14栏次第1列+主表第14栏次第3列=附表二第13栏次第1列');
						arr.push('主表第14栏次第3列 应满足条件:主表第14栏次第1列+主表第14栏次第3列=附表二第13栏次第1列');
					}
					if (
						this.gettableval('zzs_0_5_1', 'tableDataZero') <
						this.gettableval('zzs_1_8_9', 'tableDataI') +
						this.gettableval('zzs_1_9a_9', 'tableDataI') +
						this.gettableval('zzs_1_9b_9', 'tableDataI') +
						this.gettableval('zzs_1_10_9', 'tableDataI') +
						this.gettableval('zzs_1_11_9', 'tableDataI') +
						this.gettableval('zzs_1_12_9', 'tableDataI') +
						this.gettableval('zzs_1_13a_9', 'tableDataI') +
						this.gettableval('zzs_1_13b_9', 'tableDataI') +
						this.gettableval('zzs_1_13c_9', 'tableDataI') -
						this.gettableval('zzs_1_14_9', 'tableDataI') -
						this.gettableval('zzs_1_15_9', 'tableDataI')
					) {
						arr.push(
							'主表第5栏次第1列 应满足>=（附表一第8栏次第9列+附表一第9a栏次第9列+附表一第9b栏次第9列+附表一第10栏次第9列+附表一第11栏次第9列+附表一第12栏次第9列+附表一第13a栏次第9列+附表一第13b栏次第9列+附表一第13c栏次第9列）-(附表一第14栏次第9列+附表一第15栏次第9列)'
						);
					}
					if (
						this.gettableval('zzs_0_5_3', 'tableDataZero') <
						this.gettableval('zzs_1_14_9', 'tableDataI') + this.gettableval('zzs_1_15_9', 'tableDataI')
					) {
						arr.push('主表第5栏次第3列 不满足>=附表一第14栏次第9列+附表一第15栏次第9列');
					}
				}
				if (treeCode.includes('zzs_2')) {
					if (this.gettableval('zzs_2_9_2', 'tableDataII_I') < 0) {
						arr.push('附表二第9栏次第2列 不满足>=0');
					}
					if (
						this.gettableval('zzs_2_9_3', 'tableDataII_I') + this.gettableval('zzs_2_10_3', 'tableDataII_I') >
						this.gettableval('zzs_2_1_3', 'tableDataII_I') + this.gettableval('zzs_2_4_3', 'tableDataII_I') ||
						this.gettableval('zzs_2_9_3', 'tableDataII_I') < 0
					) {
						arr.push(
							'附表二第9栏次第3列 不满足>=0;且满足附表二第9栏次第3列+附表二第10栏次第3列<=附表二第1栏次第3列+附表二第4栏次第3列'
						);
					}
					if (this.gettableval('zzs_2_10_2', 'tableDataII_I') < 0) {
						arr.push('附表二第10栏次第2列 不满足>=0');
					}
					if (this.gettableval('zzs_2_10_3', 'tableDataII_I') < 0) {
						arr.push(
							'附表二第10栏次第3列 不满足>=0;满足附表二第9栏次第3列+附表二第10栏次第3列<=附表二第1栏次第3列+附表二第4栏次第3列'
						);
					}
				}
				if (treeCode.includes('zzs_3')) {
					if (
						this.gettableval('zzs_3_3_1', 'tableDataIII') + this.gettableval('zzs_3_4_1', 'tableDataIII') !=
						this.gettableval('zzs_1_5_11', 'tableDataI')
					) {
						arr.push('附表三第3栏次第1列 应满足条件:附表三第3栏次第1列+附表三第4栏次第1列=附表一第5栏次第11列');
						arr.push('附表三第4栏次第1列 应满足条件:附表三第3栏次第1列+附表三第4栏次第1列=附表一第5栏次第11列');
					}
					if (
						(this.gettableval('zzs_3_1_5', 'tableDataIII') > this.gettableval('zzs_3_1_1', 'tableDataIII') ||
							this.gettableval('zzs_3_1_5', 'tableDataIII') > this.gettableval('zzs_3_1_4', 'tableDataIII')
						) && this.gettableval('zzs_3_1_1', 'tableDataIII') >= 0
					) {
						arr.push('附表三第1栏次第5列 应满足条件:<=附表三第1栏次第1列且<=附表三第1栏次第4列');
					}
					if (
						(this.gettableval('zzs_3_2_5', 'tableDataIII') > this.gettableval('zzs_3_2_1', 'tableDataIII') ||
							this.gettableval('zzs_3_2_5', 'tableDataIII') > this.gettableval('zzs_3_2_4', 'tableDataIII')
						) && this.gettableval('zzs_3_2_1', 'tableDataIII') >= 0
					) {
						arr.push('附表三第2栏次第5列 应满足条件:<=附表三第2栏次第1列且<=附表三第2栏次第4列');
					}
					if (
						(this.gettableval('zzs_3_3_5', 'tableDataIII') > this.gettableval('zzs_3_3_1', 'tableDataIII') ||
							this.gettableval('zzs_3_3_5', 'tableDataIII') > this.gettableval('zzs_3_3_4', 'tableDataIII')
						) && this.gettableval('zzs_3_3_1', 'tableDataIII') >= 0
					) {
						arr.push('附表三第3栏次第5列 应满足条件:<=附表三第3栏次第1列且<=附表三第3栏次第4列');
					}
					if (
						(this.gettableval('zzs_3_4_5', 'tableDataIII') > this.gettableval('zzs_3_4_1', 'tableDataIII') ||
							this.gettableval('zzs_3_4_5', 'tableDataIII') > this.gettableval('zzs_3_4_4', 'tableDataIII')
						) && this.gettableval('zzs_3_4_1', 'tableDataIII') >= 0
					) {
						arr.push('附表三第4栏次第5列 应满足条件:<=附表三第4栏次第1列且<=附表三第4栏次第4列');
					}
					if (
						(this.gettableval('zzs_3_5_5', 'tableDataIII') > this.gettableval('zzs_3_5_1', 'tableDataIII') ||
							this.gettableval('zzs_3_5_5', 'tableDataIII') > this.gettableval('zzs_3_5_4', 'tableDataIII')
						) && this.gettableval('zzs_3_5_1', 'tableDataIII') >= 0
					) {
						arr.push('附表三第5栏次第5列 应满足条件:<=附表三第5栏次第1列且<=附表三第5栏次第4列');
					}
					if (
						(this.gettableval('zzs_3_6_5', 'tableDataIII') > this.gettableval('zzs_3_6_1', 'tableDataIII') ||
							this.gettableval('zzs_3_6_5', 'tableDataIII') > this.gettableval('zzs_3_6_4', 'tableDataIII')
						) && this.gettableval('zzs_3_6_1', 'tableDataIII') >= 0
					) {
						arr.push('附表三第6栏次第5列 应满足条件:<=附表三第6栏次第1列且<=附表三第6栏次第4列');
					}

					if (
						(this.gettableval('zzs_3_7_5', 'tableDataIII') > this.gettableval('zzs_3_7_1', 'tableDataIII') ||
							this.gettableval('zzs_3_7_5', 'tableDataIII') > this.gettableval('zzs_3_7_4', 'tableDataIII')
						) && this.gettableval('zzs_3_7_1', 'tableDataIII') >= 0
					) {
						arr.push('附表三第7栏次第5列 应满足条件:<=附表三第7栏次第1列且<=附表三第7栏次第4列');
					}
					if (
						(this.gettableval('zzs_3_8_5', 'tableDataIII') > this.gettableval('zzs_3_8_1', 'tableDataIII') ||
							this.gettableval('zzs_3_8_5', 'tableDataIII') > this.gettableval('zzs_3_8_4', 'tableDataIII')
						) && this.gettableval('zzs_3_8_1', 'tableDataIII') >= 0
					) {
						arr.push('附表三第8栏次第5列 应满足条件:<=附表三第8栏次第1列且<=附表三第8栏次第4列');
					}
				}
				if (treeCode.includes('zzs_4')) {
					if (this.gettableval('zzs_4_1_4', 'tableDataIV_I') > this.gettableval('zzs_4_1_3', 'tableDataIV_I')) {
						arr.push('附表四第1栏次第4列 不满足<=附表四第1栏次第3列');
					}
					if ((this.gettableval('zzs_4_1_4', 'tableDataIV_I') < this.gettableval('zzs_4_1_3',
							'tableDataIV_I')) && this.gettableval('zzs_4_1_5', 'tableDataIV_I') == 0) {
						arr.push('附表四第1栏次第5列值不能为：0');
					}
					if (this.gettableval('zzs_4_2_4', 'tableDataIV_I') > this.gettableval('zzs_4_2_3', 'tableDataIV_I')) {
						arr.push('附表四第2栏次第4列 不满足<=附表四第2栏次第3列');
					}
					if ((this.gettableval('zzs_4_2_4', 'tableDataIV_I') < this.gettableval('zzs_4_2_3',
							'tableDataIV_I')) && this.gettableval('zzs_4_2_5', 'tableDataIV_I') == 0) {
						arr.push('附表四第2栏次第5列值不能为：0');
					}
					// if (this.gettableval('zzs_4_3_4', 'tableDataIV_I') > this.gettableval('zzs_4_3_3', 'tableDataIV_I')) {
					// 	arr.push('附表四第3栏次第4列 不满足<=附表四第3栏次第3列');
					// }
					if ((this.gettableval('zzs_4_3_4', 'tableDataIV_I') < this.gettableval('zzs_4_3_3',
							'tableDataIV_I')) && this.gettableval('zzs_4_3_5', 'tableDataIV_I') == 0) {
						arr.push('附表四第3栏次第5列值不能为：0');
					}
					if (this.gettableval('zzs_4_4_4', 'tableDataIV_I') > this.gettableval('zzs_4_4_3', 'tableDataIV_I')) {
						arr.push('附表四第4栏次第4列 不满足<=附表四第4栏次第3列');
					}
					if ((this.gettableval('zzs_4_4_4', 'tableDataIV_I') < this.gettableval('zzs_4_4_3',
							'tableDataIV_I')) && this.gettableval('zzs_4_4_5', 'tableDataIV_I') == 0) {
						arr.push('附表四第4栏次第5列值不能为：0');
					}
					if (this.gettableval('zzs_4_5_4', 'tableDataIV_I') > this.gettableval('zzs_4_5_3', 'tableDataIV_I')) {
						arr.push('附表四第5栏次第4列 不满足<=附表四第5栏次第3列');
					}
					if ((this.gettableval('zzs_4_5_4', 'tableDataIV_I') < this.gettableval('zzs_4_5_3',
							'tableDataIV_I')) && this.gettableval('zzs_4_5_5', 'tableDataIV_I') == 0) {
						arr.push('附表四第5栏次第5列值不能为：0');
					}
				}
				if (treeCode.includes('zzs_6')) {
					if (this.gettableval('zzs_6_2_3', 'tableDataTax_I') < this.gettableval('zzs_6_2_4',
							'tableDataTax_I')) {
						arr.push('附表六第2栏次第4列 不满足<=附表六第2栏次第3列');
					}
					if (this.gettableval('zzs_6_3_4', 'tableDataTax_I') > this.gettableval('zzs_6_3_3',
							'tableDataTax_I')) {
						arr.push('附表六第3栏次第4列 不满足<=附表六第3栏次第3列');
					}
					if (this.gettableval('zzs_6_4_4', 'tableDataTax_I') > this.gettableval('zzs_6_4_3',
							'tableDataTax_I')) {
						arr.push('附表六第4栏次第4列 不满足<=附表六第4栏次第3列');
					}
					if (this.gettableval('zzs_6_5_4', 'tableDataTax_I') > this.gettableval('zzs_6_5_3',
							'tableDataTax_I')) {
						arr.push('附表六第5栏次第4列 不满足<=附表六第5栏次第3列');
					}
					if (this.gettableval('zzs_6_6_4', 'tableDataTax_I') > this.gettableval('zzs_6_6_3',
							'tableDataTax_I')) {
						arr.push('附表六第6栏次第4列 不满足<=附表六第6栏次第3列');
					}
				}
				if (treeCode.includes('zzs_9')) {
					if (this.gettableval('zzs_9_2_2', 'tableDataOTDC_I') < 0) {
						arr.push('其他扣税凭证明细表第2栏次第2列 应满足条件:其他扣税凭证明细表第2栏次第2列>=0');
					}
					if (
						this.gettableval('zzs_9_2_3', 'tableDataOTDC_I') < 0 &&
						this.gettableval('zzs_2_9_3', 'tableDataII_I') + this.gettableval('zzs_2_10_3', 'tableDataII_I') >
						this.gettableval('zzs_2_1_3', 'tableDataII_I') + this.gettableval('zzs_2_4_3', 'tableDataII_I')
					) {
						arr.push(
							'其他扣税凭证明细表第2栏次第3列 应满足条件:其他扣税凭证明细表第2栏次第3列>=0 且需满足 附表二第9栏次第3列+附表二第10栏次第3列<=附表二第1栏次第3列+附表二第4栏次第3列'
						);
					}
				}
				if (arr.length > 0) {
					this.errarr = arr;
					this.errdiag = true;
					return false;
				} else {
					return true;
				}
			},
			refreshcodeval() {
				var newarrall = [
					...this.filternums(this.tableDataZero, this.ZeroHead),
					...this.filternums(this.tableDataI, this.IHead),
					...this.filternums(this.tableDataII_I, this.IIHead),
					...this.filternums(this.tableDataII_II, this.IIHead),
					...this.filternums(this.tableDataII_III, this.IIHead),
					...this.filternums(this.tableDataII_IV, this.IIHead),
					...this.filternums(this.tableDataIII, this.IIIHead),
					...this.filternums(this.tableDataIV_I, this.IVHead),
					...this.filternums(this.tableDataIV_II, this.IVHead),
					...this.filternums(this.tableDataV_I, this.VHead),
					...this.filternums(this.tableDataV_II, this.VHead),
					...this.filternums(this.tableDataTax_I, this.TaxHead),
					...this.filternums(this.tableDataTax_II, this.TaxHead),
					...this.filternums(this.tableDatahold, this.holdHead),
					...this.filternums(this.tableDataOTDC_I, this.OTDCHead)
				];
				newarrall.forEach((item) => {
					if (item.cellCode && isNaN(item.cellVal) && item.cellVal != '- -') {
						this.inputblur(item);
					}
				});
			},
			forsave() {
				let status = this.checkerror();
				var newarrall = [
					...this.filternums(this.tableDataZero, this.ZeroHead),
					...this.filternums(this.tableDataI, this.IHead),
					...this.filternums(this.tableDataII_I, this.IIHead),
					...this.filternums(this.tableDataII_II, this.IIHead),
					...this.filternums(this.tableDataII_III, this.IIHead),
					...this.filternums(this.tableDataII_IV, this.IIHead),
					...this.filternums(this.tableDataIII, this.IIIHead),
					...this.filternums(this.tableDataIV_I, this.IVHead),
					...this.filternums(this.tableDataIV_II, this.IVHead),
					...this.filternums(this.tableDataV_I, this.VHead),
					...this.filternums(this.tableDataV_II, this.VHead),
					...this.filternums(this.tableDataTax_I, this.TaxHead),
					...this.filternums(this.tableDataTax_II, this.TaxHead),
					...this.filternums(this.tableDatahold, this.holdHead),
					...this.filternums(this.tableDataOTDC_I, this.OTDCHead),
					...this.filternums(this.tableDataSummary_I, this.SummaryHeadII),
					...this.filternums(this.tableDataSummary_II, this.SummaryHead)
				];
				var newarr = JSON.parse(JSON.stringify(newarrall));
				newarr.forEach((item) => {
					if (
						item.cellCode && ['zzs_5_1_5', 'zzs_5_2_5', 'zzs_5_3_5', 'zzs_5_4_5', 'zzs_5_1_9',
							'zzs_5_2_9', 'zzs_5_3_9', 'zzs_5_4_9'
						].includes(
							item.cellCode
						) &&
						item.cellVal != '- -'
					) {
						item.cellVal = item.cellVal * (0.01).toFixed(2);
					}
					if (item.cellCode && ['zzs_1_13a_0', 'zzs_1_13b_0', 'zzs_1_13c_0'].includes(item.cellCode) &&
						item.cellVal != '- -') {
						item.cellVal = item.cellVal * (0.01).toFixed(2);
					}
				});
				let params = {
					cells: newarr,
					companyNo: this.params.companyNo,
					id: this.params.id,
					sbbm: this.params.sbbm,
					head: this.headobj,
					delCells: this.delCells,
					checkFlag: status
				};
				writesave(params).then((res) => {
					if (res.data.code == 1) {
						this.Changed = 0;
						this.querycell();
						this.$message.success(res.data.msg);
					} else {
						this.$message.error(res.data.msg);
					}
				});
        if (this.baohckyw === "1" && this.chukywsmtc === "1" && this.jiaJDkBl && this.gettableval('zzs_4_6_2', 'tableDataIV_II') !== 0) {
          queryCurrentPeriodExportBusinessSituation(
              {
                shuibId: this.params.shuibId,
                companyId: this.params.companyId,
                year: this.suosq.substring(0, 4),
                suosq: this.suosq
              }
          ).then((res) => {
            if (res.data.code === 1) {
              if (res.data.data === "1") {
                // 保存时：如果附报4对应格子存在值 但是对应出口业务没有记录 则自动弹框
                this.exportBusinessSituation();
              }
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
			},
			Hollysys_HangZhou(e) {
				this.changetableval(
					'zzs_0_35_3',
					'tableDataZero',
					this.gettableval('zzs_0_34_3', 'tableDataZero') - this.gettableval('zzs_0_1_3', 'tableDataZero') *
					0.03,
					false,
					'restart'
				);
			},
			Hollysys_Beijing(e) {
				if (e.cellCode == 'zzs_9_2_1') {
					this.changetableval('zzs_2_10_1', 'tableDataII_I', this.gettableval('zzs_9_2_1', 'tableDataOTDC_I'),
						false, 'restart');
				}
				if (e.cellCode == 'zzs_9_2_2') {
					this.changetableval('zzs_2_10_2', 'tableDataII_I', this.gettableval('zzs_9_2_2', 'tableDataOTDC_I'),
						false, 'restart');
				}
				if (e.cellCode == 'zzs_9_2_3') {
					this.changetableval('zzs_2_10_3', 'tableDataII_I', this.gettableval('zzs_9_2_3', 'tableDataOTDC_I'),
						false, 'restart');
				}
				if (e.cellCode == 'zzs_9_5_1') {
					this.changetableval('zzs_2_8b_1', 'tableDataII_I', this.gettableval('zzs_9_5_1', 'tableDataOTDC_I'),
						false, 'restart');
				}
				if (e.cellCode == 'zzs_9_5_2') {
					this.changetableval('zzs_2_8b_2', 'tableDataII_I', this.gettableval('zzs_9_5_2', 'tableDataOTDC_I'),
						false, 'restart');
				}
				if (e.cellCode == 'zzs_9_5_3') {
					this.changetableval('zzs_2_8b_3', 'tableDataII_I', this.gettableval('zzs_9_5_3', 'tableDataOTDC_I'),
						false, 'restart');
				}
				if (e.cellCode == 'zzs_7_1000_0') {
					this.changetableval('zzs_2_7_3', 'tableDataII_I', this.gettableval('zzs_7_1000_0', 'tableDatahold'),
						false, 'restart');
				}
				if (e.cellCode == 'zzs_1_18_9') {
					this.changetableval('zzs_0_9_1', 'tableDataZero', this.gettableval('zzs_1_18_9', 'tableDataI'), false,
						'restart');
				}
			},
			Hollysys_shandon(e) {
				if (e.cellCode == 'zzs_7_1000_0') {
					this.changetableval('zzs_2_7_3', 'tableDataII_I', this.gettableval('zzs_7_1000_0', 'tableDatahold'),
						false, 'restart');
				}
			},
			//主表关系
			inputblur(e) {
				console.log(123123)
				console.log(e)
				this.Changed++;
				if (
					e.cellCode == 'zzs_6_2_0' ||
					e.cellCode == 'zzs_6_3_0' ||
					e.cellCode == 'zzs_6_4_0' ||
					e.cellCode == 'zzs_6_5_0' ||
					e.cellCode == 'zzs_6_6_0' ||
					e.cellCode == 'zzs_6_10_0' ||
					e.cellCode == 'zzs_6_11_0' ||
					e.cellCode == 'zzs_6_12_0' ||
					e.cellCode == 'zzs_6_13_0' ||
					e.cellCode == 'zzs_6_14_0' ||
					e.cellCode == 'zzs_6_15_0' ||
					e.cellCode == 'zzs_6_16_0'
				) {
					this[this.choosetable][this.chooseindex][this.choosecolum]['cellType'] = '1';
				}
				if (this.ruleNum == 'Hollysys-Beijing') {
					this.Hollysys_Beijing(e);
				}
				if (this.ruleNum == 'Hollysys-shandon') {
					this.Hollysys_shandon(e);
				}
				if (this.ruleNum == 'Hollysys-HangZhou') {
					this.Hollysys_HangZhou(e);
				}
				this.counttest++;
				if (
					parseFloat(e.cellVal).toFixed(2) !=
					parseFloat(this[this.choosetable][this.chooseindex][this.choosecolum]['cellOldVal']).toFixed(2) &&
					this[this.choosetable][this.chooseindex][this.choosecolum]['cellCode'] == e.cellCode
				) {
					if (e.cellCode == "zzs_5_1_5" || e.cellCode == "zzs_5_2_5" || e.cellCode == "zzs_5_3_5") {
						if (this[this.choosetable][this.chooseindex][this.choosecolum]['cellOldVal'] != "") {
							if ((parseFloat(e.cellVal) * 0.01).toFixed(2) != parseFloat(this[this.choosetable][this.chooseindex][this.choosecolum]['cellOldVal']).toFixed(2)) {
								this[this.choosetable][this.chooseindex][this.choosecolum]['cellType'] = '1';
							}
						} else {
							if (e.cellVal != "0" && e.cellVal != "0.00") {
								this[this.choosetable][this.chooseindex][this.choosecolum]['cellType'] = '1';
							}
						}

					} else {
						this[this.choosetable][this.chooseindex][this.choosecolum]['cellType'] = '1';
					}
				}else{
					if (e.cellCode == "zzs_5_1_5" || e.cellCode == "zzs_5_2_5" || e.cellCode == "zzs_5_3_5") {
						if (this[this.choosetable][this.chooseindex][this.choosecolum]['cellOldVal'] != "") {
							if ((parseFloat(e.cellVal) * 0.01).toFixed(2) == parseFloat(this[this.choosetable][this.chooseindex][this.choosecolum]['cellOldVal']).toFixed(2)) {
								this[this.choosetable][this.chooseindex][this.choosecolum]['cellType'] = '0';
							}
						} else {
							if (e.cellVal == "0" || e.cellVal == "0.00") {
								this[this.choosetable][this.chooseindex][this.choosecolum]['cellType'] = '0';
							}
						}
					
					}
				}
				if (e.cellCode == 'zzs_0_1_1') {
					this.changetableval(
						'zzs_0_1_2',
						'tableDataZero',
						this.gettableval('zzs_0_1_2', 'tableDataZero', 'old') + this.gettableval('zzs_0_1_1',
							'tableDataZero'),
						'checkq'
					);
					this.changetableval('zzs_8_0_9', 'tableDataSummary_I', this.gettableval('zzs_0_1_1', 'tableDataZero'));
				}
				if (e.cellCode == 'zzs_0_1_3') {
					this.changetableval(
						'zzs_0_1_4',
						'tableDataZero',
						this.gettableval('zzs_0_1_4', 'tableDataZero', 'old') + this.gettableval('zzs_0_1_3',
							'tableDataZero'),
						'checkq'
					);
					this.changetableval(
						'zzs_0_2_3',
						'tableDataZero',
						this.gettableval('zzs_0_1_3', 'tableDataZero') -
						this.gettableval('zzs_0_3_3', 'tableDataZero') -
						this.gettableval('zzs_0_4_3', 'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_0_2_1') {
					this.changetableval(
						'zzs_0_2_2',
						'tableDataZero',
						this.gettableval('zzs_0_2_2', 'tableDataZero', 'old') + this.gettableval('zzs_0_2_1',
							'tableDataZero'),
						'checkq'
					);
				}
				if (e.cellCode == 'zzs_0_2_3') {
					this.changetableval(
						'zzs_0_2_4',
						'tableDataZero',
						this.gettableval('zzs_0_2_4', 'tableDataZero', 'old') + this.gettableval('zzs_0_2_3',
							'tableDataZero'),
						'checkq'
					);

					this.changetableval(
						'zzs_0_2_1',
						'tableDataZero',
						this.gettableval('zzs_1_1_9', 'tableDataI') -
						this.gettableval('zzs_0_2_3', 'tableDataZero') -
						this.gettableval('zzs_0_3_1', 'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_0_3_1') {
					let d = this.gettableval('zzs_1_1_9', 'tableDataI') -
						this.gettableval('zzs_0_2_3', 'tableDataZero') -
						this.gettableval('zzs_0_3_1', 'tableDataZero')
					this.changetableval(
						'zzs_0_2_1',
						'tableDataZero',
						this.gettableval('zzs_1_1_9', 'tableDataI') -
						this.gettableval('zzs_0_2_3', 'tableDataZero') -
						this.gettableval('zzs_0_3_1', 'tableDataZero')
					);
					this.changetableval(
						'zzs_0_3_2',
						'tableDataZero',
						this.gettableval('zzs_0_3_2', 'tableDataZero', 'old') + this.gettableval('zzs_0_3_1',
							'tableDataZero'),
						'checkq'
					);
				}
				if (e.cellCode == 'zzs_0_3_3') {
					this.changetableval(
						'zzs_0_2_3',
						'tableDataZero',
						this.gettableval('zzs_0_1_3', 'tableDataZero') -
						this.gettableval('zzs_0_3_3', 'tableDataZero') -
						this.gettableval('zzs_0_4_3', 'tableDataZero')
					);
					this.changetableval('zzs_0_3_1', 'tableDataZero', this.ssbm_lw - this.gettableval('zzs_0_3_3',
						'tableDataZero'));
					this.changetableval(
						'zzs_0_3_4',
						'tableDataZero',
						this.gettableval('zzs_0_3_4', 'tableDataZero', 'old') + this.gettableval('zzs_0_3_3',
							'tableDataZero'),
						'checkq'
					);
				}
				if (e.cellCode == 'zzs_0_4_1') {
					this.changetableval(
						'zzs_0_4_2',
						'tableDataZero',
						this.gettableval('zzs_0_4_2', 'tableDataZero', 'old') + this.gettableval('zzs_0_4_1',
							'tableDataZero'),
						'checkq'
					);
				}
				if (e.cellCode == 'zzs_0_4_3') {
					this.changetableval(
						'zzs_0_2_3',
						'tableDataZero',
						this.gettableval('zzs_0_1_3', 'tableDataZero') -
						this.gettableval('zzs_0_3_3', 'tableDataZero') -
						this.gettableval('zzs_0_4_3', 'tableDataZero')
					);
					this.changetableval(
						'zzs_0_4_4',
						'tableDataZero',
						this.gettableval('zzs_0_4_4', 'tableDataZero', 'old') + this.gettableval('zzs_0_4_3',
							'tableDataZero'),
						'checkq'
					);
				}
				if (e.cellCode == 'zzs_0_5_1') {
					this.changetableval(
						'zzs_0_5_2',
						'tableDataZero',
						this.gettableval('zzs_0_5_2', 'tableDataZero', 'old') + this.gettableval('zzs_0_5_1',
							'tableDataZero'),
						'checkq'
					);
				}
				if (e.cellCode == 'zzs_0_5_3') {
					this.changetableval(
						'zzs_0_5_4',
						'tableDataZero',
						this.gettableval('zzs_0_5_4', 'tableDataZero', 'old') + this.gettableval('zzs_0_5_3',
							'tableDataZero'),
						'checkq'
					);
				}
				if (e.cellCode == 'zzs_0_6_1') {
					this.changetableval(
						'zzs_0_6_2',
						'tableDataZero',
						this.gettableval('zzs_0_6_2', 'tableDataZero', 'old') + this.gettableval('zzs_0_6_1',
							'tableDataZero'),
						'checkq'
					);
				}
				if (e.cellCode == 'zzs_0_6_3') {
					this.changetableval(
						'zzs_0_6_4',
						'tableDataZero',
						this.gettableval('zzs_0_6_4', 'tableDataZero', 'old') + this.gettableval('zzs_0_6_3',
							'tableDataZero'),
						'checkq'
					);
				}
				if (e.cellCode == 'zzs_0_7_1') {
					this.changetableval(
						'zzs_0_7_2',
						'tableDataZero',
						this.gettableval('zzs_0_7_2', 'tableDataZero', 'old') + this.gettableval('zzs_0_7_1',
							'tableDataZero'),
						'checkq'
					);
				}
				if (e.cellCode == 'zzs_0_8_1') {
					this.changetableval(
						'zzs_0_8_2',
						'tableDataZero',
						this.gettableval('zzs_0_8_2', 'tableDataZero', 'old') + this.gettableval('zzs_0_8_1',
							'tableDataZero'),
						'checkq'
					);


					// this.changetableval("zzs_6_7_1", 'tableDataTax_II', this.gettableval("zzs_0_8_1", 'tableDataZero'))
				}
				if (e.cellCode == 'zzs_0_9_1') {
					this.changetableval(
						'zzs_0_9_2',
						'tableDataZero',
						this.gettableval('zzs_0_9_2', 'tableDataZero', 'old') + this.gettableval('zzs_0_9_1',
							'tableDataZero'),
						'checkq'
					);
				}
				if (e.cellCode == 'zzs_0_10_1') {
					this.changetableval(
						'zzs_0_9_1',
						'tableDataZero',
						this.gettableval('zzs_1_18_9', 'tableDataI') - this.gettableval('zzs_0_10_1', 'tableDataZero')
					);
					this.changetableval(
						'zzs_0_10_2',
						'tableDataZero',
						this.gettableval('zzs_0_10_2', 'tableDataZero', 'old') + this.gettableval('zzs_0_10_1',
							'tableDataZero'),
						'checkq'
					);
				}
				if (e.cellCode == 'zzs_0_11_1') {
					this.changetableval(
						'zzs_0_11_2',
						'tableDataZero',
						this.gettableval('zzs_0_11_2', 'tableDataZero', 'old') + this.gettableval('zzs_0_11_1',
							'tableDataZero'),
						'checkq'
					);
					this.changetableval(
						'zzs_0_18_1',
						'tableDataZero',
						this.gettableval('zzs_0_17_1', 'tableDataZero') < this.gettableval('zzs_0_11_1',
							'tableDataZero') ?
						this.gettableval('zzs_0_17_1', 'tableDataZero') :
						this.gettableval('zzs_0_11_1', 'tableDataZero')
					);
					if (
						(this.gettableval('zzs_4_6_4', 'tableDataIV_II') > 0 || this.gettableval('zzs_4_6_4',
							'tableDataIV_II') == 0) &&
						this.gettableval('zzs_4_6_4', 'tableDataIV_II') <
						this.gettableval('zzs_0_11_1', 'tableDataZero') - this.gettableval('zzs_0_18_1', 'tableDataZero')
					) {
						this.changetableval('zzs_4_6_5', 'tableDataIV_II', this.gettableval('zzs_4_6_4',
							'tableDataIV_II'));
					}
					if (
						!(
							this.gettableval('zzs_4_6_4', 'tableDataIV_II') <
							this.gettableval('zzs_0_11_1', 'tableDataZero') - this.gettableval('zzs_0_18_1',
								'tableDataZero')
						)
					) {
						this.changetableval(
							'zzs_4_6_5',
							'tableDataIV_II',
							this.gettableval('zzs_0_11_1', 'tableDataZero') - this.gettableval('zzs_0_18_1',
								'tableDataZero')
						);
					}
					if (this.gettableval('zzs_4_6_4', 'tableDataIV_II') < 0) {
						this.changetableval('zzs_4_6_5', 'tableDataIV_II', 0);
					}
					this.changetableval(
						'zzs_0_19_1',
						'tableDataZero',
						this.gettableval('zzs_0_11_1', 'tableDataZero') -
						this.gettableval('zzs_0_18_1', 'tableDataZero') -
						this.gettableval('zzs_4_6_5', 'tableDataIV_II')
					);
				}
				if (e.cellCode == 'zzs_0_11_3') {
					this.changetableval(
						'zzs_0_11_4',
						'tableDataZero',
						this.gettableval('zzs_0_11_4', 'tableDataZero', 'old') + this.gettableval('zzs_0_11_3',
							'tableDataZero'),
						'checkq'
					);
					this.changetableval(
						'zzs_0_18_3',
						'tableDataZero',
						this.gettableval('zzs_0_17_3', 'tableDataZero') < this.gettableval('zzs_0_11_3',
							'tableDataZero') ?
						this.gettableval('zzs_0_17_3', 'tableDataZero') :
						this.gettableval('zzs_0_11_3', 'tableDataZero')
					);
					this.changetableval(
						'zzs_0_19_3',
						'tableDataZero',
						this.gettableval('zzs_0_11_3', 'tableDataZero') -
						this.gettableval('zzs_0_18_3', 'tableDataZero') -
						this.gettableval('zzs_4_7_5', 'tableDataIV_II')
					);
					var val = '';
					if (
						!(this.gettableval('zzs_4_7_4', 'tableDataIV_II') < 0) &&
						this.gettableval('zzs_4_7_4', 'tableDataIV_II') <
						this.gettableval('zzs_0_11_3', 'tableDataZero') - this.gettableval('zzs_0_18_3', 'tableDataZero')
					) {
						val = this.gettableval('zzs_4_7_4', 'tableDataIV_II');
					} else if (
						!(
							this.gettableval('zzs_4_7_4', 'tableDataIV_II') <
							this.gettableval('zzs_0_11_3', 'tableDataZero') - this.gettableval('zzs_0_18_3',
								'tableDataZero')
						)
					) {
						val = this.gettableval('zzs_0_11_3', 'tableDataZero') - this.gettableval('zzs_0_18_3',
							'tableDataZero');
					}
					if (this.gettableval('zzs_4_7_4', 'tableDataIV_II') < 0) {
						val = 0;
					}
					this.changetableval('zzs_4_7_5', 'tableDataIV_II', val);
				}
				if (e.cellCode == 'zzs_0_12_1') {
					// if ((this.gettableval("zzs_0_12_1", 'tableDataZero') + this.gettableval("zzs_0_12_3",
					// 		'tableDataZero')) != this.gettableval("zzs_2_12_3", 'tableDataII_I')) {
					// 	this.$message.error("zzs_0_12_1格子校验不正确")
					// }
					this.changetableval(
						'zzs_0_12_2',
						'tableDataZero',
						this.gettableval('zzs_0_12_2', 'tableDataZero', 'old') + this.gettableval('zzs_0_12_1',
							'tableDataZero'),
						'checkq'
					);
					this.changetableval(
						'zzs_0_17_1',
						'tableDataZero',
						this.gettableval('zzs_0_12_1', 'tableDataZero') +
						this.gettableval('zzs_0_13_1', 'tableDataZero') -
						this.gettableval('zzs_0_14_1', 'tableDataZero') -
						this.gettableval('zzs_0_15_1', 'tableDataZero') +
						this.gettableval('zzs_0_16_1', 'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_0_12_3') {
					// if ((this.gettableval("zzs_0_12_1", 'tableDataZero') + this.gettableval("zzs_0_12_3",
					// 		'tableDataZero')) != this.gettableval("zzs_2_12_3", 'tableDataII_I')) {
					// 	this.$message.error("zzs_2_12_3格子校验不正确")
					// }
					this.changetableval(
						'zzs_0_12_4',
						'tableDataZero',
						this.gettableval('zzs_0_12_4', 'tableDataZero', 'old') + this.gettableval('zzs_0_12_3',
							'tableDataZero'),
						'checkq'
					);
					this.changetableval(
						'zzs_0_17_3',
						'tableDataZero',
						this.gettableval('zzs_0_12_3', 'tableDataZero') +
						this.gettableval('zzs_0_13_3', 'tableDataZero') -
						this.gettableval('zzs_0_14_3', 'tableDataZero') -
						this.gettableval('zzs_0_15_3', 'tableDataZero') +
						this.gettableval('zzs_0_16_3', 'tableDataZero')
					);
					this.changetableval(
						'zzs_0_12_1',
						'tableDataZero',
						this.gettableval('zzs_2_12_3', 'tableDataII_I') - this.gettableval('zzs_0_12_3',
							'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_0_13_1') {
					this.changetableval(
						'zzs_0_17_1',
						'tableDataZero',
						this.gettableval('zzs_0_12_1', 'tableDataZero') +
						this.gettableval('zzs_0_13_1', 'tableDataZero') -
						this.gettableval('zzs_0_14_1', 'tableDataZero') -
						this.gettableval('zzs_0_15_1', 'tableDataZero') +
						this.gettableval('zzs_0_16_1', 'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_0_13_3') {
					this.changetableval(
						'zzs_0_17_3',
						'tableDataZero',
						this.gettableval('zzs_0_12_3', 'tableDataZero') +
						this.gettableval('zzs_0_13_3', 'tableDataZero') -
						this.gettableval('zzs_0_14_3', 'tableDataZero') -
						this.gettableval('zzs_0_15_3', 'tableDataZero') +
						this.gettableval('zzs_0_16_3', 'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_0_14_1') {
					// if ((this.gettableval("zzs_2_13_1", 'tableDataII_II') - this.gettableval("zzs_0_14_3",
					// 		'tableDataZero')) != this.gettableval("zzs_0_14_1", 'tableDataZero')) {
					// 	this.$message.error("zzs_0_14_1格子校验不正确")
					// }


					// this.changetableval(
					//     'zzs_0_14_3',
					//     'tableDataZero',
					//     this.gettableval('zzs_2_13_1', 'tableDataII_II') - this.gettableval('zzs_0_14_1', 'tableDataZero')
					// );
					this.changetableval(
						'zzs_0_14_2',
						'tableDataZero',
						this.gettableval('zzs_0_14_2', 'tableDataZero', 'old') + this.gettableval('zzs_0_14_1',
							'tableDataZero'),
						'checkq'
					);
					this.changetableval(
						'zzs_0_17_1',
						'tableDataZero',
						this.gettableval('zzs_0_12_1', 'tableDataZero') +
						this.gettableval('zzs_0_13_1', 'tableDataZero') -
						this.gettableval('zzs_0_14_1', 'tableDataZero') -
						this.gettableval('zzs_0_15_1', 'tableDataZero') +
						this.gettableval('zzs_0_16_1', 'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_0_14_3') {
					// if ((this.gettableval("zzs_2_13_1", 'tableDataII_II') - this.gettableval("zzs_0_14_3",
					// 		'tableDataZero')) != this.gettableval("zzs_0_14_1", 'tableDataZero')) {
					// 	this.$message.error("zzs_0_14_3格子校验不正确")
					// }
					this.changetableval(
						'zzs_0_14_1',
						'tableDataZero',
						this.gettableval('zzs_2_13_1', 'tableDataII_II') - this.gettableval('zzs_0_14_3',
							'tableDataZero')
					);
					this.changetableval(
						'zzs_0_14_4',
						'tableDataZero',
						this.gettableval('zzs_0_14_4', 'tableDataZero', 'old') + this.gettableval('zzs_0_14_3',
							'tableDataZero'),
						'checkq'
					);
					this.changetableval(
						'zzs_0_17_3',
						'tableDataZero',
						this.gettableval('zzs_0_12_3', 'tableDataZero') +
						this.gettableval('zzs_0_13_3', 'tableDataZero') -
						this.gettableval('zzs_0_14_3', 'tableDataZero') -
						this.gettableval('zzs_0_15_3', 'tableDataZero') +
						this.gettableval('zzs_0_16_3', 'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_0_15_1') {
					this.changetableval(
						'zzs_0_15_2',
						'tableDataZero',
						this.gettableval('zzs_0_15_2', 'tableDataZero', 'old') + this.gettableval('zzs_0_15_1',
							'tableDataZero'),
						'checkq'
					);
					this.changetableval(
						'zzs_0_17_1',
						'tableDataZero',
						this.gettableval('zzs_0_12_1', 'tableDataZero') +
						this.gettableval('zzs_0_13_1', 'tableDataZero') -
						this.gettableval('zzs_0_14_1', 'tableDataZero') -
						this.gettableval('zzs_0_15_1', 'tableDataZero') +
						this.gettableval('zzs_0_16_1', 'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_0_15_3') {
					this.changetableval(
						'zzs_0_17_3',
						'tableDataZero',
						this.gettableval('zzs_0_12_3', 'tableDataZero') +
						this.gettableval('zzs_0_13_3', 'tableDataZero') -
						this.gettableval('zzs_0_14_3', 'tableDataZero') -
						this.gettableval('zzs_0_15_3', 'tableDataZero') +
						this.gettableval('zzs_0_16_3', 'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_0_16_1') {
					this.changetableval(
						'zzs_0_16_2',
						'tableDataZero',
						this.gettableval('zzs_0_16_2', 'tableDataZero', 'old') + this.gettableval('zzs_0_16_1',
							'tableDataZero'),
						'checkq'
					);
					this.changetableval(
						'zzs_0_17_1',
						'tableDataZero',
						this.gettableval('zzs_0_12_1', 'tableDataZero') +
						this.gettableval('zzs_0_13_1', 'tableDataZero') -
						this.gettableval('zzs_0_14_1', 'tableDataZero') -
						this.gettableval('zzs_0_15_1', 'tableDataZero') +
						this.gettableval('zzs_0_16_1', 'tableDataZero')
					);
					this.changetableval(
						'zzs_0_38_1',
						'tableDataZero',
						this.gettableval('zzs_0_16_1', 'tableDataZero') +
						this.gettableval('zzs_0_22_1', 'tableDataZero') +
						this.gettableval('zzs_0_36_1', 'tableDataZero') -
						this.gettableval('zzs_0_37_1', 'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_0_16_3') {
					this.changetableval(
						'zzs_0_17_3',
						'tableDataZero',
						this.gettableval('zzs_0_12_3', 'tableDataZero') +
						this.gettableval('zzs_0_13_3', 'tableDataZero') -
						this.gettableval('zzs_0_14_3', 'tableDataZero') -
						this.gettableval('zzs_0_15_3', 'tableDataZero') +
						this.gettableval('zzs_0_16_3', 'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_0_17_1') {
					this.changetableval(
						'zzs_0_18_1',
						'tableDataZero',
						this.gettableval('zzs_0_17_1', 'tableDataZero') < this.gettableval('zzs_0_11_1',
							'tableDataZero') ?
						this.gettableval('zzs_0_17_1', 'tableDataZero') :
						this.gettableval('zzs_0_11_1', 'tableDataZero')
					);
					this.changetableval(
						'zzs_0_20_1',
						'tableDataZero',
						this.gettableval('zzs_0_17_1', 'tableDataZero') - this.gettableval('zzs_0_18_1',
							'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_0_17_3') {
					this.changetableval(
						'zzs_0_18_3',
						'tableDataZero',
						this.gettableval('zzs_0_17_3', 'tableDataZero') < this.gettableval('zzs_0_11_3',
							'tableDataZero') ?
						this.gettableval('zzs_0_17_3', 'tableDataZero') :
						this.gettableval('zzs_0_11_3', 'tableDataZero')
					);
					this.changetableval(
						'zzs_0_20_3',
						'tableDataZero',
						this.gettableval('zzs_0_17_3', 'tableDataZero') - this.gettableval('zzs_0_18_3',
							'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_0_18_1') {
					this.changetableval(
						'zzs_0_20_1',
						'tableDataZero',
						this.gettableval('zzs_0_17_1', 'tableDataZero') - this.gettableval('zzs_0_18_1',
							'tableDataZero')
					);
					if (
						(this.gettableval('zzs_4_6_4', 'tableDataIV_II') > 0 || this.gettableval('zzs_4_6_4',
							'tableDataIV_II') == 0) &&
						this.gettableval('zzs_4_6_4', 'tableDataIV_II') <
						this.gettableval('zzs_0_11_1', 'tableDataZero') - this.gettableval('zzs_0_18_1', 'tableDataZero')
					) {
						this.changetableval('zzs_4_6_5', 'tableDataIV_II', this.gettableval('zzs_4_6_4',
							'tableDataIV_II'));
					}
					if (
						!(
							this.gettableval('zzs_4_6_4', 'tableDataIV_II') <
							this.gettableval('zzs_0_11_1', 'tableDataZero') - this.gettableval('zzs_0_18_1',
								'tableDataZero')
						)
					) {
						this.changetableval(
							'zzs_4_6_5',
							'tableDataIV_II',
							this.gettableval('zzs_0_11_1', 'tableDataZero') - this.gettableval('zzs_0_18_1',
								'tableDataZero')
						);
					}
					if (this.gettableval('zzs_4_6_4', 'tableDataIV_II') < 0) {
						this.changetableval('zzs_4_6_5', 'tableDataIV_II', 0);
					}
					this.changetableval(
						'zzs_0_19_1',
						'tableDataZero',
						this.gettableval('zzs_0_11_1', 'tableDataZero') -
						this.gettableval('zzs_0_18_1', 'tableDataZero') -
						this.gettableval('zzs_4_6_5', 'tableDataIV_II')
					);
				}
				if (e.cellCode == 'zzs_0_18_3') {
					this.changetableval(
						'zzs_0_18_4',
						'tableDataZero',
						this.gettableval('zzs_0_18_4', 'tableDataZero', 'old') + this.gettableval('zzs_0_18_3',
							'tableDataZero'),
						'checkq'
					);
					this.changetableval(
						'zzs_0_19_3',
						'tableDataZero',
						this.gettableval('zzs_0_11_3', 'tableDataZero') -
						this.gettableval('zzs_0_18_3', 'tableDataZero') -
						this.gettableval('zzs_4_7_5', 'tableDataIV_II')
					);
					this.changetableval(
						'zzs_0_20_3',
						'tableDataZero',
						this.gettableval('zzs_0_17_3', 'tableDataZero') - this.gettableval('zzs_0_18_3',
							'tableDataZero')
					);
					var val = '';
					if (
						!(this.gettableval('zzs_4_7_4', 'tableDataIV_II') < 0) &&
						this.gettableval('zzs_4_7_4', 'tableDataIV_II') <
						this.gettableval('zzs_0_11_3', 'tableDataZero') - this.gettableval('zzs_0_18_3', 'tableDataZero')
					) {
						val = this.gettableval('zzs_4_7_4', 'tableDataIV_II');
					} else if (
						!(
							this.gettableval('zzs_4_7_4', 'tableDataIV_II') <
							this.gettableval('zzs_0_11_3', 'tableDataZero') - this.gettableval('zzs_0_18_3',
								'tableDataZero')
						)
					) {
						val = this.gettableval('zzs_0_11_3', 'tableDataZero') - this.gettableval('zzs_0_18_3',
							'tableDataZero');
					}
					if (this.gettableval('zzs_4_7_4', 'tableDataIV_II') < 0) {
						val = 0;
					}
					this.changetableval('zzs_4_7_5', 'tableDataIV_II', val);
				}
				if (e.cellCode == 'zzs_0_19_1') {
					this.changetableval(
						'zzs_0_19_2',
						'tableDataZero',
						this.gettableval('zzs_0_19_2', 'tableDataZero', 'old') + this.gettableval('zzs_0_19_1',
							'tableDataZero'),
						'checkq'
					);
					// this.changetableval("zzs_0_23_1", 'tableDataZero', (this.gettableval("zzs_0_23_1", 'tableDataZero') > (
					// 		this.gettableval("zzs_0_19_1", 'tableDataZero') + this.gettableval("zzs_0_21_1",
					// 			'tableDataZero'))) ? this.gettableval("zzs_0_19_1", 'tableDataZero') + this
					// 	.gettableval("zzs_0_21_1", 'tableDataZero') : this.gettableval("zzs_0_23_1", 'tableDataZero'))
					this.changetableval(
						'zzs_0_24_1',
						'tableDataZero',
						this.gettableval('zzs_0_19_1', 'tableDataZero') +
						this.gettableval('zzs_0_21_1', 'tableDataZero') -
						this.gettableval('zzs_0_23_1', 'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_0_19_3') {
					this.changetableval(
						'zzs_0_19_4',
						'tableDataZero',
						this.gettableval('zzs_0_19_4', 'tableDataZero', 'old') + this.gettableval('zzs_0_19_3',
							'tableDataZero'),
						'checkq'
					);
					this.changetableval(
						'zzs_0_23_3',
						'tableDataZero',
						this.gettableval('zzs_0_23_3', 'tableDataZero') >
						this.gettableval('zzs_0_19_3', 'tableDataZero') + this.gettableval('zzs_0_21_3',
							'tableDataZero') ?
						this.gettableval('zzs_0_19_3', 'tableDataZero') + this.gettableval('zzs_0_21_3',
							'tableDataZero') :
						this.gettableval('zzs_0_23_3', 'tableDataZero')
					);
					this.changetableval(
						'zzs_0_24_3',
						'tableDataZero',
						this.gettableval('zzs_0_19_3', 'tableDataZero') +
						this.gettableval('zzs_0_21_3', 'tableDataZero') -
						this.gettableval('zzs_0_23_3', 'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_0_21_1') {
					this.changetableval(
						'zzs_0_21_2',
						'tableDataZero',
						this.gettableval('zzs_0_21_2', 'tableDataZero', 'old') + this.gettableval('zzs_0_21_1',
							'tableDataZero'),
						'checkq'
					);
					// this.changetableval("zzs_0_23_1", 'tableDataZero', (this.gettableval("zzs_0_23_1", 'tableDataZero') > (
					// 		this.gettableval("zzs_0_19_1", 'tableDataZero') + this.gettableval("zzs_0_21_1",
					// 			'tableDataZero'))) ? this.gettableval("zzs_0_19_1", 'tableDataZero') + this
					// 	.gettableval("zzs_0_21_1", 'tableDataZero') : this.gettableval("zzs_0_23_1", 'tableDataZero'))
					this.changetableval(
						'zzs_0_24_1',
						'tableDataZero',
						this.gettableval('zzs_0_19_1', 'tableDataZero') +
						this.gettableval('zzs_0_21_1', 'tableDataZero') -
						this.gettableval('zzs_0_23_1', 'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_0_21_3') {
					this.changetableval(
						'zzs_0_21_4',
						'tableDataZero',
						this.gettableval('zzs_0_21_4', 'tableDataZero', 'old') + this.gettableval('zzs_0_21_1',
							'tableDataZero'),
						'checkq'
					);
					this.changetableval(
						'zzs_0_23_3',
						'tableDataZero',
						this.gettableval('zzs_0_23_3', 'tableDataZero') >
						this.gettableval('zzs_0_19_3', 'tableDataZero') + this.gettableval('zzs_0_21_3',
							'tableDataZero') ?
						this.gettableval('zzs_0_19_3', 'tableDataZero') + this.gettableval('zzs_0_21_3',
							'tableDataZero') :
						this.gettableval('zzs_0_23_3', 'tableDataZero')
					);
					this.changetableval(
						'zzs_0_24_3',
						'tableDataZero',
						this.gettableval('zzs_0_19_3', 'tableDataZero') +
						this.gettableval('zzs_0_21_3', 'tableDataZero') -
						this.gettableval('zzs_0_23_3', 'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_0_22_1') {
					this.changetableval(
						'zzs_0_38_1',
						'tableDataZero',
						this.gettableval('zzs_0_16_1', 'tableDataZero') +
						this.gettableval('zzs_0_22_1', 'tableDataZero') +
						this.gettableval('zzs_0_36_1', 'tableDataZero') -
						this.gettableval('zzs_0_37_1', 'tableDataZero')
					);
					this.changetableval(
						'zzs_0_22_2',
						'tableDataZero',
						this.gettableval('zzs_0_22_2', 'tableDataZero', 'old') + this.gettableval('zzs_0_22_1',
							'tableDataZero'),
						'checkq'
					);
				}
				if (e.cellCode == 'zzs_0_23_1') {
					this.changetableval(
						'zzs_0_23_2',
						'tableDataZero',
						this.gettableval('zzs_0_23_2', 'tableDataZero', 'old') + this.gettableval('zzs_0_23_1',
							'tableDataZero'),
						'checkq'
					);
					// this.changetableval("zzs_6_1_4", 'tableDataTax_I', this.gettableval("zzs_0_23_1", 'tableDataZero'))
					// this.changetableval("zzs_0_23_1", 'tableDataZero', (this.gettableval("zzs_0_23_1", 'tableDataZero') > (
					// 		this.gettableval("zzs_0_19_1", 'tableDataZero') + this.gettableval("zzs_0_21_1",
					// 			'tableDataZero'))) ? this.gettableval("zzs_0_19_1", 'tableDataZero') + this
					// 	.gettableval("zzs_0_21_1", 'tableDataZero') : this.gettableval("zzs_0_23_1", 'tableDataZero'))
					this.changetableval(
						'zzs_0_24_1',
						'tableDataZero',
						this.gettableval('zzs_0_19_1', 'tableDataZero') +
						this.gettableval('zzs_0_21_1', 'tableDataZero') -
						this.gettableval('zzs_0_23_1', 'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_0_23_3') {
					this.changetableval(
						'zzs_0_23_4',
						'tableDataZero',
						this.gettableval('zzs_0_23_4', 'tableDataZero', 'old') + this.gettableval('zzs_0_23_3',
							'tableDataZero'),
						'checkq'
					);
					this.changetableval(
						'zzs_0_24_3',
						'tableDataZero',
						this.gettableval('zzs_0_19_3', 'tableDataZero') +
						this.gettableval('zzs_0_21_3', 'tableDataZero') -
						this.gettableval('zzs_0_23_3', 'tableDataZero')
					);
					this.changetableval(
						'zzs_0_23_3',
						'tableDataZero',
						this.gettableval('zzs_0_23_3', 'tableDataZero') >
						this.gettableval('zzs_0_19_3', 'tableDataZero') + this.gettableval('zzs_0_21_3',
							'tableDataZero') ?
						this.gettableval('zzs_0_19_3', 'tableDataZero') + this.gettableval('zzs_0_21_3',
							'tableDataZero') :
						this.gettableval('zzs_0_23_3', 'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_0_24_1') {
					this.changetableval(
						'zzs_0_24_2',
						'tableDataZero',
						this.gettableval('zzs_0_24_2', 'tableDataZero', 'old') + this.gettableval('zzs_0_24_1',
							'tableDataZero'),
						'checkq'
					);
					this.changetableval(
						'zzs_0_32_1',
						'tableDataZero',
						this.gettableval('zzs_0_24_1', 'tableDataZero') +
						this.gettableval('zzs_0_25_1', 'tableDataZero') +
						this.gettableval('zzs_0_26_1', 'tableDataZero') -
						this.gettableval('zzs_0_27_1', 'tableDataZero')
					);
					this.changetableval(
						'zzs_0_34_1',
						'tableDataZero',
						this.gettableval('zzs_0_24_1', 'tableDataZero') -
						this.gettableval('zzs_0_28_1', 'tableDataZero') -
						this.gettableval('zzs_0_29_1', 'tableDataZero')
					);
					this.changetableval('zzs_8_0_8', 'tableDataSummary_I', this.gettableval('zzs_0_24_1',
						'tableDataZero'));
					if (
						(this.params.companyCode == '1100' ||
							this.params.companyCode == '1200' ||
							this.params.companyCode == '1130' ||
							this.params.companyCode == '4300') &&
						this.gettableval('zzs_4_3_3', 'tableDataIV_I') > 0 &&
						this.gettableval('zzs_0_24_1', 'tableDataZero') - this.gettableval('zzs_0_21_1', 'tableDataZero') >
						0 &&
						config.company == 'hls' &&
						this.tableDataIV_I[2].zzs_4_x_4.cellType == '0'
					) {
						if (
							this.gettableval('zzs_4_3_3', 'tableDataIV_I') >
							this.gettableval('zzs_0_24_1', 'tableDataZero') - this.gettableval('zzs_0_21_1',
								'tableDataZero')
						) {
							this.changetableval(
								'zzs_4_3_4',
								'tableDataIV_I',
								this.gettableval('zzs_0_24_1', 'tableDataZero') - this.gettableval('zzs_0_21_1',
									'tableDataZero')
							);
						} else {
							this.changetableval('zzs_4_3_4', 'tableDataIV_I', this.gettableval('zzs_4_3_3',
								'tableDataIV_I'));
						}
					}
				}
				if (e.cellCode == 'zzs_0_24_3') {
					this.changetableval(
						'zzs_0_24_4',
						'tableDataZero',
						this.gettableval('zzs_0_24_4', 'tableDataZero', 'old') + this.gettableval('zzs_0_24_3',
							'tableDataZero'),
						'checkq'
					);
					this.changetableval(
						'zzs_0_32_3',
						'tableDataZero',
						this.gettableval('zzs_0_24_3', 'tableDataZero') +
						this.gettableval('zzs_0_25_3', 'tableDataZero') +
						this.gettableval('zzs_0_26_3', 'tableDataZero') -
						this.gettableval('zzs_0_27_3', 'tableDataZero')
					);
					this.changetableval(
						'zzs_0_34_3',
						'tableDataZero',
						this.gettableval('zzs_0_24_3', 'tableDataZero') -
						this.gettableval('zzs_0_28_3', 'tableDataZero') -
						this.gettableval('zzs_0_29_3', 'tableDataZero')
					);
				}
				// if (e.cellCode == 'zzs_0_24_4') {
				//     this.changetableval(
				//         'zzs_0_32_4',
				//         'tableDataZero',
				//         this.gettableval('zzs_0_24_4', 'tableDataZero') +
				//             this.gettableval('zzs_0_25_4', 'tableDataZero') +
				//             this.gettableval('zzs_0_26_4', 'tableDataZero') -
				//             this.gettableval('zzs_0_27_4', 'tableDataZero')
				//     );
				// }
				if (e.cellCode == 'zzs_0_25_1') {
					this.changetableval(
						'zzs_0_25_2',
						'tableDataZero',
						this.gettableval('zzs_0_25_2', 'tableDataZero', 'old') + this.gettableval('zzs_0_25_1',
							'tableDataZero'),
						'checkq'
					);
					this.changetableval(
						'zzs_0_32_1',
						'tableDataZero',
						this.gettableval('zzs_0_24_1', 'tableDataZero') +
						this.gettableval('zzs_0_25_1', 'tableDataZero') +
						this.gettableval('zzs_0_26_1', 'tableDataZero') -
						this.gettableval('zzs_0_27_1', 'tableDataZero')
					);
					this.changetableval(
						'zzs_0_33_1',
						'tableDataZero',
						this.gettableval('zzs_0_25_1', 'tableDataZero') +
						this.gettableval('zzs_0_26_1', 'tableDataZero') -
						this.gettableval('zzs_0_27_1', 'tableDataZero')
					);
					if (this.gettableval('zzs_0_33_1', 'tableDataZero') < 0) {
						this.changetableval('zzs_0_33_1', 'tableDataZero', 0);
					}
				}
				if (e.cellCode == 'zzs_0_25_3') {
					this.changetableval(
						'zzs_0_25_4',
						'tableDataZero',
						this.gettableval('zzs_0_25_4', 'tableDataZero', 'old') + this.gettableval('zzs_0_25_5',
							'tableDataZero'),
						'checkq'
					);
					this.changetableval(
						'zzs_0_32_3',
						'tableDataZero',
						this.gettableval('zzs_0_24_3', 'tableDataZero') +
						this.gettableval('zzs_0_25_3', 'tableDataZero') +
						this.gettableval('zzs_0_26_3', 'tableDataZero') -
						this.gettableval('zzs_0_27_3', 'tableDataZero')
					);
					this.changetableval(
						'zzs_0_33_3',
						'tableDataZero',
						this.gettableval('zzs_0_25_3', 'tableDataZero') +
						this.gettableval('zzs_0_26_3', 'tableDataZero') -
						this.gettableval('zzs_0_27_3', 'tableDataZero')
					);
				}
				// if (e.cellCode == 'zzs_0_25_4') {
				//     this.changetableval(
				//         'zzs_0_32_4',
				//         'tableDataZero',
				//         this.gettableval('zzs_0_24_4', 'tableDataZero') +
				//             this.gettableval('zzs_0_25_4', 'tableDataZero') +
				//             this.gettableval('zzs_0_26_4', 'tableDataZero') -
				//             this.gettableval('zzs_0_27_4', 'tableDataZero')
				//     );
				// }
				if (e.cellCode == 'zzs_0_26_1') {
					this.changetableval(
						'zzs_0_32_1',
						'tableDataZero',
						this.gettableval('zzs_0_24_1', 'tableDataZero') +
						this.gettableval('zzs_0_25_1', 'tableDataZero') +
						this.gettableval('zzs_0_26_1', 'tableDataZero') -
						this.gettableval('zzs_0_27_1', 'tableDataZero')
					);
					this.changetableval(
						'zzs_0_33_1',
						'tableDataZero',
						this.gettableval('zzs_0_25_1', 'tableDataZero') +
						this.gettableval('zzs_0_26_1', 'tableDataZero') -
						this.gettableval('zzs_0_27_1', 'tableDataZero')
					);
					if (this.gettableval('zzs_0_33_1', 'tableDataZero') < 0) {
						this.changetableval('zzs_0_33_1', 'tableDataZero', 0);
					}
				}
				if (e.cellCode == 'zzs_0_26_3') {
					this.changetableval(
						'zzs_0_32_3',
						'tableDataZero',
						this.gettableval('zzs_0_24_3', 'tableDataZero') +
						this.gettableval('zzs_0_25_3', 'tableDataZero') +
						this.gettableval('zzs_0_26_3', 'tableDataZero') -
						this.gettableval('zzs_0_27_3', 'tableDataZero')
					);
					this.changetableval(
						'zzs_0_33_3',
						'tableDataZero',
						this.gettableval('zzs_0_25_3', 'tableDataZero') +
						this.gettableval('zzs_0_26_3', 'tableDataZero') -
						this.gettableval('zzs_0_27_3', 'tableDataZero')
					);
				}
				// if (e.cellCode == 'zzs_0_26_4') {
				//     this.changetableval(
				//         'zzs_0_32_4',
				//         'tableDataZero',
				//         this.gettableval('zzs_0_24_4', 'tableDataZero') +
				//             this.gettableval('zzs_0_25_4', 'tableDataZero') +
				//             this.gettableval('zzs_0_26_4', 'tableDataZero') -
				//             this.gettableval('zzs_0_27_4', 'tableDataZero')
				//     );
				// }
				if (e.cellCode == 'zzs_0_27_1') {
					this.changetableval(
						'zzs_0_27_2',
						'tableDataZero',
						this.gettableval('zzs_0_27_2', 'tableDataZero', 'old') + this.gettableval('zzs_0_27_1',
							'tableDataZero'),
						'checkq'
					);
					this.changetableval(
						'zzs_0_32_1',
						'tableDataZero',
						this.gettableval('zzs_0_24_1', 'tableDataZero') +
						this.gettableval('zzs_0_25_1', 'tableDataZero') +
						this.gettableval('zzs_0_26_1', 'tableDataZero') -
						this.gettableval('zzs_0_27_1', 'tableDataZero')
					);
					this.changetableval(
						'zzs_0_33_1',
						'tableDataZero',
						this.gettableval('zzs_0_25_1', 'tableDataZero') +
						this.gettableval('zzs_0_26_1', 'tableDataZero') -
						this.gettableval('zzs_0_27_1', 'tableDataZero')
					);
					if (this.gettableval('zzs_0_33_1', 'tableDataZero') < 0) {
						this.changetableval('zzs_0_33_1', 'tableDataZero', 0);
					}
				}
				if (e.cellCode == 'zzs_0_27_3') {
					this.changetableval(
						'zzs_0_27_4',
						'tableDataZero',
						this.gettableval('zzs_0_27_4', 'tableDataZero', 'old') + this.gettableval('zzs_0_27_3',
							'tableDataZero'),
						'checkq'
					);
					this.changetableval(
						'zzs_0_32_3',
						'tableDataZero',
						this.gettableval('zzs_0_24_3', 'tableDataZero') +
						this.gettableval('zzs_0_25_3', 'tableDataZero') +
						this.gettableval('zzs_0_26_3', 'tableDataZero') -
						this.gettableval('zzs_0_27_3', 'tableDataZero')
					);
					let list = 0;
					if (
						(this.params.companyCode == '1500' ||
							this.params.companyCode == '1100' ||
							this.params.companyCode == '1200' ||
							this.params.companyCode == '1130' ||
							this.params.companyCode == '4300') &&
						config.company == 'hls'
					) {
						if (
							this.gettableval('zzs_0_25_3', 'tableDataZero') +
							this.gettableval('zzs_0_26_3', 'tableDataZero') -
							this.gettableval('zzs_0_27_3', 'tableDataZero') <=
							0
						) {
							this.changetableval('zzs_0_33_3', 'tableDataZero', 0);
						} else {
							this.changetableval(
								'zzs_0_33_3',
								'tableDataZero',
								this.gettableval('zzs_0_25_3', 'tableDataZero') +
								this.gettableval('zzs_0_26_3', 'tableDataZero') -
								this.gettableval('zzs_0_27_3', 'tableDataZero')
							);
						}
					} else {
						this.changetableval(
							'zzs_0_33_3',
							'tableDataZero',
							this.gettableval('zzs_0_25_3', 'tableDataZero') +
							this.gettableval('zzs_0_26_3', 'tableDataZero') -
							this.gettableval('zzs_0_27_3', 'tableDataZero')
						);
					}
				}
				// if (e.cellCode == 'zzs_0_27_4') {
				//     this.changetableval(
				//         'zzs_0_32_4',
				//         'tableDataZero',
				//         this.gettableval('zzs_0_24_4', 'tableDataZero') +
				//             this.gettableval('zzs_0_25_4', 'tableDataZero') +
				//             this.gettableval('zzs_0_26_4', 'tableDataZero') -
				//             this.gettableval('zzs_0_27_4', 'tableDataZero')
				//     );
				// }
				if (e.cellCode == 'zzs_0_28_1') {
					this.changetableval(
						'zzs_0_27_1',
						'tableDataZero',
						this.gettableval('zzs_0_28_1', 'tableDataZero') +
						this.gettableval('zzs_0_29_1', 'tableDataZero') +
						this.gettableval('zzs_0_30_1', 'tableDataZero') +
						this.gettableval('zzs_0_31_1', 'tableDataZero')
					);
					this.changetableval(
						'zzs_0_34_1',
						'tableDataZero',
						this.gettableval('zzs_0_24_1', 'tableDataZero') -
						this.gettableval('zzs_0_28_1', 'tableDataZero') -
						this.gettableval('zzs_0_29_1', 'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_0_28_3') {
					this.changetableval(
						'zzs_0_27_3',
						'tableDataZero',
						this.gettableval('zzs_0_28_3', 'tableDataZero') +
						this.gettableval('zzs_0_29_3', 'tableDataZero') +
						this.gettableval('zzs_0_30_3', 'tableDataZero') +
						this.gettableval('zzs_0_31_3', 'tableDataZero')
					);
					this.changetableval(
						'zzs_0_34_3',
						'tableDataZero',
						this.gettableval('zzs_0_24_3', 'tableDataZero') -
						this.gettableval('zzs_0_28_3', 'tableDataZero') -
						this.gettableval('zzs_0_29_3', 'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_0_29_3') {
					this.changetableval(
						'zzs_0_27_3',
						'tableDataZero',
						this.gettableval('zzs_0_28_3', 'tableDataZero') +
						this.gettableval('zzs_0_29_3', 'tableDataZero') +
						this.gettableval('zzs_0_30_3', 'tableDataZero') +
						this.gettableval('zzs_0_31_3', 'tableDataZero')
					);
					this.changetableval(
						'zzs_0_34_3',
						'tableDataZero',
						this.gettableval('zzs_0_24_3', 'tableDataZero') -
						this.gettableval('zzs_0_28_3', 'tableDataZero') -
						this.gettableval('zzs_0_29_3', 'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_0_30_1') {
					this.changetableval(
						'zzs_0_27_1',
						'tableDataZero',
						this.gettableval('zzs_0_28_1', 'tableDataZero') +
						this.gettableval('zzs_0_29_1', 'tableDataZero') +
						this.gettableval('zzs_0_30_1', 'tableDataZero') +
						this.gettableval('zzs_0_31_1', 'tableDataZero')
					);
					this.changetableval(
						'zzs_0_30_2',
						'tableDataZero',
						this.gettableval('zzs_0_30_2', 'tableDataZero', 'old') + this.gettableval('zzs_0_30_1',
							'tableDataZero'),
						'checkq'
					);
				}
				if (e.cellCode == 'zzs_0_30_3') {
					this.changetableval(
						'zzs_0_27_3',
						'tableDataZero',
						this.gettableval('zzs_0_28_3', 'tableDataZero') +
						this.gettableval('zzs_0_29_3', 'tableDataZero') +
						this.gettableval('zzs_0_30_3', 'tableDataZero') +
						this.gettableval('zzs_0_31_3', 'tableDataZero')
					);
					this.changetableval(
						'zzs_0_30_4',
						'tableDataZero',
						this.gettableval('zzs_0_30_4', 'tableDataZero', 'old') + this.gettableval('zzs_0_30_3',
							'tableDataZero'),
						'checkq'
					);
				}
				if (e.cellCode == 'zzs_0_31_1') {
					this.changetableval(
						'zzs_0_27_1',
						'tableDataZero',
						this.gettableval('zzs_0_28_1', 'tableDataZero') +
						this.gettableval('zzs_0_29_1', 'tableDataZero') +
						this.gettableval('zzs_0_30_1', 'tableDataZero') +
						this.gettableval('zzs_0_31_1', 'tableDataZero')
					);
					this.changetableval(
						'zzs_0_31_2',
						'tableDataZero',
						this.gettableval('zzs_0_31_2', 'tableDataZero', 'old') + this.gettableval('zzs_0_31_1',
							'tableDataZero'),
						'checkq'
					);
				}
				if (e.cellCode == 'zzs_0_31_3') {
					this.changetableval(
						'zzs_0_27_3',
						'tableDataZero',
						this.gettableval('zzs_0_28_3', 'tableDataZero') +
						this.gettableval('zzs_0_29_3', 'tableDataZero') +
						this.gettableval('zzs_0_30_3', 'tableDataZero') +
						this.gettableval('zzs_0_31_3', 'tableDataZero')
					);
					this.changetableval(
						'zzs_0_31_4',
						'tableDataZero',
						this.gettableval('zzs_0_31_4', 'tableDataZero', 'old') + this.gettableval('zzs_0_31_3',
							'tableDataZero'),
						'checkq'
					);
				}
				if (e.cellCode == 'zzs_0_32_1') {
					// this.changetableval('zzs_0_25_1', 'tableDataZero', this.gettableval('zzs_0_32_1', 'tableDataZero', 'old'));
					this.changetableval('zzs_0_32_2', 'tableDataZero', this.gettableval('zzs_0_32_1', 'tableDataZero'));
				}
				if (e.cellCode == 'zzs_0_32_3') {
					this.changetableval('zzs_0_25_3', 'tableDataZero', this.gettableval('zzs_0_32_3', 'tableDataZero',
						'old'));
					this.changetableval('zzs_0_32_4', 'tableDataZero', this.gettableval('zzs_0_32_3', 'tableDataZero'));
				}
				if (e.cellCode == 'zzs_0_34_1') {
					this.changetableval(
						'zzs_5_1_1',
						'tableDataV_I',
						this.gettableval('zzs_0_34_1', 'tableDataZero') + this.gettableval('zzs_0_34_3',
							'tableDataZero')
					);
					this.changetableval(
						'zzs_5_2_1',
						'tableDataV_I',
						this.gettableval('zzs_0_34_1', 'tableDataZero') + this.gettableval('zzs_0_34_3',
							'tableDataZero')
					);
					this.changetableval(
						'zzs_5_3_1',
						'tableDataV_I',
						this.gettableval('zzs_0_34_1', 'tableDataZero') + this.gettableval('zzs_0_34_3',
							'tableDataZero')
					);
					// this.changetableval("zzs_5_11a_5", 'tableDataV_III', this.gettableval("zzs_0_34_1", "tableDataZero"))
					// this.changetableval("zzs_5_11c_5", 'tableDataV_III', this.gettableval("zzs_0_34_1", "tableDataZero"))
					// this.changetableval("zzs_5_11d_5", 'tableDataV_III', this.gettableval("zzs_0_34_1", "tableDataZero"))
				}
				if (e.cellCode == 'zzs_0_34_3') {
					this.changetableval(
						'zzs_5_1_1',
						'tableDataV_I',
						this.gettableval('zzs_0_34_1', 'tableDataZero') + this.gettableval('zzs_0_34_3',
							'tableDataZero')
					);
					this.changetableval(
						'zzs_5_2_1',
						'tableDataV_I',
						this.gettableval('zzs_0_34_1', 'tableDataZero') + this.gettableval('zzs_0_34_3',
							'tableDataZero')
					);
					this.changetableval(
						'zzs_5_3_1',
						'tableDataV_I',
						this.gettableval('zzs_0_34_1', 'tableDataZero') + this.gettableval('zzs_0_34_3',
							'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_0_35_3') {
					this.changetableval(
						'zzs_0_35_4',
						'tableDataZero',
						this.gettableval('zzs_0_35_4', 'tableDataZero', 'old') + this.gettableval('zzs_0_35_3',
							'tableDataZero'),
						'checkq'
					);
				}
				if (e.cellCode == 'zzs_0_36_1') {
					this.changetableval(
						'zzs_0_38_1',
						'tableDataZero',
						this.gettableval('zzs_0_16_1', 'tableDataZero') +
						this.gettableval('zzs_0_22_1', 'tableDataZero') +
						this.gettableval('zzs_0_36_1', 'tableDataZero') -
						this.gettableval('zzs_0_37_1', 'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_0_37_1') {
					this.changetableval(
						'zzs_0_37_2',
						'tableDataZero',
						this.gettableval('zzs_0_37_2', 'tableDataZero', 'old') + this.gettableval('zzs_0_37_1',
							'tableDataZero')
					);
					this.changetableval(
						'zzs_0_38_1',
						'tableDataZero',
						this.gettableval('zzs_0_16_1', 'tableDataZero') +
						this.gettableval('zzs_0_22_1', 'tableDataZero') +
						this.gettableval('zzs_0_36_1', 'tableDataZero') -
						this.gettableval('zzs_0_37_1', 'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_0_38_1') {
					this.changetableval('zzs_0_36_1', 'tableDataZero', this.gettableval('zzs_0_38_1', 'tableDataZero',
						'old'));
					this.changetableval('zzs_0_38_2', 'tableDataZero', this.gettableval('zzs_0_38_1', 'tableDataZero'));
				}
				if (e.cellCode == 'zzs_0_38_2') {
					this.changetableval('zzs_0_36_2', 'tableDataZero', this.gettableval('zzs_0_38_2', 'tableDataZero',
						'lastyear'));
				}
				if (e.cellCode == 'zzs_0_39_1') {
					this.changetableval(
						'zzs_0_39_2',
						'tableDataZero',
						this.gettableval('zzs_0_39_2', 'tableDataZero', 'old') + this.gettableval('zzs_0_39_1',
							'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_0_40_1') {
					this.changetableval(
						'zzs_0_40_2',
						'tableDataZero',
						this.gettableval('zzs_0_40_2', 'tableDataZero', 'old') + this.gettableval('zzs_0_40_1',
							'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_0_41_1') {
					this.changetableval(
						'zzs_0_41_2',
						'tableDataZero',
						this.gettableval('zzs_0_41_2', 'tableDataZero', 'old') + this.gettableval('zzs_0_41_1',
							'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_1_1_1') {
					this.changetableval(
						'zzs_1_1_9',
						'tableDataI',
						this.gettableval('zzs_1_1_1', 'tableDataI') +
						this.gettableval('zzs_1_1_3', 'tableDataI') +
						this.gettableval('zzs_1_1_5', 'tableDataI') +
						this.gettableval('zzs_1_1_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_1_2') {
					this.changetableval(
						'zzs_1_1_10',
						'tableDataI',
						this.gettableval('zzs_1_1_2', 'tableDataI') +
						this.gettableval('zzs_1_1_4', 'tableDataI') +
						this.gettableval('zzs_1_1_6', 'tableDataI') +
						this.gettableval('zzs_1_1_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_1_3') {
					this.changetableval(
						'zzs_1_1_9',
						'tableDataI',
						this.gettableval('zzs_1_1_1', 'tableDataI') +
						this.gettableval('zzs_1_1_3', 'tableDataI') +
						this.gettableval('zzs_1_1_5', 'tableDataI') +
						this.gettableval('zzs_1_1_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_1_4') {
					this.changetableval(
						'zzs_1_1_10',
						'tableDataI',
						this.gettableval('zzs_1_1_2', 'tableDataI') +
						this.gettableval('zzs_1_1_4', 'tableDataI') +
						this.gettableval('zzs_1_1_6', 'tableDataI') +
						this.gettableval('zzs_1_1_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_1_5') {
					this.changetableval(
						'zzs_1_1_9',
						'tableDataI',
						this.gettableval('zzs_1_1_1', 'tableDataI') +
						this.gettableval('zzs_1_1_3', 'tableDataI') +
						this.gettableval('zzs_1_1_5', 'tableDataI') +
						this.gettableval('zzs_1_1_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_1_6') {
					this.changetableval(
						'zzs_1_1_10',
						'tableDataI',
						this.gettableval('zzs_1_1_2', 'tableDataI') +
						this.gettableval('zzs_1_1_4', 'tableDataI') +
						this.gettableval('zzs_1_1_6', 'tableDataI') +
						this.gettableval('zzs_1_1_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_1_7') {
					this.changetableval(
						'zzs_1_1_9',
						'tableDataI',
						this.gettableval('zzs_1_1_1', 'tableDataI') +
						this.gettableval('zzs_1_1_3', 'tableDataI') +
						this.gettableval('zzs_1_1_5', 'tableDataI') +
						this.gettableval('zzs_1_1_7', 'tableDataI')
					);
					this.changetableval(
						'zzs_0_4_1',
						'tableDataZero',
						this.gettableval('zzs_1_1_7', 'tableDataI') +
						this.gettableval('zzs_1_2_7', 'tableDataI') +
						this.gettableval('zzs_1_3_7', 'tableDataI') +
						this.gettableval('zzs_1_4_7', 'tableDataI') +
						this.gettableval('zzs_1_5_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_1_8') {
					this.changetableval(
						'zzs_1_1_10',
						'tableDataI',
						this.gettableval('zzs_1_1_2', 'tableDataI') +
						this.gettableval('zzs_1_1_4', 'tableDataI') +
						this.gettableval('zzs_1_1_6', 'tableDataI') +
						this.gettableval('zzs_1_1_8', 'tableDataI')
					);
					// if (this.gettableval("zzs_0_16_1", 'tableDataZero') > (this.gettableval("zzs_1_1_8", 'tableDataI') +
					// 		this.gettableval("zzs_1_2_8", 'tableDataI') + this.gettableval("zzs_1_3_8", 'tableDataI') +
					// 		this.gettableval("zzs_1_4_8", 'tableDataI') + this.gettableval("zzs_1_5_8", 'tableDataI') +
					// 		this.gettableval("zzs_2_19_1", 'tableDataII_II'))) {
					// 	this.$message.error("zzs_0_16_1格子校验不正确")
					// }
				}
				if (e.cellCode == 'zzs_1_1_9') {
					this.changetableval(
						'zzs_0_1_1',
						'tableDataZero',
						this.gettableval('zzs_1_1_9', 'tableDataI') +
						this.gettableval('zzs_1_2_9', 'tableDataI') +
						this.gettableval('zzs_1_3_9', 'tableDataI') +
						this.gettableval('zzs_1_4_9', 'tableDataI') +
						this.gettableval('zzs_1_5_9', 'tableDataI') -
						(this.gettableval('zzs_1_6_9', 'tableDataI') + this.gettableval('zzs_1_7_9', 'tableDataI'))
					);
					this.changetableval(
						'zzs_0_2_1',
						'tableDataZero',
						this.gettableval('zzs_1_1_9', 'tableDataI') -
						this.gettableval('zzs_0_2_3', 'tableDataZero') -
						this.gettableval('zzs_0_3_1', 'tableDataZero')
					);
					this.changetableval(
						'zzs_8_0_11',
						'tableDataSummary_I',
						this.gettableval('zzs_1_1_9', 'tableDataI') + this.gettableval('zzs_1_3_9', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_1_10') {
					this.changetableval(
						'zzs_0_11_1',
						'tableDataZero',
						this.gettableval('zzs_1_1_10', 'tableDataI') +
						this.gettableval('zzs_1_3_10', 'tableDataI') -
						this.gettableval('zzs_1_6_10', 'tableDataI') +
						(this.gettableval('zzs_1_2_14', 'tableDataI') +
							this.gettableval('zzs_1_4_14', 'tableDataI') +
							this.gettableval('zzs_1_5_14', 'tableDataI') -
							this.gettableval('zzs_1_7_14', 'tableDataI'))
					);
					this.changetableval(
						'zzs_8_0_13',
						'tableDataSummary_I',
						this.gettableval('zzs_1_1_10', 'tableDataI') + this.gettableval('zzs_1_3_10', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_2_1') {
					this.changetableval(
						'zzs_1_2_9',
						'tableDataI',
						this.gettableval('zzs_1_2_1', 'tableDataI') +
						this.gettableval('zzs_1_2_3', 'tableDataI') +
						this.gettableval('zzs_1_2_5', 'tableDataI') +
						this.gettableval('zzs_1_2_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_2_2') {
					this.changetableval(
						'zzs_1_2_10',
						'tableDataI',
						this.gettableval('zzs_1_2_2', 'tableDataI') +
						this.gettableval('zzs_1_2_4', 'tableDataI') +
						this.gettableval('zzs_1_2_6', 'tableDataI') +
						this.gettableval('zzs_1_2_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_2_3') {
					this.changetableval(
						'zzs_1_2_9',
						'tableDataI',
						this.gettableval('zzs_1_2_1', 'tableDataI') +
						this.gettableval('zzs_1_2_3', 'tableDataI') +
						this.gettableval('zzs_1_2_5', 'tableDataI') +
						this.gettableval('zzs_1_2_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_2_4') {
					this.changetableval(
						'zzs_1_2_10',
						'tableDataI',
						this.gettableval('zzs_1_2_2', 'tableDataI') +
						this.gettableval('zzs_1_2_4', 'tableDataI') +
						this.gettableval('zzs_1_2_6', 'tableDataI') +
						this.gettableval('zzs_1_2_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_2_5') {
					this.changetableval(
						'zzs_1_2_9',
						'tableDataI',
						this.gettableval('zzs_1_2_1', 'tableDataI') +
						this.gettableval('zzs_1_2_3', 'tableDataI') +
						this.gettableval('zzs_1_2_5', 'tableDataI') +
						this.gettableval('zzs_1_2_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_2_6') {
					this.changetableval(
						'zzs_1_2_10',
						'tableDataI',
						this.gettableval('zzs_1_2_2', 'tableDataI') +
						this.gettableval('zzs_1_2_4', 'tableDataI') +
						this.gettableval('zzs_1_2_6', 'tableDataI') +
						this.gettableval('zzs_1_2_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_2_7') {
					this.changetableval(
						'zzs_0_4_1',
						'tableDataZero',
						this.gettableval('zzs_1_1_7', 'tableDataI') +
						this.gettableval('zzs_1_2_7', 'tableDataI') +
						this.gettableval('zzs_1_3_7', 'tableDataI') +
						this.gettableval('zzs_1_4_7', 'tableDataI') +
						this.gettableval('zzs_1_5_7', 'tableDataI')
					);
					this.changetableval(
						'zzs_1_2_9',
						'tableDataI',
						this.gettableval('zzs_1_2_1', 'tableDataI') +
						this.gettableval('zzs_1_2_3', 'tableDataI') +
						this.gettableval('zzs_1_2_5', 'tableDataI') +
						this.gettableval('zzs_1_2_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_2_8') {
					// if (this.gettableval("zzs_0_16_1", 'tableDataZero') > (this.gettableval("zzs_1_1_8", 'tableDataI') +
					// 		this.gettableval("zzs_1_2_8", 'tableDataI') + this.gettableval("zzs_1_3_8", 'tableDataI') +
					// 		this.gettableval("zzs_1_4_8", 'tableDataI') + this.gettableval("zzs_1_5_8", 'tableDataI') +
					// 		this.gettableval("zzs_2_19_1", 'tableDataII_II'))) {
					// 	this.$message.error("zzs_0_16_1格子校验不正确")
					// }
					this.changetableval(
						'zzs_1_2_10',
						'tableDataI',
						this.gettableval('zzs_1_2_2', 'tableDataI') +
						this.gettableval('zzs_1_2_4', 'tableDataI') +
						this.gettableval('zzs_1_2_6', 'tableDataI') +
						this.gettableval('zzs_1_2_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_2_9') {
					this.changetableval(
						'zzs_0_1_1',
						'tableDataZero',
						this.gettableval('zzs_1_1_9', 'tableDataI') +
						this.gettableval('zzs_1_2_9', 'tableDataI') +
						this.gettableval('zzs_1_3_9', 'tableDataI') +
						this.gettableval('zzs_1_4_9', 'tableDataI') +
						this.gettableval('zzs_1_5_9', 'tableDataI') -
						(this.gettableval('zzs_1_6_9', 'tableDataI') + this.gettableval('zzs_1_7_9', 'tableDataI'))
					);
					this.changetableval(
						'zzs_1_2_11',
						'tableDataI',
						this.gettableval('zzs_1_2_9', 'tableDataI') + this.gettableval('zzs_1_2_10', 'tableDataI')
					);
					this.changetableval(
						'zzs_8_0_17',
						'tableDataSummary_I',
						this.gettableval('zzs_1_2_9', 'tableDataI') +
						this.gettableval('zzs_1_4_9', 'tableDataI') +
						this.gettableval('zzs_1_5_9', 'tableDataI')
					);

				}
				if (e.cellCode == 'zzs_1_2_10') {
					this.changetableval(
						'zzs_1_2_11',
						'tableDataI',
						this.gettableval('zzs_1_2_9', 'tableDataI') + this.gettableval('zzs_1_2_10', 'tableDataI')
					);
					this.changetableval('zzs_1_2_14', 'tableDataI', this.gettableval('zzs_1_2_10', 'tableDataI'));
				}
				if (e.cellCode == 'zzs_1_2_11') {
					this.changetableval(
						'zzs_1_2_13',
						'tableDataI',
						this.gettableval('zzs_1_2_11', 'tableDataI') - this.gettableval('zzs_1_2_12', 'tableDataI')
					);
					this.changetableval('zzs_3_1_1', 'tableDataIII', this.gettableval('zzs_1_2_11', 'tableDataI'));
					this.changetableval(
						'zzs_8_0_19',
						'tableDataSummary_I',
						this.gettableval('zzs_1_2_11', 'tableDataI') +
						this.gettableval('zzs_1_4_11', 'tableDataI') +
						this.gettableval('zzs_1_5_11', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_2_12') {
					this.changetableval(
						'zzs_1_2_13',
						'tableDataI',
						this.gettableval('zzs_1_2_11', 'tableDataI') - this.gettableval('zzs_1_2_12', 'tableDataI')
					);
					this.changetableval('zzs_1_2_14', 'tableDataI', this.gettableval('zzs_1_2_10', 'tableDataI'));
				}
				if (e.cellCode == 'zzs_1_2_13') {
					this.changetableval('zzs_1_2_14', 'tableDataI', this.gettableval('zzs_1_2_10', 'tableDataI'));
				}
				if (e.cellCode == 'zzs_1_2_14') {
					this.changetableval(
						'zzs_0_11_1',
						'tableDataZero',
						this.gettableval('zzs_1_1_10', 'tableDataI') +
						this.gettableval('zzs_1_3_10', 'tableDataI') -
						this.gettableval('zzs_1_6_10', 'tableDataI') +
						(this.gettableval('zzs_1_2_14', 'tableDataI') +
							this.gettableval('zzs_1_4_14', 'tableDataI') +
							this.gettableval('zzs_1_5_14', 'tableDataI') -
							this.gettableval('zzs_1_7_14', 'tableDataI'))
					);
				}
				if (e.cellCode == 'zzs_1_3_1') {
					this.changetableval(
						'zzs_0_11_1',
						'tableDataZero',
						this.gettableval('zzs_1_1_10', 'tableDataI') +
						this.gettableval('zzs_1_3_10', 'tableDataI') -
						this.gettableval('zzs_1_6_10', 'tableDataI') +
						(this.gettableval('zzs_1_2_14', 'tableDataI') +
							this.gettableval('zzs_1_4_14', 'tableDataI') +
							this.gettableval('zzs_1_5_14', 'tableDataI') -
							this.gettableval('zzs_1_7_14', 'tableDataI'))
					);
					this.changetableval(
						'zzs_1_3_9',
						'tableDataI',
						this.gettableval('zzs_1_3_1', 'tableDataI') +
						this.gettableval('zzs_1_3_3', 'tableDataI') +
						this.gettableval('zzs_1_3_5', 'tableDataI') +
						this.gettableval('zzs_1_3_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_3_2') {
					this.changetableval(
						'zzs_1_3_10',
						'tableDataI',
						this.gettableval('zzs_1_3_2', 'tableDataI') +
						this.gettableval('zzs_1_3_4', 'tableDataI') +
						this.gettableval('zzs_1_3_6', 'tableDataI') +
						this.gettableval('zzs_1_3_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_3_3') {
					this.changetableval(
						'zzs_1_3_9',
						'tableDataI',
						this.gettableval('zzs_1_3_1', 'tableDataI') +
						this.gettableval('zzs_1_3_3', 'tableDataI') +
						this.gettableval('zzs_1_3_5', 'tableDataI') +
						this.gettableval('zzs_1_3_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_3_4') {
					this.changetableval(
						'zzs_1_3_10',
						'tableDataI',
						this.gettableval('zzs_1_3_2', 'tableDataI') +
						this.gettableval('zzs_1_3_4', 'tableDataI') +
						this.gettableval('zzs_1_3_6', 'tableDataI') +
						this.gettableval('zzs_1_3_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_3_5') {
					this.changetableval(
						'zzs_1_3_9',
						'tableDataI',
						this.gettableval('zzs_1_3_1', 'tableDataI') +
						this.gettableval('zzs_1_3_3', 'tableDataI') +
						this.gettableval('zzs_1_3_5', 'tableDataI') +
						this.gettableval('zzs_1_3_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_3_6') {
					this.changetableval(
						'zzs_1_3_10',
						'tableDataI',
						this.gettableval('zzs_1_3_2', 'tableDataI') +
						this.gettableval('zzs_1_3_4', 'tableDataI') +
						this.gettableval('zzs_1_3_6', 'tableDataI') +
						this.gettableval('zzs_1_3_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_3_7') {
					this.changetableval(
						'zzs_0_4_1',
						'tableDataZero',
						this.gettableval('zzs_1_1_7', 'tableDataI') +
						this.gettableval('zzs_1_2_7', 'tableDataI') +
						this.gettableval('zzs_1_3_7', 'tableDataI') +
						this.gettableval('zzs_1_4_7', 'tableDataI') +
						this.gettableval('zzs_1_5_7', 'tableDataI')
					);
					this.changetableval(
						'zzs_1_3_9',
						'tableDataI',
						this.gettableval('zzs_1_3_1', 'tableDataI') +
						this.gettableval('zzs_1_3_3', 'tableDataI') +
						this.gettableval('zzs_1_3_5', 'tableDataI') +
						this.gettableval('zzs_1_3_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_3_8') {
					// if (this.gettableval("zzs_0_16_1", 'tableDataZero') > (this.gettableval("zzs_1_1_8", 'tableDataI') +
					// 		this.gettableval("zzs_1_2_8", 'tableDataI') + this.gettableval("zzs_1_3_8", 'tableDataI') +
					// 		this.gettableval("zzs_1_4_8", 'tableDataI') + this.gettableval("zzs_1_5_8", 'tableDataI') +
					// 		this.gettableval("zzs_2_19_1", 'tableDataII_II'))) {
					// 	this.$message.error("zzs_0_16_1格子校验不正确")
					// }
					this.changetableval(
						'zzs_1_3_10',
						'tableDataI',
						this.gettableval('zzs_1_3_2', 'tableDataI') +
						this.gettableval('zzs_1_3_4', 'tableDataI') +
						this.gettableval('zzs_1_3_6', 'tableDataI') +
						this.gettableval('zzs_1_3_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_3_9') {
					this.changetableval(
						'zzs_0_1_1',
						'tableDataZero',
						this.gettableval('zzs_1_1_9', 'tableDataI') +
						this.gettableval('zzs_1_2_9', 'tableDataI') +
						this.gettableval('zzs_1_3_9', 'tableDataI') +
						this.gettableval('zzs_1_4_9', 'tableDataI') +
						this.gettableval('zzs_1_5_9', 'tableDataI') -
						(this.gettableval('zzs_1_6_9', 'tableDataI') + this.gettableval('zzs_1_7_9', 'tableDataI'))
					);
					this.changetableval(
						'zzs_8_0_11',
						'tableDataSummary_I',
						this.gettableval('zzs_1_1_9', 'tableDataI') + this.gettableval('zzs_1_3_9', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_3_10') {
					this.changetableval(
						'zzs_0_11_1',
						'tableDataZero',
						this.gettableval('zzs_1_1_10', 'tableDataI') +
						this.gettableval('zzs_1_3_10', 'tableDataI') -
						this.gettableval('zzs_1_6_10', 'tableDataI') +
						(this.gettableval('zzs_1_2_14', 'tableDataI') +
							this.gettableval('zzs_1_4_14', 'tableDataI') +
							this.gettableval('zzs_1_5_14', 'tableDataI') -
							this.gettableval('zzs_1_7_14', 'tableDataI'))
					);
					this.changetableval(
						'zzs_8_0_13',
						'tableDataSummary_I',
						this.gettableval('zzs_1_1_10', 'tableDataI') + this.gettableval('zzs_1_3_10', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_4_1') {
					this.changetableval(
						'zzs_1_4_9',
						'tableDataI',
						this.gettableval('zzs_1_4_1', 'tableDataI') +
						this.gettableval('zzs_1_4_3', 'tableDataI') +
						this.gettableval('zzs_1_4_5', 'tableDataI') +
						this.gettableval('zzs_1_4_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_4_2') {
					this.changetableval(
						'zzs_1_4_10',
						'tableDataI',
						this.gettableval('zzs_1_4_2', 'tableDataI') +
						this.gettableval('zzs_1_4_4', 'tableDataI') +
						this.gettableval('zzs_1_4_6', 'tableDataI') +
						this.gettableval('zzs_1_4_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_4_3') {
					this.changetableval(
						'zzs_1_4_9',
						'tableDataI',
						this.gettableval('zzs_1_4_1', 'tableDataI') +
						this.gettableval('zzs_1_4_3', 'tableDataI') +
						this.gettableval('zzs_1_4_5', 'tableDataI') +
						this.gettableval('zzs_1_4_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_4_4') {
					this.changetableval(
						'zzs_1_4_10',
						'tableDataI',
						this.gettableval('zzs_1_4_2', 'tableDataI') +
						this.gettableval('zzs_1_4_4', 'tableDataI') +
						this.gettableval('zzs_1_4_6', 'tableDataI') +
						this.gettableval('zzs_1_4_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_4_5') {
					this.changetableval(
						'zzs_1_4_9',
						'tableDataI',
						this.gettableval('zzs_1_4_1', 'tableDataI') +
						this.gettableval('zzs_1_4_3', 'tableDataI') +
						this.gettableval('zzs_1_4_5', 'tableDataI') +
						this.gettableval('zzs_1_4_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_4_6') {
					this.changetableval(
						'zzs_1_4_10',
						'tableDataI',
						this.gettableval('zzs_1_4_2', 'tableDataI') +
						this.gettableval('zzs_1_4_4', 'tableDataI') +
						this.gettableval('zzs_1_4_6', 'tableDataI') +
						this.gettableval('zzs_1_4_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_4_7') {
					this.changetableval(
						'zzs_1_4_9',
						'tableDataI',
						this.gettableval('zzs_1_4_1', 'tableDataI') +
						this.gettableval('zzs_1_4_3', 'tableDataI') +
						this.gettableval('zzs_1_4_5', 'tableDataI') +
						this.gettableval('zzs_1_4_7', 'tableDataI')
					);
					this.changetableval(
						'zzs_0_4_1',
						'tableDataZero',
						this.gettableval('zzs_1_1_7', 'tableDataI') +
						this.gettableval('zzs_1_2_7', 'tableDataI') +
						this.gettableval('zzs_1_3_7', 'tableDataI') +
						this.gettableval('zzs_1_4_7', 'tableDataI') +
						this.gettableval('zzs_1_5_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_4_8') {
					this.changetableval(
						'zzs_1_4_10',
						'tableDataI',
						this.gettableval('zzs_1_4_2', 'tableDataI') +
						this.gettableval('zzs_1_4_4', 'tableDataI') +
						this.gettableval('zzs_1_4_6', 'tableDataI') +
						this.gettableval('zzs_1_4_8', 'tableDataI')
					);
					// if (this.gettableval("zzs_0_16_1", 'tableDataZero') > (this.gettableval("zzs_1_1_8", 'tableDataI') +
					// 		this.gettableval("zzs_1_2_8", 'tableDataI') + this.gettableval("zzs_1_3_8", 'tableDataI') +
					// 		this.gettableval("zzs_1_4_8", 'tableDataI') + this.gettableval("zzs_1_5_8", 'tableDataI') +
					// 		this.gettableval("zzs_2_19_1", 'tableDataII_II'))) {
					// 	this.$message.error("zzs_0_16_1格子校验不正确")
					// }
				}
				if (e.cellCode == 'zzs_1_4_9') {
					this.changetableval(
						'zzs_0_1_1',
						'tableDataZero',
						this.gettableval('zzs_1_1_9', 'tableDataI') +
						this.gettableval('zzs_1_2_9', 'tableDataI') +
						this.gettableval('zzs_1_3_9', 'tableDataI') +
						this.gettableval('zzs_1_4_9', 'tableDataI') +
						this.gettableval('zzs_1_5_9', 'tableDataI') -
						(this.gettableval('zzs_1_6_9', 'tableDataI') + this.gettableval('zzs_1_7_9', 'tableDataI'))
					);
					this.changetableval(
						'zzs_1_4_11',
						'tableDataI',
						this.gettableval('zzs_1_4_9', 'tableDataI') + this.gettableval('zzs_1_4_10', 'tableDataI')
					);
					this.changetableval(
						'zzs_8_0_17',
						'tableDataSummary_I',
						this.gettableval('zzs_1_2_9', 'tableDataI') +
						this.gettableval('zzs_1_4_9', 'tableDataI') +
						this.gettableval('zzs_1_5_9', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_4_10') {
					this.changetableval(
						'zzs_1_4_11',
						'tableDataI',
						this.gettableval('zzs_1_4_9', 'tableDataI') + this.gettableval('zzs_1_4_10', 'tableDataI')
					);
					this.changetableval('zzs_1_4_14', 'tableDataI', this.gettableval('zzs_1_4_10', 'tableDataI'));
				}
				if (e.cellCode == 'zzs_1_4_11') {
					this.changetableval(
						'zzs_1_4_13',
						'tableDataI',
						this.gettableval('zzs_1_4_11', 'tableDataI') - this.gettableval('zzs_1_4_12', 'tableDataI')
					);
					this.changetableval('zzs_3_2_1', 'tableDataIII', this.gettableval('zzs_1_4_11', 'tableDataI'));
					this.changetableval(
						'zzs_8_0_19',
						'tableDataSummary_I',
						this.gettableval('zzs_1_2_11', 'tableDataI') +
						this.gettableval('zzs_1_4_11', 'tableDataI') +
						this.gettableval('zzs_1_5_11', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_4_12') {
					this.changetableval(
						'zzs_1_4_13',
						'tableDataI',
						this.gettableval('zzs_1_4_11', 'tableDataI') - this.gettableval('zzs_1_4_12', 'tableDataI')
					);
					this.changetableval('zzs_1_4_14', 'tableDataI', this.gettableval('zzs_1_4_10', 'tableDataI'));
				}
				if (e.cellCode == 'zzs_1_4_13') {
					this.changetableval('zzs_1_4_14', 'tableDataI', this.gettableval('zzs_1_4_10', 'tableDataI'));
				}
				if (e.cellCode == 'zzs_1_4_14') {
					this.changetableval(
						'zzs_0_11_1',
						'tableDataZero',
						this.gettableval('zzs_1_1_10', 'tableDataI') +
						this.gettableval('zzs_1_3_10', 'tableDataI') -
						this.gettableval('zzs_1_6_10', 'tableDataI') +
						(this.gettableval('zzs_1_2_14', 'tableDataI') +
							this.gettableval('zzs_1_4_14', 'tableDataI') +
							this.gettableval('zzs_1_5_14', 'tableDataI') -
							this.gettableval('zzs_1_7_14', 'tableDataI'))
					);
				}
				if (e.cellCode == 'zzs_1_5_1') {
					this.changetableval(
						'zzs_1_5_9',
						'tableDataI',
						this.gettableval('zzs_1_5_1', 'tableDataI') +
						this.gettableval('zzs_1_5_3', 'tableDataI') +
						this.gettableval('zzs_1_5_5', 'tableDataI') +
						this.gettableval('zzs_1_5_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_5_2') {
					this.changetableval(
						'zzs_1_5_10',
						'tableDataI',
						this.gettableval('zzs_1_5_2', 'tableDataI') +
						this.gettableval('zzs_1_5_4', 'tableDataI') +
						this.gettableval('zzs_1_5_6', 'tableDataI') +
						this.gettableval('zzs_1_5_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_5_3') {
					this.changetableval(
						'zzs_1_5_9',
						'tableDataI',
						this.gettableval('zzs_1_5_1', 'tableDataI') +
						this.gettableval('zzs_1_5_3', 'tableDataI') +
						this.gettableval('zzs_1_5_5', 'tableDataI') +
						this.gettableval('zzs_1_5_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_5_4') {
					this.changetableval(
						'zzs_1_5_10',
						'tableDataI',
						this.gettableval('zzs_1_5_2', 'tableDataI') +
						this.gettableval('zzs_1_5_4', 'tableDataI') +
						this.gettableval('zzs_1_5_6', 'tableDataI') +
						this.gettableval('zzs_1_5_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_5_5') {
					this.changetableval(
						'zzs_1_5_9',
						'tableDataI',
						this.gettableval('zzs_1_5_1', 'tableDataI') +
						this.gettableval('zzs_1_5_3', 'tableDataI') +
						this.gettableval('zzs_1_5_5', 'tableDataI') +
						this.gettableval('zzs_1_5_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_5_6') {
					this.changetableval(
						'zzs_1_5_10',
						'tableDataI',
						this.gettableval('zzs_1_5_2', 'tableDataI') +
						this.gettableval('zzs_1_5_4', 'tableDataI') +
						this.gettableval('zzs_1_5_6', 'tableDataI') +
						this.gettableval('zzs_1_5_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_5_7') {
					this.changetableval(
						'zzs_0_4_1',
						'tableDataZero',
						this.gettableval('zzs_1_1_7', 'tableDataI') +
						this.gettableval('zzs_1_2_7', 'tableDataI') +
						this.gettableval('zzs_1_3_7', 'tableDataI') +
						this.gettableval('zzs_1_4_7', 'tableDataI') +
						this.gettableval('zzs_1_5_7', 'tableDataI')
					);
					this.changetableval(
						'zzs_1_5_9',
						'tableDataI',
						this.gettableval('zzs_1_5_1', 'tableDataI') +
						this.gettableval('zzs_1_5_3', 'tableDataI') +
						this.gettableval('zzs_1_5_5', 'tableDataI') +
						this.gettableval('zzs_1_5_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_5_8') {
					// if (this.gettableval("zzs_0_16_1", 'tableDataZero') > (this.gettableval("zzs_1_1_8", 'tableDataI') +
					// 		this.gettableval("zzs_1_2_8", 'tableDataI') + this.gettableval("zzs_1_3_8", 'tableDataI') +
					// 		this.gettableval("zzs_1_4_8", 'tableDataI') + this.gettableval("zzs_1_5_8", 'tableDataI') +
					// 		this.gettableval("zzs_2_19_1", 'tableDataII_II'))) {
					// 	this.$message.error("zzs_0_16_1格子校验不正确")
					// }
					this.changetableval(
						'zzs_1_5_10',
						'tableDataI',
						this.gettableval('zzs_1_5_2', 'tableDataI') +
						this.gettableval('zzs_1_5_4', 'tableDataI') +
						this.gettableval('zzs_1_5_6', 'tableDataI') +
						this.gettableval('zzs_1_5_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_5_9') {
					this.changetableval(
						'zzs_0_1_1',
						'tableDataZero',
						this.gettableval('zzs_1_1_9', 'tableDataI') +
						this.gettableval('zzs_1_2_9', 'tableDataI') +
						this.gettableval('zzs_1_3_9', 'tableDataI') +
						this.gettableval('zzs_1_4_9', 'tableDataI') +
						this.gettableval('zzs_1_5_9', 'tableDataI') -
						(this.gettableval('zzs_1_6_9', 'tableDataI') + this.gettableval('zzs_1_7_9', 'tableDataI'))
					);
					this.changetableval(
						'zzs_1_5_11',
						'tableDataI',
						this.gettableval('zzs_1_5_9', 'tableDataI') + this.gettableval('zzs_1_5_10', 'tableDataI')
					);
					this.changetableval(
						'zzs_8_0_17',
						'tableDataSummary_I',
						this.gettableval('zzs_1_2_9', 'tableDataI') +
						this.gettableval('zzs_1_4_9', 'tableDataI') +
						this.gettableval('zzs_1_5_9', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_5_10') {
					this.changetableval(
						'zzs_1_5_11',
						'tableDataI',
						this.gettableval('zzs_1_5_9', 'tableDataI') + this.gettableval('zzs_1_5_10', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_5_11') {
					this.changetableval(
						'zzs_1_5_13',
						'tableDataI',
						this.gettableval('zzs_1_5_11', 'tableDataI') - this.gettableval('zzs_1_5_12', 'tableDataI')
					);
					this.changetableval('zzs_3_3_1', 'tableDataIII', this.gettableval('zzs_1_5_11', 'tableDataI'));
					this.changetableval(
						'zzs_8_0_19',
						'tableDataSummary_I',
						this.gettableval('zzs_1_2_11', 'tableDataI') +
						this.gettableval('zzs_1_4_11', 'tableDataI') +
						this.gettableval('zzs_1_5_11', 'tableDataI')
					);
					// if (this.gettableval("zzs_3_3_1", 'tableDataIII') + this.gettableval("zzs_3_4_1", 'tableDataIII') !=
					// 	this.gettableval("zzs_1_5_11", 'tableDataI')) {
					// 	this.$message.error("zzs_3_3_1格子校验不正确")
					// }
					// if (this.gettableval("zzs_3_3_1", 'tableDataIII') + this.gettableval("zzs_3_4_1", 'tableDataIII') !=
					// 	this.gettableval("zzs_1_5_11", 'tableDataI')) {
					// 	this.$message.error("zzs_3_4_1格子校验不正确")
					// }
				}
				if (e.cellCode == 'zzs_1_5_12') {
					this.changetableval(
						'zzs_1_5_13',
						'tableDataI',
						this.gettableval('zzs_1_5_11', 'tableDataI') - this.gettableval('zzs_1_5_12', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_5_13') {
					this.changetableval('zzs_1_5_14', 'tableDataI', this.gettableval('zzs_1_5_10', 'tableDataI'));
				}
				if (e.cellCode == 'zzs_1_5_14') {
					this.changetableval(
						'zzs_0_11_1',
						'tableDataZero',
						this.gettableval('zzs_1_1_10', 'tableDataI') +
						this.gettableval('zzs_1_3_10', 'tableDataI') -
						this.gettableval('zzs_1_6_10', 'tableDataI') +
						(this.gettableval('zzs_1_2_14', 'tableDataI') +
							this.gettableval('zzs_1_4_14', 'tableDataI') +
							this.gettableval('zzs_1_5_14', 'tableDataI') -
							this.gettableval('zzs_1_7_14', 'tableDataI'))
					);
				}
				if (e.cellCode == 'zzs_1_6_9') {
					this.changetableval(
						'zzs_0_1_1',
						'tableDataZero',
						this.gettableval('zzs_1_1_9', 'tableDataI') +
						this.gettableval('zzs_1_2_9', 'tableDataI') +
						this.gettableval('zzs_1_3_9', 'tableDataI') +
						this.gettableval('zzs_1_4_9', 'tableDataI') +
						this.gettableval('zzs_1_5_9', 'tableDataI') -
						(this.gettableval('zzs_1_6_9', 'tableDataI') + this.gettableval('zzs_1_7_9', 'tableDataI'))
					);
					this.changetableval(
						'zzs_0_1_3',
						'tableDataZero',
						this.gettableval('zzs_1_6_9', 'tableDataI') + this.gettableval('zzs_1_7_9', 'tableDataI')
					);
					this.changetableval('zzs_8_0_14', 'tableDataSummary_I', this.gettableval('zzs_1_6_9', 'tableDataI'));
				}
				if (e.cellCode == 'zzs_1_6_10') {
					this.changetableval(
						'zzs_0_11_3',
						'tableDataZero',
						this.gettableval('zzs_1_6_10', 'tableDataI') + this.gettableval('zzs_1_7_14', 'tableDataI')
					);
					this.changetableval(
						'zzs_0_11_1',
						'tableDataZero',
						this.gettableval('zzs_1_1_10', 'tableDataI') +
						this.gettableval('zzs_1_3_10', 'tableDataI') -
						this.gettableval('zzs_1_6_10', 'tableDataI') +
						(this.gettableval('zzs_1_2_14', 'tableDataI') +
							this.gettableval('zzs_1_4_14', 'tableDataI') +
							this.gettableval('zzs_1_5_14', 'tableDataI') -
							this.gettableval('zzs_1_7_14', 'tableDataI'))
					);
					// this.changetableval("zzs_8_0_16", 'tableDataSummary_I', this.gettableval("zzs_1_6_10", 'tableDataI'))
				}
				if (e.cellCode == 'zzs_1_7_9') {
					this.changetableval(
						'zzs_0_1_1',
						'tableDataZero',
						this.gettableval('zzs_1_1_9', 'tableDataI') +
						this.gettableval('zzs_1_2_9', 'tableDataI') +
						this.gettableval('zzs_1_3_9', 'tableDataI') +
						this.gettableval('zzs_1_4_9', 'tableDataI') +
						this.gettableval('zzs_1_5_9', 'tableDataI') -
						(this.gettableval('zzs_1_6_9', 'tableDataI') + this.gettableval('zzs_1_7_9', 'tableDataI'))
					);
					this.changetableval(
						'zzs_0_1_3',
						'tableDataZero',
						this.gettableval('zzs_1_6_9', 'tableDataI') + this.gettableval('zzs_1_7_9', 'tableDataI')
					);
					this.changetableval(
						'zzs_1_7_11',
						'tableDataI',
						this.gettableval('zzs_1_7_9', 'tableDataI') + this.gettableval('zzs_1_7_10', 'tableDataI')
					);
					this.changetableval('zzs_8_0_20', 'tableDataSummary_I', this.gettableval('zzs_1_7_9', 'tableDataI'));
				}
				if (e.cellCode == 'zzs_1_7_10') {
					this.changetableval(
						'zzs_1_7_11',
						'tableDataI',
						this.gettableval('zzs_1_7_9', 'tableDataI') + this.gettableval('zzs_1_7_10', 'tableDataI')
					);
					this.changetableval('zzs_8_0_22', 'tableDataSummary_I', this.gettableval('zzs_1_7_10', 'tableDataI'));
				}
				if (e.cellCode == 'zzs_1_7_14') {
					this.changetableval(
						'zzs_0_11_1',
						'tableDataZero',
						this.gettableval('zzs_1_1_10', 'tableDataI') +
						this.gettableval('zzs_1_3_10', 'tableDataI') -
						this.gettableval('zzs_1_6_10', 'tableDataI') +
						(this.gettableval('zzs_1_2_14', 'tableDataI') +
							this.gettableval('zzs_1_4_14', 'tableDataI') +
							this.gettableval('zzs_1_5_14', 'tableDataI') -
							this.gettableval('zzs_1_7_14', 'tableDataI'))
					);
					this.changetableval(
						'zzs_0_11_3',
						'tableDataZero',
						this.gettableval('zzs_1_6_10', 'tableDataI') + this.gettableval('zzs_1_7_14', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_8_1') {
					this.changetableval(
						'zzs_1_8_9',
						'tableDataI',
						this.gettableval('zzs_1_8_1', 'tableDataI') +
						this.gettableval('zzs_1_8_3', 'tableDataI') +
						this.gettableval('zzs_1_8_5', 'tableDataI') +
						this.gettableval('zzs_1_8_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_8_2') {
					this.changetableval(
						'zzs_1_8_10',
						'tableDataI',
						this.gettableval('zzs_1_8_2', 'tableDataI') +
						this.gettableval('zzs_1_8_4', 'tableDataI') +
						this.gettableval('zzs_1_8_6', 'tableDataI') +
						this.gettableval('zzs_1_8_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_8_3') {
					this.changetableval(
						'zzs_1_8_9',
						'tableDataI',
						this.gettableval('zzs_1_8_1', 'tableDataI') +
						this.gettableval('zzs_1_8_3', 'tableDataI') +
						this.gettableval('zzs_1_8_5', 'tableDataI') +
						this.gettableval('zzs_1_8_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_8_4') {
					this.changetableval(
						'zzs_1_8_10',
						'tableDataI',
						this.gettableval('zzs_1_8_2', 'tableDataI') +
						this.gettableval('zzs_1_8_4', 'tableDataI') +
						this.gettableval('zzs_1_8_6', 'tableDataI') +
						this.gettableval('zzs_1_8_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_8_5') {
					this.changetableval(
						'zzs_1_8_9',
						'tableDataI',
						this.gettableval('zzs_1_8_1', 'tableDataI') +
						this.gettableval('zzs_1_8_3', 'tableDataI') +
						this.gettableval('zzs_1_8_5', 'tableDataI') +
						this.gettableval('zzs_1_8_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_8_6') {
					this.changetableval(
						'zzs_1_8_10',
						'tableDataI',
						this.gettableval('zzs_1_8_2', 'tableDataI') +
						this.gettableval('zzs_1_8_4', 'tableDataI') +
						this.gettableval('zzs_1_8_6', 'tableDataI') +
						this.gettableval('zzs_1_8_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_8_7') {
					this.changetableval(
						'zzs_1_8_9',
						'tableDataI',
						this.gettableval('zzs_1_8_1', 'tableDataI') +
						this.gettableval('zzs_1_8_3', 'tableDataI') +
						this.gettableval('zzs_1_8_5', 'tableDataI') +
						this.gettableval('zzs_1_8_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_8_8') {
					this.changetableval(
						'zzs_1_8_10',
						'tableDataI',
						this.gettableval('zzs_1_8_2', 'tableDataI') +
						this.gettableval('zzs_1_8_4', 'tableDataI') +
						this.gettableval('zzs_1_8_6', 'tableDataI') +
						this.gettableval('zzs_1_8_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_8_9') {
					// if (this.gettableval("zzs_0_5_1", 'tableDataZero') < (this.gettableval("zzs_1_8_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_9a_9", 'tableDataI') + this.gettableval("zzs_1_9b_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_10_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_11_9", 'tableDataI') + this.gettableval("zzs_1_12_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_13a_9", 'tableDataI') + this.gettableval("zzs_1_13b_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_13c_9", 'tableDataI') -
					// 		this.gettableval("zzs_1_14_9", 'tableDataI') - this.gettableval("zzs_1_15_9", 'tableDataI'))) {
					// 	this.$message.error("zzs_0_5_1格子校验不正确")
					// }
				}
				if (e.cellCode == 'zzs_1_8_10') {
					this.changetableval(
						'zzs_0_21_1',
						'tableDataZero',
						this.gettableval('zzs_1_8_10', 'tableDataI') +
						this.gettableval('zzs_1_9a_10', 'tableDataI') +
						this.gettableval('zzs_1_10_10', 'tableDataI') +
						this.gettableval('zzs_1_11_10', 'tableDataI') -
						this.gettableval('zzs_1_14_10', 'tableDataI') +
						this.gettableval('zzs_1_9b_14', 'tableDataI') +
						this.gettableval('zzs_1_12_14', 'tableDataI') +
						this.gettableval('zzs_1_13a_14', 'tableDataI') +
						this.gettableval('zzs_1_13b_14', 'tableDataI') -
						this.gettableval('zzs_1_15_14', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_9a_1') {
					this.changetableval(
						'zzs_1_9a_9',
						'tableDataI',
						this.gettableval('zzs_1_9a_1', 'tableDataI') +
						this.gettableval('zzs_1_9a_3', 'tableDataI') +
						this.gettableval('zzs_1_9a_5', 'tableDataI') +
						this.gettableval('zzs_1_9a_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_9a_2') {
					this.changetableval(
						'zzs_1_9a_10',
						'tableDataI',
						this.gettableval('zzs_1_9a_2', 'tableDataI') +
						this.gettableval('zzs_1_9a_4', 'tableDataI') +
						this.gettableval('zzs_1_9a_6', 'tableDataI') +
						this.gettableval('zzs_1_9a_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_9a_3') {
					this.changetableval(
						'zzs_1_9a_9',
						'tableDataI',
						this.gettableval('zzs_1_9a_1', 'tableDataI') +
						this.gettableval('zzs_1_9a_3', 'tableDataI') +
						this.gettableval('zzs_1_9a_5', 'tableDataI') +
						this.gettableval('zzs_1_9a_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_9a_4') {
					this.changetableval(
						'zzs_1_9a_10',
						'tableDataI',
						this.gettableval('zzs_1_9a_2', 'tableDataI') +
						this.gettableval('zzs_1_9a_4', 'tableDataI') +
						this.gettableval('zzs_1_9a_6', 'tableDataI') +
						this.gettableval('zzs_1_9a_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_9a_5') {
					this.changetableval(
						'zzs_1_9a_9',
						'tableDataI',
						this.gettableval('zzs_1_9a_1', 'tableDataI') +
						this.gettableval('zzs_1_9a_3', 'tableDataI') +
						this.gettableval('zzs_1_9a_5', 'tableDataI') +
						this.gettableval('zzs_1_9a_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_9a_6') {
					this.changetableval(
						'zzs_1_9a_10',
						'tableDataI',
						this.gettableval('zzs_1_9a_2', 'tableDataI') +
						this.gettableval('zzs_1_9a_4', 'tableDataI') +
						this.gettableval('zzs_1_9a_6', 'tableDataI') +
						this.gettableval('zzs_1_9a_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_9a_7') {
					this.changetableval(
						'zzs_1_9a_9',
						'tableDataI',
						this.gettableval('zzs_1_9a_1', 'tableDataI') +
						this.gettableval('zzs_1_9a_3', 'tableDataI') +
						this.gettableval('zzs_1_9a_5', 'tableDataI') +
						this.gettableval('zzs_1_9a_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_9a_8') {
					this.changetableval(
						'zzs_1_9a_10',
						'tableDataI',
						this.gettableval('zzs_1_9a_2', 'tableDataI') +
						this.gettableval('zzs_1_9a_4', 'tableDataI') +
						this.gettableval('zzs_1_9a_6', 'tableDataI') +
						this.gettableval('zzs_1_9a_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_9a_9') {
					// if (this.gettableval("zzs_0_5_1", 'tableDataZero') < (this.gettableval("zzs_1_8_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_9a_9", 'tableDataI') + this.gettableval("zzs_1_9b_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_10_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_11_9", 'tableDataI') + this.gettableval("zzs_1_12_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_13a_9", 'tableDataI') + this.gettableval("zzs_1_13b_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_13c_9", 'tableDataI') -
					// 		-this.gettableval("zzs_1_14_9", 'tableDataI') - this.gettableval("zzs_1_15_9", 'tableDataI')
					// 	)) {
					// 	this.$message.error("zzs_0_5_1格子校验不正确")
					// }
				}
				if (e.cellCode == 'zzs_1_9a_10') {
					this.changetableval(
						'zzs_0_21_1',
						'tableDataZero',
						this.gettableval('zzs_1_8_10', 'tableDataI') +
						this.gettableval('zzs_1_9a_10', 'tableDataI') +
						this.gettableval('zzs_1_10_10', 'tableDataI') +
						this.gettableval('zzs_1_11_10', 'tableDataI') -
						this.gettableval('zzs_1_14_10', 'tableDataI') +
						this.gettableval('zzs_1_9b_14', 'tableDataI') +
						this.gettableval('zzs_1_12_14', 'tableDataI') +
						this.gettableval('zzs_1_13a_14', 'tableDataI') +
						this.gettableval('zzs_1_13b_14', 'tableDataI') -
						this.gettableval('zzs_1_15_14', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_9b_1') {
					this.changetableval(
						'zzs_1_9b_9',
						'tableDataI',
						this.gettableval('zzs_1_9b_1', 'tableDataI') +
						this.gettableval('zzs_1_9b_3', 'tableDataI') +
						this.gettableval('zzs_1_9b_5', 'tableDataI') +
						this.gettableval('zzs_1_9b_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_9b_2') {
					this.changetableval(
						'zzs_1_9b_10',
						'tableDataI',
						this.gettableval('zzs_1_9b_2', 'tableDataI') +
						this.gettableval('zzs_1_9b_4', 'tableDataI') +
						this.gettableval('zzs_1_9b_6', 'tableDataI') +
						this.gettableval('zzs_1_9b_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_9b_3') {
					this.changetableval(
						'zzs_1_9b_9',
						'tableDataI',
						this.gettableval('zzs_1_9b_1', 'tableDataI') +
						this.gettableval('zzs_1_9b_3', 'tableDataI') +
						this.gettableval('zzs_1_9b_5', 'tableDataI') +
						this.gettableval('zzs_1_9b_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_9b_4') {
					this.changetableval(
						'zzs_1_9b_10',
						'tableDataI',
						this.gettableval('zzs_1_9b_2', 'tableDataI') +
						this.gettableval('zzs_1_9b_4', 'tableDataI') +
						this.gettableval('zzs_1_9b_6', 'tableDataI') +
						this.gettableval('zzs_1_9b_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_9b_5') {
					this.changetableval(
						'zzs_1_9b_9',
						'tableDataI',
						this.gettableval('zzs_1_9b_1', 'tableDataI') +
						this.gettableval('zzs_1_9b_3', 'tableDataI') +
						this.gettableval('zzs_1_9b_5', 'tableDataI') +
						this.gettableval('zzs_1_9b_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_9b_6') {
					this.changetableval(
						'zzs_1_9b_10',
						'tableDataI',
						this.gettableval('zzs_1_9b_2', 'tableDataI') +
						this.gettableval('zzs_1_9b_4', 'tableDataI') +
						this.gettableval('zzs_1_9b_6', 'tableDataI') +
						this.gettableval('zzs_1_9b_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_9b_7') {
					this.changetableval(
						'zzs_1_9b_9',
						'tableDataI',
						this.gettableval('zzs_1_9b_1', 'tableDataI') +
						this.gettableval('zzs_1_9b_3', 'tableDataI') +
						this.gettableval('zzs_1_9b_5', 'tableDataI') +
						this.gettableval('zzs_1_9b_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_9b_8') {
					this.changetableval(
						'zzs_1_9b_10',
						'tableDataI',
						this.gettableval('zzs_1_9b_2', 'tableDataI') +
						this.gettableval('zzs_1_9b_4', 'tableDataI') +
						this.gettableval('zzs_1_9b_6', 'tableDataI') +
						this.gettableval('zzs_1_9b_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_9b_9') {
					this.changetableval(
						'zzs_1_9b_11',
						'tableDataI',
						this.gettableval('zzs_1_9b_9', 'tableDataI') + this.gettableval('zzs_1_9b_10', 'tableDataI')
					);
					// if (this.gettableval("zzs_0_5_1", 'tableDataZero') < (this.gettableval("zzs_1_8_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_9a_9", 'tableDataI') + this.gettableval("zzs_1_9b_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_10_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_11_9", 'tableDataI') + this.gettableval("zzs_1_12_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_13a_9", 'tableDataI') + this.gettableval("zzs_1_13b_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_13c_9", 'tableDataI') -
					// 		this.gettableval("zzs_1_14_9", 'tableDataI') - this.gettableval("zzs_1_15_9", 'tableDataI'))) {
					// 	this.$message.error("zzs_0_5_1格子校验不正确")
					// }
				}
				if (e.cellCode == 'zzs_1_9b_10') {
					this.changetableval(
						'zzs_1_9b_11',
						'tableDataI',
						this.gettableval('zzs_1_9b_9', 'tableDataI') + this.gettableval('zzs_1_9b_10', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_9b_11') {
					this.changetableval(
						'zzs_1_9b_13',
						'tableDataI',
						this.gettableval('zzs_1_9b_11', 'tableDataI') - this.gettableval('zzs_1_9b_12', 'tableDataI')
					);
					this.changetableval('zzs_3_5_1', 'tableDataIII', this.gettableval('zzs_1_9b_11', 'tableDataI'));
				}
				if (e.cellCode == 'zzs_1_9b_12') {
					this.changetableval(
						'zzs_1_9b_13',
						'tableDataI',
						this.gettableval('zzs_1_9b_11', 'tableDataI') - this.gettableval('zzs_1_9b_12', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_9b_13') {
					this.changetableval('zzs_1_9b_14', 'tableDataI', this.gettableval('zzs_1_9b_10', 'tableDataI'));
				}
				if (e.cellCode == 'zzs_1_9b_14') {
					this.changetableval(
						'zzs_0_21_1',
						'tableDataZero',
						this.gettableval('zzs_1_8_10', 'tableDataI') +
						this.gettableval('zzs_1_9a_10', 'tableDataI') +
						this.gettableval('zzs_1_10_10', 'tableDataI') +
						this.gettableval('zzs_1_11_10', 'tableDataI') -
						this.gettableval('zzs_1_14_10', 'tableDataI') +
						this.gettableval('zzs_1_9b_14', 'tableDataI') +
						this.gettableval('zzs_1_12_14', 'tableDataI') +
						this.gettableval('zzs_1_13a_14', 'tableDataI') +
						this.gettableval('zzs_1_13b_14', 'tableDataI') -
						this.gettableval('zzs_1_15_14', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_10_1') {
					this.changetableval(
						'zzs_1_10_9',
						'tableDataI',
						this.gettableval('zzs_1_10_1', 'tableDataI') +
						this.gettableval('zzs_1_10_3', 'tableDataI') +
						this.gettableval('zzs_1_10_5', 'tableDataI') +
						this.gettableval('zzs_1_10_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_10_2') {
					this.changetableval(
						'zzs_1_10_10',
						'tableDataI',
						this.gettableval('zzs_1_10_2', 'tableDataI') +
						this.gettableval('zzs_1_10_4', 'tableDataI') +
						this.gettableval('zzs_1_10_6', 'tableDataI') +
						this.gettableval('zzs_1_10_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_10_3') {
					this.changetableval(
						'zzs_1_10_9',
						'tableDataI',
						this.gettableval('zzs_1_10_1', 'tableDataI') +
						this.gettableval('zzs_1_10_3', 'tableDataI') +
						this.gettableval('zzs_1_10_5', 'tableDataI') +
						this.gettableval('zzs_1_10_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_10_4') {
					this.changetableval(
						'zzs_1_10_10',
						'tableDataI',
						this.gettableval('zzs_1_10_2', 'tableDataI') +
						this.gettableval('zzs_1_10_4', 'tableDataI') +
						this.gettableval('zzs_1_10_6', 'tableDataI') +
						this.gettableval('zzs_1_10_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_10_5') {
					this.changetableval(
						'zzs_1_10_9',
						'tableDataI',
						this.gettableval('zzs_1_10_1', 'tableDataI') +
						this.gettableval('zzs_1_10_3', 'tableDataI') +
						this.gettableval('zzs_1_10_5', 'tableDataI') +
						this.gettableval('zzs_1_10_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_10_6') {
					this.changetableval(
						'zzs_1_10_10',
						'tableDataI',
						this.gettableval('zzs_1_10_2', 'tableDataI') +
						this.gettableval('zzs_1_10_4', 'tableDataI') +
						this.gettableval('zzs_1_10_6', 'tableDataI') +
						this.gettableval('zzs_1_10_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_10_7') {
					this.changetableval(
						'zzs_1_10_9',
						'tableDataI',
						this.gettableval('zzs_1_10_1', 'tableDataI') +
						this.gettableval('zzs_1_10_3', 'tableDataI') +
						this.gettableval('zzs_1_10_5', 'tableDataI') +
						this.gettableval('zzs_1_10_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_10_8') {
					this.changetableval(
						'zzs_1_10_10',
						'tableDataI',
						this.gettableval('zzs_1_10_2', 'tableDataI') +
						this.gettableval('zzs_1_10_4', 'tableDataI') +
						this.gettableval('zzs_1_10_6', 'tableDataI') +
						this.gettableval('zzs_1_10_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_10_9') {
					// if (this.gettableval("zzs_0_5_1", 'tableDataZero') < (this.gettableval("zzs_1_8_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_9a_9", 'tableDataI') + this.gettableval("zzs_1_9b_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_10_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_11_9", 'tableDataI') + this.gettableval("zzs_1_12_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_13a_9", 'tableDataI') + this.gettableval("zzs_1_13b_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_13c_9", 'tableDataI') -
					// 		this.gettableval("zzs_1_14_9", 'tableDataI') - this.gettableval("zzs_1_15_9", 'tableDataI'))) {
					// 	this.$message.error("zzs_0_5_1格子校验不正确")
					// }
				}
				if (e.cellCode == 'zzs_1_10_10') {
					this.changetableval(
						'zzs_0_21_1',
						'tableDataZero',
						this.gettableval('zzs_1_8_10', 'tableDataI') +
						this.gettableval('zzs_1_9a_10', 'tableDataI') +
						this.gettableval('zzs_1_10_10', 'tableDataI') +
						this.gettableval('zzs_1_11_10', 'tableDataI') -
						this.gettableval('zzs_1_14_10', 'tableDataI') +
						this.gettableval('zzs_1_9b_14', 'tableDataI') +
						this.gettableval('zzs_1_12_14', 'tableDataI') +
						this.gettableval('zzs_1_13a_14', 'tableDataI') +
						this.gettableval('zzs_1_13b_14', 'tableDataI') -
						this.gettableval('zzs_1_15_14', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_11_1') {
					this.changetableval(
						'zzs_1_11_9',
						'tableDataI',
						this.gettableval('zzs_1_11_1', 'tableDataI') +
						this.gettableval('zzs_1_11_3', 'tableDataI') +
						this.gettableval('zzs_1_11_5', 'tableDataI') +
						this.gettableval('zzs_1_11_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_11_2') {
					this.changetableval(
						'zzs_1_11_10',
						'tableDataI',
						this.gettableval('zzs_1_11_2', 'tableDataI') +
						this.gettableval('zzs_1_11_4', 'tableDataI') +
						this.gettableval('zzs_1_11_6', 'tableDataI') +
						this.gettableval('zzs_1_11_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_11_3') {
					this.changetableval(
						'zzs_1_11_9',
						'tableDataI',
						this.gettableval('zzs_1_11_1', 'tableDataI') +
						this.gettableval('zzs_1_11_3', 'tableDataI') +
						this.gettableval('zzs_1_11_5', 'tableDataI') +
						this.gettableval('zzs_1_11_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_11_4') {
					this.changetableval(
						'zzs_1_11_10',
						'tableDataI',
						this.gettableval('zzs_1_11_2', 'tableDataI') +
						this.gettableval('zzs_1_11_4', 'tableDataI') +
						this.gettableval('zzs_1_11_6', 'tableDataI') +
						this.gettableval('zzs_1_11_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_11_5') {
					this.changetableval(
						'zzs_1_11_9',
						'tableDataI',
						this.gettableval('zzs_1_11_1', 'tableDataI') +
						this.gettableval('zzs_1_11_3', 'tableDataI') +
						this.gettableval('zzs_1_11_5', 'tableDataI') +
						this.gettableval('zzs_1_11_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_11_6') {
					this.changetableval(
						'zzs_1_11_10',
						'tableDataI',
						this.gettableval('zzs_1_11_2', 'tableDataI') +
						this.gettableval('zzs_1_11_4', 'tableDataI') +
						this.gettableval('zzs_1_11_6', 'tableDataI') +
						this.gettableval('zzs_1_11_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_11_9') {
					// if (this.gettableval("zzs_0_5_1", 'tableDataZero') < (this.gettableval("zzs_1_8_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_9a_9", 'tableDataI') + this.gettableval("zzs_1_9b_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_10_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_11_9", 'tableDataI') + this.gettableval("zzs_1_12_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_13a_9", 'tableDataI') + this.gettableval("zzs_1_13b_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_13c_9", 'tableDataI') -
					// 		this.gettableval("zzs_1_14_9", 'tableDataI') - this.gettableval("zzs_1_15_9", 'tableDataI'))) {
					// 	this.$message.error("zzs_0_5_1格子校验不正确")
					// }
				}
				if (e.cellCode == 'zzs_1_11_10') {
					this.changetableval(
						'zzs_0_21_1',
						'tableDataZero',
						this.gettableval('zzs_1_8_10', 'tableDataI') +
						this.gettableval('zzs_1_9a_10', 'tableDataI') +
						this.gettableval('zzs_1_10_10', 'tableDataI') +
						this.gettableval('zzs_1_11_10', 'tableDataI') -
						this.gettableval('zzs_1_14_10', 'tableDataI') +
						this.gettableval('zzs_1_9b_14', 'tableDataI') +
						this.gettableval('zzs_1_12_14', 'tableDataI') +
						this.gettableval('zzs_1_13a_14', 'tableDataI') +
						this.gettableval('zzs_1_13b_14', 'tableDataI') -
						this.gettableval('zzs_1_15_14', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_12_1') {
					this.changetableval(
						'zzs_1_12_9',
						'tableDataI',
						this.gettableval('zzs_1_12_1', 'tableDataI') +
						this.gettableval('zzs_1_12_3', 'tableDataI') +
						this.gettableval('zzs_1_12_5', 'tableDataI') +
						this.gettableval('zzs_1_12_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_12_2') {
					this.changetableval(
						'zzs_1_12_10',
						'tableDataI',
						this.gettableval('zzs_1_12_2', 'tableDataI') +
						this.gettableval('zzs_1_12_4', 'tableDataI') +
						this.gettableval('zzs_1_12_6', 'tableDataI') +
						this.gettableval('zzs_1_12_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_12_3') {
					this.changetableval(
						'zzs_1_12_9',
						'tableDataI',
						this.gettableval('zzs_1_12_1', 'tableDataI') +
						this.gettableval('zzs_1_12_3', 'tableDataI') +
						this.gettableval('zzs_1_12_5', 'tableDataI') +
						this.gettableval('zzs_1_12_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_12_4') {
					this.changetableval(
						'zzs_1_12_10',
						'tableDataI',
						this.gettableval('zzs_1_12_2', 'tableDataI') +
						this.gettableval('zzs_1_12_4', 'tableDataI') +
						this.gettableval('zzs_1_12_6', 'tableDataI') +
						this.gettableval('zzs_1_12_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_12_5') {
					this.changetableval(
						'zzs_1_12_9',
						'tableDataI',
						this.gettableval('zzs_1_12_1', 'tableDataI') +
						this.gettableval('zzs_1_12_3', 'tableDataI') +
						this.gettableval('zzs_1_12_5', 'tableDataI') +
						this.gettableval('zzs_1_12_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_12_6') {
					this.changetableval(
						'zzs_1_12_10',
						'tableDataI',
						this.gettableval('zzs_1_12_2', 'tableDataI') +
						this.gettableval('zzs_1_12_4', 'tableDataI') +
						this.gettableval('zzs_1_12_6', 'tableDataI') +
						this.gettableval('zzs_1_12_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_12_7') {
					this.changetableval(
						'zzs_1_12_9',
						'tableDataI',
						this.gettableval('zzs_1_12_1', 'tableDataI') +
						this.gettableval('zzs_1_12_3', 'tableDataI') +
						this.gettableval('zzs_1_12_5', 'tableDataI') +
						this.gettableval('zzs_1_12_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_12_8') {
					this.changetableval(
						'zzs_1_12_10',
						'tableDataI',
						this.gettableval('zzs_1_12_2', 'tableDataI') +
						this.gettableval('zzs_1_12_4', 'tableDataI') +
						this.gettableval('zzs_1_12_6', 'tableDataI') +
						this.gettableval('zzs_1_12_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_12_9') {
					// if (this.gettableval("zzs_0_5_1", 'tableDataZero') < (this.gettableval("zzs_1_8_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_9a_9", 'tableDataI') + this.gettableval("zzs_1_9b_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_10_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_11_9", 'tableDataI') + this.gettableval("zzs_1_12_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_13a_9", 'tableDataI') + this.gettableval("zzs_1_13b_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_13c_9", 'tableDataI') -
					// 		this.gettableval("zzs_1_14_9", 'tableDataI') - this.gettableval("zzs_1_15_9", 'tableDataI'))) {
					// 	this.$message.error("zzs_0_5_1格子校验不正确")
					// }
					this.changetableval(
						'zzs_1_12_11',
						'tableDataI',
						this.gettableval('zzs_1_12_9', 'tableDataI') + this.gettableval('zzs_1_12_10', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_12_10') {
					this.changetableval(
						'zzs_1_12_11',
						'tableDataI',
						this.gettableval('zzs_1_12_9', 'tableDataI') + this.gettableval('zzs_1_12_10', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_12_11') {
					this.changetableval(
						'zzs_1_12_13',
						'tableDataI',
						this.gettableval('zzs_1_12_11', 'tableDataI') - this.gettableval('zzs_1_12_12', 'tableDataI')
					);
					this.changetableval('zzs_3_6_1', 'tableDataIII', this.gettableval('zzs_1_12_11', 'tableDataI'));
				}
				if (e.cellCode == 'zzs_1_12_12') {
					this.changetableval(
						'zzs_1_12_13',
						'tableDataI',
						this.gettableval('zzs_1_12_11', 'tableDataI') - this.gettableval('zzs_1_12_12', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_12_13') {
					this.changetableval('zzs_1_12_14', 'tableDataI', this.gettableval('zzs_1_12_10', 'tableDataI'));
				}
				if (e.cellCode == 'zzs_1_12_14') {
					this.changetableval(
						'zzs_0_21_1',
						'tableDataZero',
						this.gettableval('zzs_1_8_10', 'tableDataI') +
						this.gettableval('zzs_1_9a_10', 'tableDataI') +
						this.gettableval('zzs_1_10_10', 'tableDataI') +
						this.gettableval('zzs_1_11_10', 'tableDataI') -
						-this.gettableval('zzs_1_14_10', 'tableDataI') +
						this.gettableval('zzs_1_9b_14', 'tableDataI') +
						this.gettableval('zzs_1_12_14', 'tableDataI') +
						this.gettableval('zzs_1_13a_14', 'tableDataI') +
						this.gettableval('zzs_1_13b_14', 'tableDataI') -
						this.gettableval('zzs_1_15_14', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13a_1') {
					this.changetableval(
						'zzs_1_13a_9',
						'tableDataI',
						this.gettableval('zzs_1_13a_1', 'tableDataI') +
						this.gettableval('zzs_1_13a_3', 'tableDataI') +
						this.gettableval('zzs_1_13a_5', 'tableDataI') +
						this.gettableval('zzs_1_13a_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13a_2') {
					this.changetableval(
						'zzs_1_13a_10',
						'tableDataI',
						this.gettableval('zzs_1_13a_2', 'tableDataI') +
						this.gettableval('zzs_1_13a_4', 'tableDataI') +
						this.gettableval('zzs_1_13a_6', 'tableDataI') +
						this.gettableval('zzs_1_13a_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13a_3') {
					this.changetableval(
						'zzs_1_13a_9',
						'tableDataI',
						this.gettableval('zzs_1_13a_1', 'tableDataI') +
						this.gettableval('zzs_1_13a_3', 'tableDataI') +
						this.gettableval('zzs_1_13a_5', 'tableDataI') +
						this.gettableval('zzs_1_13a_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13a_4') {
					this.changetableval(
						'zzs_1_13a_10',
						'tableDataI',
						this.gettableval('zzs_1_13a_2', 'tableDataI') +
						this.gettableval('zzs_1_13a_4', 'tableDataI') +
						this.gettableval('zzs_1_13a_6', 'tableDataI') +
						this.gettableval('zzs_1_13a_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13a_5') {
					this.changetableval(
						'zzs_1_13a_9',
						'tableDataI',
						this.gettableval('zzs_1_13a_1', 'tableDataI') +
						this.gettableval('zzs_1_13a_3', 'tableDataI') +
						this.gettableval('zzs_1_13a_5', 'tableDataI') +
						this.gettableval('zzs_1_13a_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13a_6') {
					this.changetableval(
						'zzs_1_13a_10',
						'tableDataI',
						this.gettableval('zzs_1_13a_2', 'tableDataI') +
						this.gettableval('zzs_1_13a_4', 'tableDataI') +
						this.gettableval('zzs_1_13a_6', 'tableDataI') +
						this.gettableval('zzs_1_13a_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13a_7') {
					this.changetableval(
						'zzs_1_13a_9',
						'tableDataI',
						this.gettableval('zzs_1_13a_1', 'tableDataI') +
						this.gettableval('zzs_1_13a_3', 'tableDataI') +
						this.gettableval('zzs_1_13a_5', 'tableDataI') +
						this.gettableval('zzs_1_13a_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13a_8') {
					this.changetableval(
						'zzs_1_13a_10',
						'tableDataI',
						this.gettableval('zzs_1_13a_2', 'tableDataI') +
						this.gettableval('zzs_1_13a_4', 'tableDataI') +
						this.gettableval('zzs_1_13a_6', 'tableDataI') +
						this.gettableval('zzs_1_13a_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13a_9') {
					// if (this.gettableval("zzs_0_5_1", 'tableDataZero') < (this.gettableval("zzs_1_8_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_9a_9", 'tableDataI') + this.gettableval("zzs_1_9b_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_10_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_11_9", 'tableDataI') + this.gettableval("zzs_1_12_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_13a_9", 'tableDataI') + this.gettableval("zzs_1_13b_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_13c_9", 'tableDataI') -
					// 		this.gettableval("zzs_1_14_9", 'tableDataI') - this.gettableval("zzs_1_15_9", 'tableDataI'))) {
					// 	this.$message.error("zzs_0_5_1格子校验不正确")
					// }
					this.changetableval(
						'zzs_1_13a_11',
						'tableDataI',
						this.gettableval('zzs_1_13a_9', 'tableDataI') + this.gettableval('zzs_1_13a_10', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13a_10') {
					this.changetableval(
						'zzs_1_13a_11',
						'tableDataI',
						this.gettableval('zzs_1_13a_9', 'tableDataI') + this.gettableval('zzs_1_13a_10', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13a_13') {
					this.changetableval(
						'zzs_1_13a_14',
						'tableDataI',
						(this.gettableval('zzs_1_13a_13', 'tableDataI') / (1 + this.gettableval('zzs_1_13a_0',
							'tableDataI'))) *
						this.gettableval('zzs_1_13a_0', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13a_0') {
					this.changetableval(
						'zzs_1_13a_14',
						'tableDataI',
						(this.gettableval('zzs_1_13a_13', 'tableDataI') / (1 + this.gettableval('zzs_1_13a_0',
							'tableDataI'))) *
						this.gettableval('zzs_1_13a_0', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13a_14') {
					this.changetableval(
						'zzs_0_21_1',
						'tableDataZero',
						this.gettableval('zzs_1_8_10', 'tableDataI') +
						this.gettableval('zzs_1_9a_10', 'tableDataI') +
						this.gettableval('zzs_1_10_10', 'tableDataI') +
						this.gettableval('zzs_1_11_10', 'tableDataI') -
						this.gettableval('zzs_1_14_10', 'tableDataI') +
						this.gettableval('zzs_1_9b_14', 'tableDataI') +
						this.gettableval('zzs_1_12_14', 'tableDataI') +
						this.gettableval('zzs_1_13a_14', 'tableDataI') +
						this.gettableval('zzs_1_13b_14', 'tableDataI') -
						this.gettableval('zzs_1_15_14', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13b_1') {
					this.changetableval(
						'zzs_1_13b_9',
						'tableDataI',
						this.gettableval('zzs_1_13b_1', 'tableDataI') +
						this.gettableval('zzs_1_13b_3', 'tableDataI') +
						this.gettableval('zzs_1_13b_5', 'tableDataI') +
						this.gettableval('zzs_1_13b_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13b_2') {
					this.changetableval(
						'zzs_1_13b_10',
						'tableDataI',
						this.gettableval('zzs_1_13b_2', 'tableDataI') +
						this.gettableval('zzs_1_13b_4', 'tableDataI') +
						this.gettableval('zzs_1_13b_6', 'tableDataI') +
						this.gettableval('zzs_1_13b_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13b_3') {
					this.changetableval(
						'zzs_1_13b_9',
						'tableDataI',
						this.gettableval('zzs_1_13b_1', 'tableDataI') +
						this.gettableval('zzs_1_13b_3', 'tableDataI') +
						this.gettableval('zzs_1_13b_5', 'tableDataI') +
						this.gettableval('zzs_1_13b_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13b_4') {
					this.changetableval(
						'zzs_1_13b_10',
						'tableDataI',
						this.gettableval('zzs_1_13b_2', 'tableDataI') +
						this.gettableval('zzs_1_13b_4', 'tableDataI') +
						this.gettableval('zzs_1_13b_6', 'tableDataI') +
						this.gettableval('zzs_1_13b_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13b_5') {
					this.changetableval(
						'zzs_1_13b_9',
						'tableDataI',
						this.gettableval('zzs_1_13b_1', 'tableDataI') +
						this.gettableval('zzs_1_13b_3', 'tableDataI') +
						this.gettableval('zzs_1_13b_5', 'tableDataI') +
						this.gettableval('zzs_1_13b_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13b_6') {
					this.changetableval(
						'zzs_1_13b_10',
						'tableDataI',
						this.gettableval('zzs_1_13b_2', 'tableDataI') +
						this.gettableval('zzs_1_13b_4', 'tableDataI') +
						this.gettableval('zzs_1_13b_6', 'tableDataI') +
						this.gettableval('zzs_1_13b_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13b_7') {
					this.changetableval(
						'zzs_1_13b_9',
						'tableDataI',
						this.gettableval('zzs_1_13b_1', 'tableDataI') +
						this.gettableval('zzs_1_13b_3', 'tableDataI') +
						this.gettableval('zzs_1_13b_5', 'tableDataI') +
						this.gettableval('zzs_1_13b_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13b_8') {
					this.changetableval(
						'zzs_1_13b_10',
						'tableDataI',
						this.gettableval('zzs_1_13b_2', 'tableDataI') +
						this.gettableval('zzs_1_13b_4', 'tableDataI') +
						this.gettableval('zzs_1_13b_6', 'tableDataI') +
						this.gettableval('zzs_1_13b_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13b_9') {
					// if (this.gettableval("zzs_0_5_1", 'tableDataZero') < (this.gettableval("zzs_1_8_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_9a_9", 'tableDataI') + this.gettableval("zzs_1_9b_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_10_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_11_9", 'tableDataI') + this.gettableval("zzs_1_12_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_13a_9", 'tableDataI') + this.gettableval("zzs_1_13b_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_13c_9", 'tableDataI') -
					// 		this.gettableval("zzs_1_14_9", 'tableDataI') - this.gettableval("zzs_1_15_9", 'tableDataI'))) {
					// 	this.$message.error("zzs_0_5_1格子校验不正确")
					// }
					this.changetableval(
						'zzs_1_13b_11',
						'tableDataI',
						this.gettableval('zzs_1_13b_9', 'tableDataI') + this.gettableval('zzs_1_13b_10', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13b_10') {
					this.changetableval(
						'zzs_1_13b_11',
						'tableDataI',
						this.gettableval('zzs_1_13b_9', 'tableDataI') + this.gettableval('zzs_1_13b_10', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13b_13') {
					this.changetableval(
						'zzs_1_13b_14',
						'tableDataI',
						(this.gettableval('zzs_1_13b_13', 'tableDataI') / (1 + this.gettableval('zzs_1_13b_0',
							'tableDataI'))) *
						this.gettableval('zzs_1_13b_0', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13b_0') {
					this.changetableval(
						'zzs_1_13b_14',
						'tableDataI',
						(this.gettableval('zzs_1_13b_13', 'tableDataI') / (1 + this.gettableval('zzs_1_13b_0',
							'tableDataI'))) *
						this.gettableval('zzs_1_13b_0', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13b_14') {
					this.changetableval(
						'zzs_0_21_1',
						'tableDataZero',
						this.gettableval('zzs_1_8_10', 'tableDataI') +
						this.gettableval('zzs_1_9a_10', 'tableDataI') +
						this.gettableval('zzs_1_10_10', 'tableDataI') +
						this.gettableval('zzs_1_11_10', 'tableDataI') -
						this.gettableval('zzs_1_14_10', 'tableDataI') +
						this.gettableval('zzs_1_9b_14', 'tableDataI') +
						this.gettableval('zzs_1_12_14', 'tableDataI') +
						this.gettableval('zzs_1_13a_14', 'tableDataI') +
						this.gettableval('zzs_1_13b_14', 'tableDataI') -
						this.gettableval('zzs_1_15_14', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13c_1') {
					this.changetableval(
						'zzs_1_13c_9',
						'tableDataI',
						this.gettableval('zzs_1_13c_1', 'tableDataI') +
						this.gettableval('zzs_1_13c_3', 'tableDataI') +
						this.gettableval('zzs_1_13c_5', 'tableDataI') +
						this.gettableval('zzs_1_13c_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13c_2') {
					this.changetableval(
						'zzs_1_13c_10',
						'tableDataI',
						this.gettableval('zzs_1_13c_2', 'tableDataI') +
						this.gettableval('zzs_1_13c_4', 'tableDataI') +
						this.gettableval('zzs_1_13c_6', 'tableDataI') +
						this.gettableval('zzs_1_13c_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13c_3') {
					this.changetableval(
						'zzs_1_13c_9',
						'tableDataI',
						this.gettableval('zzs_1_13c_1', 'tableDataI') +
						this.gettableval('zzs_1_13c_3', 'tableDataI') +
						this.gettableval('zzs_1_13c_5', 'tableDataI') +
						this.gettableval('zzs_1_13c_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13c_4') {
					this.changetableval(
						'zzs_1_13c_10',
						'tableDataI',
						this.gettableval('zzs_1_13c_2', 'tableDataI') +
						this.gettableval('zzs_1_13c_4', 'tableDataI') +
						this.gettableval('zzs_1_13c_6', 'tableDataI') +
						this.gettableval('zzs_1_13c_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13c_5') {
					this.changetableval(
						'zzs_1_13c_9',
						'tableDataI',
						this.gettableval('zzs_1_13c_1', 'tableDataI') +
						this.gettableval('zzs_1_13c_3', 'tableDataI') +
						this.gettableval('zzs_1_13c_5', 'tableDataI') +
						this.gettableval('zzs_1_13c_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13c_6') {
					this.changetableval(
						'zzs_1_13c_10',
						'tableDataI',
						this.gettableval('zzs_1_13c_2', 'tableDataI') +
						this.gettableval('zzs_1_13c_4', 'tableDataI') +
						this.gettableval('zzs_1_13c_6', 'tableDataI') +
						this.gettableval('zzs_1_13c_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13c_7') {
					this.changetableval(
						'zzs_1_13c_9',
						'tableDataI',
						this.gettableval('zzs_1_13c_1', 'tableDataI') +
						this.gettableval('zzs_1_13c_3', 'tableDataI') +
						this.gettableval('zzs_1_13c_5', 'tableDataI') +
						this.gettableval('zzs_1_13c_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13c_8') {
					this.changetableval(
						'zzs_1_13c_10',
						'tableDataI',
						this.gettableval('zzs_1_13c_2', 'tableDataI') +
						this.gettableval('zzs_1_13c_4', 'tableDataI') +
						this.gettableval('zzs_1_13c_6', 'tableDataI') +
						this.gettableval('zzs_1_13c_8', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13c_9') {
					// if (this.gettableval("zzs_0_5_1", 'tableDataZero') < (this.gettableval("zzs_1_8_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_9a_9", 'tableDataI') + this.gettableval("zzs_1_9b_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_10_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_11_9", 'tableDataI') + this.gettableval("zzs_1_12_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_13a_9", 'tableDataI') + this.gettableval("zzs_1_13b_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_13c_9", 'tableDataI') -
					// 		this.gettableval("zzs_1_14_9", 'tableDataI') - this.gettableval("zzs_1_15_9", 'tableDataI'))) {
					// 	this.$message.error("zzs_0_5_1格子校验不正确")
					// }
					this.changetableval(
						'zzs_1_13c_11',
						'tableDataI',
						this.gettableval('zzs_1_13c_9', 'tableDataI') + this.gettableval('zzs_1_13c_10', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13c_10') {
					this.changetableval(
						'zzs_1_13c_11',
						'tableDataI',
						this.gettableval('zzs_1_13c_9', 'tableDataI') + this.gettableval('zzs_1_13c_10', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13c_13') {
					this.changetableval(
						'zzs_1_13c_14',
						'tableDataI',
						(this.gettableval('zzs_1_13c_13', 'tableDataI') / (1 + this.gettableval('zzs_1_13c_0',
							'tableDataI'))) *
						this.gettableval('zzs_1_13c_0', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_13c_0') {
					this.changetableval(
						'zzs_1_13c_14',
						'tableDataI',
						(this.gettableval('zzs_1_13c_13', 'tableDataI') / (1 + this.gettableval('zzs_1_13c_0',
							'tableDataI'))) *
						this.gettableval('zzs_1_13c_0', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_14_9') {
					// if (this.gettableval("zzs_0_5_1", 'tableDataZero') < (this.gettableval("zzs_1_8_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_9a_9", 'tableDataI') + this.gettableval("zzs_1_9b_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_10_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_11_9", 'tableDataI') + this.gettableval("zzs_1_12_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_13a_9", 'tableDataI') + this.gettableval("zzs_1_13b_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_13c_9", 'tableDataI') -
					// 		this.gettableval("zzs_1_14_9", 'tableDataI') - this.gettableval("zzs_1_15_9", 'tableDataI'))) {
					// 	this.$message.error("zzs_0_5_1格子校验不正确")
					// }
					// if (this.gettableval("zzs_0_5_3", 'tableDataZero') < (this.gettableval("zzs_1_14_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_15_9", 'tableDataI'))) {
					// 	this.$message.error("zzs_0_5_3格子校验不正确")
					// }
				}
				if (e.cellCode == 'zzs_1_14_10') {
					this.changetableval(
						'zzs_0_21_1',
						'tableDataZero',
						this.gettableval('zzs_1_8_10', 'tableDataI') +
						this.gettableval('zzs_1_9a_10', 'tableDataI') +
						this.gettableval('zzs_1_10_10', 'tableDataI') +
						this.gettableval('zzs_1_11_10', 'tableDataI') -
						this.gettableval('zzs_1_14_10', 'tableDataI') +
						this.gettableval('zzs_1_9b_14', 'tableDataI') +
						this.gettableval('zzs_1_12_14', 'tableDataI') +
						this.gettableval('zzs_1_13a_14', 'tableDataI') +
						this.gettableval('zzs_1_13b_14', 'tableDataI') -
						this.gettableval('zzs_1_15_14', 'tableDataI')
					);
					this.changetableval(
						'zzs_0_21_3',
						'tableDataZero',
						this.gettableval('zzs_1_14_10', 'tableDataI') - this.gettableval('zzs_1_15_14', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_15_9') {
					// if (this.gettableval("zzs_0_5_1", 'tableDataZero') < (this.gettableval("zzs_1_8_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_9a_9", 'tableDataI') + this.gettableval("zzs_1_9b_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_10_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_11_9", 'tableDataI') + this.gettableval("zzs_1_12_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_13a_9", 'tableDataI') + this.gettableval("zzs_1_13b_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_13c_9", 'tableDataI') -
					// 		this.gettableval("zzs_1_14_9", 'tableDataI') - this.gettableval("zzs_1_15_9", 'tableDataI'))) {
					// 	this.$message.error("zzs_0_5_1格子校验不正确")
					// }
					// if (this.gettableval("zzs_0_5_3", 'tableDataZero') < (this.gettableval("zzs_1_14_9", 'tableDataI') +
					// 		this.gettableval("zzs_1_15_9", 'tableDataI'))) {
					// 	this.$message.error("zzs_0_5_3格子校验不正确")
					// }
					this.changetableval(
						'zzs_1_15_11',
						'tableDataI',
						this.gettableval('zzs_1_15_9', 'tableDataI') + this.gettableval('zzs_1_15_10', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_15_10') {
					this.changetableval(
						'zzs_1_15_11',
						'tableDataI',
						this.gettableval('zzs_1_15_9', 'tableDataI') + this.gettableval('zzs_1_15_10', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_15_14') {
					this.changetableval(
						'zzs_0_21_1',
						'tableDataZero',
						this.gettableval('zzs_1_8_10', 'tableDataI') +
						this.gettableval('zzs_1_9a_10', 'tableDataI') +
						this.gettableval('zzs_1_10_10', 'tableDataI') +
						this.gettableval('zzs_1_11_10', 'tableDataI') -
						this.gettableval('zzs_1_14_10', 'tableDataI') +
						this.gettableval('zzs_1_9b_14', 'tableDataI') +
						this.gettableval('zzs_1_12_14', 'tableDataI') +
						this.gettableval('zzs_1_13a_14', 'tableDataI') +
						this.gettableval('zzs_1_13b_14', 'tableDataI') -
						this.gettableval('zzs_1_15_14', 'tableDataI')
					);
					this.changetableval(
						'zzs_0_21_3',
						'tableDataZero',
						this.gettableval('zzs_1_14_10', 'tableDataI') - this.gettableval('zzs_1_15_14', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_16_1') {
					this.changetableval(
						'zzs_1_16_9',
						'tableDataI',
						this.gettableval('zzs_1_16_1', 'tableDataI') +
						this.gettableval('zzs_1_16_3', 'tableDataI') +
						this.gettableval('zzs_1_16_5', 'tableDataI') +
						this.gettableval('zzs_1_16_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_16_3') {
					this.changetableval(
						'zzs_1_16_9',
						'tableDataI',
						this.gettableval('zzs_1_16_1', 'tableDataI') +
						this.gettableval('zzs_1_16_3', 'tableDataI') +
						this.gettableval('zzs_1_16_5', 'tableDataI') +
						this.gettableval('zzs_1_16_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_16_5') {
					this.changetableval(
						'zzs_1_16_9',
						'tableDataI',
						this.gettableval('zzs_1_16_1', 'tableDataI') +
						this.gettableval('zzs_1_16_3', 'tableDataI') +
						this.gettableval('zzs_1_16_5', 'tableDataI') +
						this.gettableval('zzs_1_16_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_16_7') {
					this.changetableval(
						'zzs_1_16_9',
						'tableDataI',
						this.gettableval('zzs_1_16_1', 'tableDataI') +
						this.gettableval('zzs_1_16_3', 'tableDataI') +
						this.gettableval('zzs_1_16_5', 'tableDataI') +
						this.gettableval('zzs_1_16_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_16_9') {
					this.changetableval(
						'zzs_0_7_1',
						'tableDataZero',
						this.gettableval('zzs_1_16_9', 'tableDataI') + this.gettableval('zzs_1_17_9', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_17_1') {
					this.changetableval(
						'zzs_1_17_9',
						'tableDataI',
						this.gettableval('zzs_1_17_1', 'tableDataI') +
						this.gettableval('zzs_1_17_3', 'tableDataI') +
						this.gettableval('zzs_1_17_5', 'tableDataI') +
						this.gettableval('zzs_1_17_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_17_3') {
					this.changetableval(
						'zzs_1_17_9',
						'tableDataI',
						this.gettableval('zzs_1_17_1', 'tableDataI') +
						this.gettableval('zzs_1_17_3', 'tableDataI') +
						this.gettableval('zzs_1_17_5', 'tableDataI') +
						this.gettableval('zzs_1_17_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_17_5') {
					this.changetableval(
						'zzs_1_17_9',
						'tableDataI',
						this.gettableval('zzs_1_17_1', 'tableDataI') +
						this.gettableval('zzs_1_17_3', 'tableDataI') +
						this.gettableval('zzs_1_17_5', 'tableDataI') +
						this.gettableval('zzs_1_17_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_17_7') {
					this.changetableval(
						'zzs_1_17_9',
						'tableDataI',
						this.gettableval('zzs_1_17_1', 'tableDataI') +
						this.gettableval('zzs_1_17_3', 'tableDataI') +
						this.gettableval('zzs_1_17_5', 'tableDataI') +
						this.gettableval('zzs_1_17_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_17_9') {
					this.changetableval(
						'zzs_0_7_1',
						'tableDataZero',
						this.gettableval('zzs_1_16_9', 'tableDataI') + this.gettableval('zzs_1_17_9', 'tableDataI')
					);
					this.changetableval(
						'zzs_1_17_11',
						'tableDataI',
						this.gettableval('zzs_1_17_9', 'tableDataI') + this.gettableval('zzs_1_17_10', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_17_10') {
					this.changetableval(
						'zzs_1_17_11',
						'tableDataI',
						this.gettableval('zzs_1_17_9', 'tableDataI') + this.gettableval('zzs_1_17_10', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_17_11') {
					this.changetableval(
						'zzs_1_17_13',
						'tableDataI',
						this.gettableval('zzs_1_17_11', 'tableDataI') - this.gettableval('zzs_1_17_12', 'tableDataI')
					);
					this.changetableval('zzs_3_7_1', 'tableDataIII', this.gettableval('zzs_1_17_11', 'tableDataI'));
				}
				if (e.cellCode == 'zzs_1_17_12') {
					this.changetableval(
						'zzs_1_17_13',
						'tableDataI',
						this.gettableval('zzs_1_17_11', 'tableDataI') - this.gettableval('zzs_1_17_12', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_18_1') {
					this.changetableval(
						'zzs_1_18_9',
						'tableDataI',
						this.gettableval('zzs_1_18_1', 'tableDataI') +
						this.gettableval('zzs_1_18_3', 'tableDataI') +
						this.gettableval('zzs_1_18_5', 'tableDataI') +
						this.gettableval('zzs_1_18_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_18_3') {
					this.changetableval(
						'zzs_1_18_9',
						'tableDataI',
						this.gettableval('zzs_1_18_1', 'tableDataI') +
						this.gettableval('zzs_1_18_3', 'tableDataI') +
						this.gettableval('zzs_1_18_5', 'tableDataI') +
						this.gettableval('zzs_1_18_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_18_5') {
					this.changetableval(
						'zzs_1_18_9',
						'tableDataI',
						this.gettableval('zzs_1_18_1', 'tableDataI') +
						this.gettableval('zzs_1_18_3', 'tableDataI') +
						this.gettableval('zzs_1_18_5', 'tableDataI') +
						this.gettableval('zzs_1_18_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_18_7') {
					this.changetableval(
						'zzs_1_18_9',
						'tableDataI',
						this.gettableval('zzs_1_18_1', 'tableDataI') +
						this.gettableval('zzs_1_18_3', 'tableDataI') +
						this.gettableval('zzs_1_18_5', 'tableDataI') +
						this.gettableval('zzs_1_18_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_18_9') {
					this.changetableval(
						'zzs_0_8_1',
						'tableDataZero',
						this.gettableval('zzs_1_18_9', 'tableDataI') + this.gettableval('zzs_1_19_9', 'tableDataI')
					);
					this.changetableval(
						'zzs_0_9_1',
						'tableDataZero',
						this.gettableval('zzs_1_18_9', 'tableDataI') - this.gettableval('zzs_0_10_1', 'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_1_19_1') {
					this.changetableval(
						'zzs_1_19_9',
						'tableDataI',
						this.gettableval('zzs_1_19_1', 'tableDataI') +
						this.gettableval('zzs_1_19_3', 'tableDataI') +
						this.gettableval('zzs_1_19_5', 'tableDataI') +
						this.gettableval('zzs_1_19_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_19_3') {
					this.changetableval(
						'zzs_1_19_9',
						'tableDataI',
						this.gettableval('zzs_1_19_1', 'tableDataI') +
						this.gettableval('zzs_1_19_3', 'tableDataI') +
						this.gettableval('zzs_1_19_5', 'tableDataI') +
						this.gettableval('zzs_1_19_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_19_5') {
					this.changetableval(
						'zzs_1_19_9',
						'tableDataI',
						this.gettableval('zzs_1_19_1', 'tableDataI') +
						this.gettableval('zzs_1_19_3', 'tableDataI') +
						this.gettableval('zzs_1_19_5', 'tableDataI') +
						this.gettableval('zzs_1_19_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_19_7') {
					this.changetableval(
						'zzs_1_19_9',
						'tableDataI',
						this.gettableval('zzs_1_19_1', 'tableDataI') +
						this.gettableval('zzs_1_19_3', 'tableDataI') +
						this.gettableval('zzs_1_19_5', 'tableDataI') +
						this.gettableval('zzs_1_19_7', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_19_9') {
					this.changetableval(
						'zzs_0_8_1',
						'tableDataZero',
						this.gettableval('zzs_1_18_9', 'tableDataI') + this.gettableval('zzs_1_19_9', 'tableDataI')
					);
					this.changetableval(
						'zzs_1_19_11',
						'tableDataI',
						this.gettableval('zzs_1_19_9', 'tableDataI') + this.gettableval('zzs_1_19_10', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_19_10') {
					this.changetableval(
						'zzs_1_19_11',
						'tableDataI',
						this.gettableval('zzs_1_19_9', 'tableDataI') + this.gettableval('zzs_1_19_10', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_1_19_11') {
					this.changetableval(
						'zzs_1_19_13',
						'tableDataI',
						this.gettableval('zzs_1_19_11', 'tableDataI') - this.gettableval('zzs_1_19_12', 'tableDataI')
					);
					this.changetableval('zzs_3_8_1', 'tableDataIII', this.gettableval('zzs_1_19_11', 'tableDataI'));
				}
				if (e.cellCode == 'zzs_1_19_12') {
					this.changetableval(
						'zzs_1_19_13',
						'tableDataI',
						this.gettableval('zzs_1_19_11', 'tableDataI') - this.gettableval('zzs_1_19_12', 'tableDataI')
					);
				}
				if (e.cellCode == 'zzs_2_1_1') {
					this.changetableval(
						'zzs_2_12_1',
						'tableDataII_I',
						this.gettableval('zzs_2_1_1', 'tableDataII_I') +
						this.gettableval('zzs_2_4_1', 'tableDataII_I') +
						this.gettableval('zzs_2_11_1', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_1_2') {
					this.changetableval(
						'zzs_2_12_2',
						'tableDataII_I',
						this.gettableval('zzs_2_1_2', 'tableDataII_I') +
						this.gettableval('zzs_2_4_2', 'tableDataII_I') +
						this.gettableval('zzs_2_11_2', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_1_3') {
					// if ((this.gettableval("zzs_2_9_3", 'tableDataII_I') + this.gettableval("zzs_2_10_3",
					// 		'tableDataII_I')) > (this.gettableval("zzs_2_1_3", 'tableDataII_I') + this.gettableval(
					// 		"zzs_2_4_3",
					// 		'tableDataII_I'))) {
					// 	this.$message.error("zzs_2_9_3格子校验不正确")
					// 	this.$message.error("zzs_2_10_3格子校验不正确")
					// }
					this.changetableval(
						'zzs_2_12_3',
						'tableDataII_I',
						this.gettableval('zzs_2_1_3', 'tableDataII_I') +
						this.gettableval('zzs_2_4_3', 'tableDataII_I') +
						this.gettableval('zzs_2_11_3', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_2_1') {
					this.changetableval(
						'zzs_2_1_1',
						'tableDataII_I',
						this.gettableval('zzs_2_2_1', 'tableDataII_I') + this.gettableval('zzs_2_3_1', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_2_2') {
					this.changetableval(
						'zzs_2_1_2',
						'tableDataII_I',
						this.gettableval('zzs_2_2_2', 'tableDataII_I') + this.gettableval('zzs_2_3_2', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_2_3') {
					this.changetableval(
						'zzs_2_1_3',
						'tableDataII_I',
						this.gettableval('zzs_2_2_3', 'tableDataII_I') + this.gettableval('zzs_2_3_3', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_3_1') {
					this.changetableval(
						'zzs_2_1_1',
						'tableDataII_I',
						this.gettableval('zzs_2_2_1', 'tableDataII_I') + this.gettableval('zzs_2_3_1', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_3_2') {
					this.changetableval(
						'zzs_2_1_2',
						'tableDataII_I',
						this.gettableval('zzs_2_2_2', 'tableDataII_I') + this.gettableval('zzs_2_3_2', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_3_3') {
					this.changetableval(
						'zzs_2_1_3',
						'tableDataII_I',
						this.gettableval('zzs_2_2_3', 'tableDataII_I') + this.gettableval('zzs_2_3_3', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_4_1') {
					this.changetableval(
						'zzs_2_12_1',
						'tableDataII_I',
						this.gettableval('zzs_2_1_1', 'tableDataII_I') +
						this.gettableval('zzs_2_4_1', 'tableDataII_I') +
						this.gettableval('zzs_2_11_1', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_4_2') {
					this.changetableval(
						'zzs_2_12_2',
						'tableDataII_I',
						this.gettableval('zzs_2_1_2', 'tableDataII_I') +
						this.gettableval('zzs_2_4_2', 'tableDataII_I') +
						this.gettableval('zzs_2_11_2', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_4_3') {
					// if ((this.gettableval("zzs_2_9_3", 'tableDataII_I') + this.gettableval("zzs_2_10_3",
					// 		'tableDataII_I')) > (this.gettableval("zzs_2_1_3", 'tableDataII_I') + this.gettableval(
					// 		"zzs_2_4_3",
					// 		'tableDataII_I'))) {
					// 	this.$message.error("zzs_2_9_3格子校验不正确")
					// 	this.$message.error("zzs_2_10_3格子校验不正确")
					// }
					this.changetableval(
						'zzs_2_12_3',
						'tableDataII_I',
						this.gettableval('zzs_2_1_3', 'tableDataII_I') +
						this.gettableval('zzs_2_4_3', 'tableDataII_I') +
						this.gettableval('zzs_2_11_3', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_5_1') {
					this.changetableval(
						'zzs_2_4_1',
						'tableDataII_I',
						this.gettableval('zzs_2_5_1', 'tableDataII_I') +
						this.gettableval('zzs_2_6_1', 'tableDataII_I') +
						this.gettableval('zzs_2_7_1', 'tableDataII_I') +
						this.gettableval('zzs_2_8a_1', 'tableDataII_I') +
						this.gettableval('zzs_2_8b_1', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_5_2') {
					this.changetableval(
						'zzs_2_4_2',
						'tableDataII_I',
						this.gettableval('zzs_2_5_2', 'tableDataII_I') +
						this.gettableval('zzs_2_6_2', 'tableDataII_I') +
						this.gettableval('zzs_2_7_2', 'tableDataII_I') +
						this.gettableval('zzs_2_8a_2', 'tableDataII_I') +
						this.gettableval('zzs_2_8b_2', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_5_3') {
					this.changetableval(
						'zzs_2_4_3',
						'tableDataII_I',
						this.gettableval('zzs_2_5_3', 'tableDataII_I') +
						this.gettableval('zzs_2_6_3', 'tableDataII_I') +
						this.gettableval('zzs_2_7_3', 'tableDataII_I') +
						this.gettableval('zzs_2_8a_3', 'tableDataII_I') +
						this.gettableval('zzs_2_8b_3', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_6_1') {
					this.changetableval(
						'zzs_2_4_1',
						'tableDataII_I',
						this.gettableval('zzs_2_5_1', 'tableDataII_I') +
						this.gettableval('zzs_2_6_1', 'tableDataII_I') +
						this.gettableval('zzs_2_7_1', 'tableDataII_I') +
						this.gettableval('zzs_2_8a_1', 'tableDataII_I') +
						this.gettableval('zzs_2_8b_1', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_6_2') {
					this.changetableval(
						'zzs_2_4_2',
						'tableDataII_I',
						this.gettableval('zzs_2_5_2', 'tableDataII_I') +
						this.gettableval('zzs_2_6_2', 'tableDataII_I') +
						this.gettableval('zzs_2_7_2', 'tableDataII_I') +
						this.gettableval('zzs_2_8a_2', 'tableDataII_I') +
						this.gettableval('zzs_2_8b_2', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_6_3') {
					this.changetableval(
						'zzs_2_4_3',
						'tableDataII_I',
						this.gettableval('zzs_2_5_3', 'tableDataII_I') +
						this.gettableval('zzs_2_6_3', 'tableDataII_I') +
						this.gettableval('zzs_2_7_3', 'tableDataII_I') +
						this.gettableval('zzs_2_8a_3', 'tableDataII_I') +
						this.gettableval('zzs_2_8b_3', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_7_1') {
					this.changetableval(
						'zzs_2_4_1',
						'tableDataII_I',
						this.gettableval('zzs_2_5_1', 'tableDataII_I') +
						this.gettableval('zzs_2_6_1', 'tableDataII_I') +
						this.gettableval('zzs_2_7_1', 'tableDataII_I') +
						this.gettableval('zzs_2_8a_1', 'tableDataII_I') +
						this.gettableval('zzs_2_8b_1', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_7_2') {
					this.changetableval(
						'zzs_2_4_2',
						'tableDataII_I',
						this.gettableval('zzs_2_5_2', 'tableDataII_I') +
						this.gettableval('zzs_2_6_2', 'tableDataII_I') +
						this.gettableval('zzs_2_7_2', 'tableDataII_I') +
						this.gettableval('zzs_2_8a_2', 'tableDataII_I') +
						this.gettableval('zzs_2_8b_2', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_7_3') {
					this.changetableval(
						'zzs_2_4_3',
						'tableDataII_I',
						this.gettableval('zzs_2_5_3', 'tableDataII_I') +
						this.gettableval('zzs_2_6_3', 'tableDataII_I') +
						this.gettableval('zzs_2_7_3', 'tableDataII_I') +
						this.gettableval('zzs_2_8a_3', 'tableDataII_I') +
						this.gettableval('zzs_2_8b_3', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_8a_1') {
					this.changetableval(
						'zzs_2_4_1',
						'tableDataII_I',
						this.gettableval('zzs_2_5_1', 'tableDataII_I') +
						this.gettableval('zzs_2_6_1', 'tableDataII_I') +
						this.gettableval('zzs_2_7_1', 'tableDataII_I') +
						this.gettableval('zzs_2_8a_1', 'tableDataII_I') +
						this.gettableval('zzs_2_8b_1', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_8a_2') {
					this.changetableval(
						'zzs_2_4_2',
						'tableDataII_I',
						this.gettableval('zzs_2_5_2', 'tableDataII_I') +
						this.gettableval('zzs_2_6_2', 'tableDataII_I') +
						this.gettableval('zzs_2_7_2', 'tableDataII_I') +
						this.gettableval('zzs_2_8a_2', 'tableDataII_I') +
						this.gettableval('zzs_2_8b_2', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_8a_3') {
					this.changetableval(
						'zzs_2_4_3',
						'tableDataII_I',
						this.gettableval('zzs_2_5_3', 'tableDataII_I') +
						this.gettableval('zzs_2_6_3', 'tableDataII_I') +
						this.gettableval('zzs_2_7_3', 'tableDataII_I') +
						this.gettableval('zzs_2_8a_3', 'tableDataII_I') +
						this.gettableval('zzs_2_8b_3', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_8b_1') {
					this.changetableval(
						'zzs_2_4_1',
						'tableDataII_I',
						this.gettableval('zzs_2_5_1', 'tableDataII_I') +
						this.gettableval('zzs_2_6_1', 'tableDataII_I') +
						this.gettableval('zzs_2_7_1', 'tableDataII_I') +
						this.gettableval('zzs_2_8a_1', 'tableDataII_I') +
						this.gettableval('zzs_2_8b_1', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_8b_2') {
					this.changetableval(
						'zzs_2_4_2',
						'tableDataII_I',
						this.gettableval('zzs_2_5_2', 'tableDataII_I') +
						this.gettableval('zzs_2_6_2', 'tableDataII_I') +
						this.gettableval('zzs_2_7_2', 'tableDataII_I') +
						this.gettableval('zzs_2_8a_2', 'tableDataII_I') +
						this.gettableval('zzs_2_8b_2', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_8b_3') {
					this.changetableval(
						'zzs_2_4_3',
						'tableDataII_I',
						this.gettableval('zzs_2_5_3', 'tableDataII_I') +
						this.gettableval('zzs_2_6_3', 'tableDataII_I') +
						this.gettableval('zzs_2_7_3', 'tableDataII_I') +
						this.gettableval('zzs_2_8a_3', 'tableDataII_I') +
						this.gettableval('zzs_2_8b_3', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_9_2') {
					// if (this.gettableval("zzs_2_9_2", 'tableDataII_I') < 0) {
					// 	this.$message.error("zzs_2_9_3格子校验不正确")
					// }
				}
				if (e.cellCode == 'zzs_2_9_3') {
					// if ((this.gettableval("zzs_2_9_3", 'tableDataII_I') + this.gettableval("zzs_2_10_3",
					// 		'tableDataII_I')) > (this.gettableval("zzs_2_1_3", 'tableDataII_I') + this.gettableval(
					// 		"zzs_2_4_3",
					// 		'tableDataII_I'))) {
					// 	this.$message.error("zzs_2_9_3格子校验不正确")
					// } else if (this.gettableval("zzs_2_9_3", 'tableDataII_I') < 0) {
					// 	this.$message.error("zzs_2_9_3格子校验不正确")
					// }
				}
				// if (e.cellCode == 'zzs_2_10_1') {
				// 	this.changetableval('zzs_2_8b_1', 'tableDataII_I', this.gettableval('zzs_2_10_1', 'tableDataII_I'));
				// }
				// if (e.cellCode == 'zzs_2_10_2') {
				// 	this.changetableval('zzs_2_8b_2', 'tableDataII_I', this.gettableval('zzs_2_10_2', 'tableDataII_I'));
				// 	// if (this.gettableval("zzs_2_10_2", 'tableDataII_I') < 0) {
				// 	// 	this.$message.error("zzs_2_10_2格子校验不正确")
				// 	// }
				// }
				// if (e.cellCode == 'zzs_2_10_3') {
				// 	// if ((this.gettableval("zzs_2_9_3", 'tableDataII_I') + this.gettableval("zzs_2_10_3",
				// 	// 		'tableDataII_I')) > (this.gettableval("zzs_2_1_3", 'tableDataII_I') + this.gettableval(
				// 	// 		"zzs_2_4_3",
				// 	// 		'tableDataII_I'))) {
				// 	// 	this.$message.error("zzs_2_9_3格子校验不正确")
				// 	// 	this.$message.error("zzs_2_10_3格子校验不正确")
				// 	// } else if (this.gettableval("zzs_2_10_3", 'tableDataII_I') < 0) {
				// 	// 	this.$message.error("zzs_2_10_3格子校验不正确")
				// 	// }
				// 	this.changetableval('zzs_2_8b_3', 'tableDataII_I', this.gettableval('zzs_2_10_3', 'tableDataII_I'));
				// }
				if (e.cellCode == 'zzs_2_11_1') {
					this.changetableval(
						'zzs_2_12_1',
						'tableDataII_I',
						this.gettableval('zzs_2_1_1', 'tableDataII_I') +
						this.gettableval('zzs_2_4_1', 'tableDataII_I') +
						this.gettableval('zzs_2_11_1', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_11_2') {
					this.changetableval(
						'zzs_2_12_2',
						'tableDataII_I',
						this.gettableval('zzs_2_1_2', 'tableDataII_I') +
						this.gettableval('zzs_2_4_2', 'tableDataII_I') +
						this.gettableval('zzs_2_11_2', 'tableDataII_I')
					);
				}
				if (e.cellCode == 'zzs_2_11_3') {
					this.changetableval(
						'zzs_2_12_3',
						'tableDataII_I',
						this.gettableval('zzs_2_1_3', 'tableDataII_I') +
						this.gettableval('zzs_2_4_3', 'tableDataII_I') +
						this.gettableval('zzs_2_11_3', 'tableDataII_I')
					);
					// if ((this.gettableval("zzs_0_12_1", 'tableDataZero') + this.gettableval("zzs_0_12_3",
					// 		'tableDataZero')) != this.gettableval("zzs_2_12_3", 'tableDataII_I')) {
					// 	this.$message.error("zzs_2_12_3格子校验不正确")
					// }
				}
				if (e.cellCode == 'zzs_2_12_3') {
					this.changetableval(
						'zzs_0_12_1',
						'tableDataZero',
						this.gettableval('zzs_2_12_3', 'tableDataII_I') - this.gettableval('zzs_0_12_3',
							'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_2_13_1') {
					// if ((this.gettableval("zzs_2_13_1", 'tableDataII_II') - this.gettableval("zzs_0_14_3",
					// 		'tableDataZero')) != this.gettableval("zzs_0_14_1", 'tableDataZero')) {
					// 	this.$message.error("zzs_0_14_1格子校验不正确")
					// }
					this.changetableval(
						'zzs_0_14_1',
						'tableDataZero',
						this.gettableval('zzs_2_13_1', 'tableDataII_II') - this.gettableval('zzs_0_14_3',
							'tableDataZero')
					);
					this.changetableval(
						'zzs_0_14_3',
						'tableDataZero',
						this.gettableval('zzs_2_13_1', 'tableDataII_II') - this.gettableval('zzs_0_14_1',
							'tableDataZero')
					);
				}
				if (e.cellCode == 'zzs_2_14_1') {
					this.changetableval(
						'zzs_2_13_1',
						'tableDataII_II',
						this.gettableval('zzs_2_14_1', 'tableDataII_II') +
						this.gettableval('zzs_2_15_1', 'tableDataII_II') +
						this.gettableval('zzs_2_16_1', 'tableDataII_II') +
						this.gettableval('zzs_2_17_1', 'tableDataII_II') +
						this.gettableval('zzs_2_18_1', 'tableDataII_II') +
						this.gettableval('zzs_2_19_1', 'tableDataII_II') +
						this.gettableval('zzs_2_20_1', 'tableDataII_II') +
						this.gettableval('zzs_2_21_1', 'tableDataII_II') +
						this.gettableval('zzs_2_22_1', 'tableDataII_II') +
						this.gettableval('zzs_2_23a_1', 'tableDataII_II') +
						this.gettableval('zzs_2_23b_1', 'tableDataII_II')
					);
				}
				if (e.cellCode == 'zzs_2_15_1') {
					this.changetableval(
						'zzs_2_13_1',
						'tableDataII_II',
						this.gettableval('zzs_2_14_1', 'tableDataII_II') +
						this.gettableval('zzs_2_15_1', 'tableDataII_II') +
						this.gettableval('zzs_2_16_1', 'tableDataII_II') +
						this.gettableval('zzs_2_17_1', 'tableDataII_II') +
						this.gettableval('zzs_2_18_1', 'tableDataII_II') +
						this.gettableval('zzs_2_19_1', 'tableDataII_II') +
						this.gettableval('zzs_2_20_1', 'tableDataII_II') +
						this.gettableval('zzs_2_21_1', 'tableDataII_II') +
						this.gettableval('zzs_2_22_1', 'tableDataII_II') +
						this.gettableval('zzs_2_23a_1', 'tableDataII_II') +
						this.gettableval('zzs_2_23b_1', 'tableDataII_II')
					);
				}
				if (e.cellCode == 'zzs_2_16_1') {
					this.changetableval(
						'zzs_2_13_1',
						'tableDataII_II',
						this.gettableval('zzs_2_14_1', 'tableDataII_II') +
						this.gettableval('zzs_2_15_1', 'tableDataII_II') +
						this.gettableval('zzs_2_16_1', 'tableDataII_II') +
						this.gettableval('zzs_2_17_1', 'tableDataII_II') +
						this.gettableval('zzs_2_18_1', 'tableDataII_II') +
						this.gettableval('zzs_2_19_1', 'tableDataII_II') +
						this.gettableval('zzs_2_20_1', 'tableDataII_II') +
						this.gettableval('zzs_2_21_1', 'tableDataII_II') +
						this.gettableval('zzs_2_22_1', 'tableDataII_II') +
						this.gettableval('zzs_2_23a_1', 'tableDataII_II') +
						this.gettableval('zzs_2_23b_1', 'tableDataII_II')
					);
				}
				if (e.cellCode == 'zzs_2_17_1') {
					this.changetableval(
						'zzs_2_13_1',
						'tableDataII_II',
						this.gettableval('zzs_2_14_1', 'tableDataII_II') +
						this.gettableval('zzs_2_15_1', 'tableDataII_II') +
						this.gettableval('zzs_2_16_1', 'tableDataII_II') +
						this.gettableval('zzs_2_17_1', 'tableDataII_II') +
						this.gettableval('zzs_2_18_1', 'tableDataII_II') +
						this.gettableval('zzs_2_19_1', 'tableDataII_II') +
						this.gettableval('zzs_2_20_1', 'tableDataII_II') +
						this.gettableval('zzs_2_21_1', 'tableDataII_II') +
						this.gettableval('zzs_2_22_1', 'tableDataII_II') +
						this.gettableval('zzs_2_23a_1', 'tableDataII_II') +
						this.gettableval('zzs_2_23b_1', 'tableDataII_II')
					);
				}
				if (e.cellCode == 'zzs_2_18_1') {
					this.changetableval(
						'zzs_2_13_1',
						'tableDataII_II',
						this.gettableval('zzs_2_14_1', 'tableDataII_II') +
						this.gettableval('zzs_2_15_1', 'tableDataII_II') +
						this.gettableval('zzs_2_16_1', 'tableDataII_II') +
						this.gettableval('zzs_2_17_1', 'tableDataII_II') +
						this.gettableval('zzs_2_18_1', 'tableDataII_II') +
						this.gettableval('zzs_2_19_1', 'tableDataII_II') +
						this.gettableval('zzs_2_20_1', 'tableDataII_II') +
						this.gettableval('zzs_2_21_1', 'tableDataII_II') +
						this.gettableval('zzs_2_22_1', 'tableDataII_II') +
						this.gettableval('zzs_2_23a_1', 'tableDataII_II') +
						this.gettableval('zzs_2_23b_1', 'tableDataII_II')
					);
				}
				if (e.cellCode == 'zzs_2_18_1') {
					this.changetableval(
						'zzs_2_13_1',
						'tableDataII_II',
						this.gettableval('zzs_2_14_1', 'tableDataII_II') +
						this.gettableval('zzs_2_15_1', 'tableDataII_II') +
						this.gettableval('zzs_2_16_1', 'tableDataII_II') +
						this.gettableval('zzs_2_17_1', 'tableDataII_II') +
						this.gettableval('zzs_2_18_1', 'tableDataII_II') +
						this.gettableval('zzs_2_19_1', 'tableDataII_II') +
						this.gettableval('zzs_2_20_1', 'tableDataII_II') +
						this.gettableval('zzs_2_21_1', 'tableDataII_II') +
						this.gettableval('zzs_2_22_1', 'tableDataII_II') +
						this.gettableval('zzs_2_23a_1', 'tableDataII_II') +
						this.gettableval('zzs_2_23b_1', 'tableDataII_II')
					);
				}
				if (e.cellCode == 'zzs_2_19_1') {
					// if (this.gettableval("zzs_0_16_1", 'tableDataZero') > (this.gettableval("zzs_1_1_8", 'tableDataI') +
					// 		this.gettableval("zzs_1_2_8", 'tableDataI') + this.gettableval("zzs_1_3_8", 'tableDataI') +
					// 		this.gettableval("zzs_1_4_8", 'tableDataI') + this.gettableval("zzs_1_5_8", 'tableDataI') +
					// 		this.gettableval("zzs_2_19_1", 'tableDataII_II'))) {
					// 	this.$message.error("zzs_0_16_1格子校验不正确")
					// }
					this.changetableval(
						'zzs_2_13_1',
						'tableDataII_II',
						this.gettableval('zzs_2_14_1', 'tableDataII_II') +
						this.gettableval('zzs_2_15_1', 'tableDataII_II') +
						this.gettableval('zzs_2_16_1', 'tableDataII_II') +
						this.gettableval('zzs_2_17_1', 'tableDataII_II') +
						this.gettableval('zzs_2_18_1', 'tableDataII_II') +
						this.gettableval('zzs_2_19_1', 'tableDataII_II') +
						this.gettableval('zzs_2_20_1', 'tableDataII_II') +
						this.gettableval('zzs_2_21_1', 'tableDataII_II') +
						this.gettableval('zzs_2_22_1', 'tableDataII_II') +
						this.gettableval('zzs_2_23a_1', 'tableDataII_II') +
						this.gettableval('zzs_2_23b_1', 'tableDataII_II')
					);
				}
				if (e.cellCode == 'zzs_2_20_1') {
					this.changetableval(
						'zzs_2_13_1',
						'tableDataII_II',
						this.gettableval('zzs_2_14_1', 'tableDataII_II') +
						this.gettableval('zzs_2_15_1', 'tableDataII_II') +
						this.gettableval('zzs_2_16_1', 'tableDataII_II') +
						this.gettableval('zzs_2_17_1', 'tableDataII_II') +
						this.gettableval('zzs_2_18_1', 'tableDataII_II') +
						this.gettableval('zzs_2_19_1', 'tableDataII_II') +
						this.gettableval('zzs_2_20_1', 'tableDataII_II') +
						this.gettableval('zzs_2_21_1', 'tableDataII_II') +
						this.gettableval('zzs_2_22_1', 'tableDataII_II') +
						this.gettableval('zzs_2_23a_1', 'tableDataII_II') +
						this.gettableval('zzs_2_23b_1', 'tableDataII_II')
					);
				}
				if (e.cellCode == 'zzs_2_21_1') {
					this.changetableval(
						'zzs_2_13_1',
						'tableDataII_II',
						this.gettableval('zzs_2_14_1', 'tableDataII_II') +
						this.gettableval('zzs_2_15_1', 'tableDataII_II') +
						this.gettableval('zzs_2_16_1', 'tableDataII_II') +
						this.gettableval('zzs_2_17_1', 'tableDataII_II') +
						this.gettableval('zzs_2_18_1', 'tableDataII_II') +
						this.gettableval('zzs_2_19_1', 'tableDataII_II') +
						this.gettableval('zzs_2_20_1', 'tableDataII_II') +
						this.gettableval('zzs_2_21_1', 'tableDataII_II') +
						this.gettableval('zzs_2_22_1', 'tableDataII_II') +
						this.gettableval('zzs_2_23a_1', 'tableDataII_II') +
						this.gettableval('zzs_2_23b_1', 'tableDataII_II')
					);
				}
				if (e.cellCode == 'zzs_2_22_1') {
					this.changetableval(
						'zzs_2_13_1',
						'tableDataII_II',
						this.gettableval('zzs_2_14_1', 'tableDataII_II') +
						this.gettableval('zzs_2_15_1', 'tableDataII_II') +
						this.gettableval('zzs_2_16_1', 'tableDataII_II') +
						this.gettableval('zzs_2_17_1', 'tableDataII_II') +
						this.gettableval('zzs_2_18_1', 'tableDataII_II') +
						this.gettableval('zzs_2_19_1', 'tableDataII_II') +
						this.gettableval('zzs_2_20_1', 'tableDataII_II') +
						this.gettableval('zzs_2_21_1', 'tableDataII_II') +
						this.gettableval('zzs_2_22_1', 'tableDataII_II') +
						this.gettableval('zzs_2_23a_1', 'tableDataII_II') +
						this.gettableval('zzs_2_23b_1', 'tableDataII_II')
					);
					this.changetableval('zzs_5_8_1', 'tableDataV_II', this.gettableval('zzs_2_22_1', 'tableDataII_II'));
				}
				if (e.cellCode == 'zzs_2_23a_1') {
					this.changetableval(
						'zzs_2_13_1',
						'tableDataII_II',
						this.gettableval('zzs_2_14_1', 'tableDataII_II') +
						this.gettableval('zzs_2_15_1', 'tableDataII_II') +
						this.gettableval('zzs_2_16_1', 'tableDataII_II') +
						this.gettableval('zzs_2_17_1', 'tableDataII_II') +
						this.gettableval('zzs_2_18_1', 'tableDataII_II') +
						this.gettableval('zzs_2_19_1', 'tableDataII_II') +
						this.gettableval('zzs_2_20_1', 'tableDataII_II') +
						this.gettableval('zzs_2_21_1', 'tableDataII_II') +
						this.gettableval('zzs_2_22_1', 'tableDataII_II') +
						this.gettableval('zzs_2_23a_1', 'tableDataII_II') +
						this.gettableval('zzs_2_23b_1', 'tableDataII_II')
					);
				}
				if (e.cellCode == 'zzs_2_23b_1') {
					this.changetableval(
						'zzs_2_13_1',
						'tableDataII_II',
						this.gettableval('zzs_2_14_1', 'tableDataII_II') +
						this.gettableval('zzs_2_15_1', 'tableDataII_II') +
						this.gettableval('zzs_2_16_1', 'tableDataII_II') +
						this.gettableval('zzs_2_17_1', 'tableDataII_II') +
						this.gettableval('zzs_2_18_1', 'tableDataII_II') +
						this.gettableval('zzs_2_19_1', 'tableDataII_II') +
						this.gettableval('zzs_2_20_1', 'tableDataII_II') +
						this.gettableval('zzs_2_21_1', 'tableDataII_II') +
						this.gettableval('zzs_2_22_1', 'tableDataII_II') +
						this.gettableval('zzs_2_23a_1', 'tableDataII_II') +
						this.gettableval('zzs_2_23b_1', 'tableDataII_II')
					);
				}
				if (e.cellCode == 'zzs_2_30_1') {
					this.changetableval(
						'zzs_2_29_1',
						'tableDataII_III',
						this.gettableval('zzs_2_30_1', 'tableDataII_III') +
						this.gettableval('zzs_2_31_1', 'tableDataII_III') +
						this.gettableval('zzs_2_32_1', 'tableDataII_III') +
						this.gettableval('zzs_2_33_1', 'tableDataII_III')
					);
				}
				if (e.cellCode == 'zzs_2_30_2') {
					this.changetableval(
						'zzs_2_29_2',
						'tableDataII_III',
						this.gettableval('zzs_2_30_2', 'tableDataII_III') +
						this.gettableval('zzs_2_31_2', 'tableDataII_III') +
						this.gettableval('zzs_2_32_2', 'tableDataII_III') +
						this.gettableval('zzs_2_33_2', 'tableDataII_III')
					);
				}
				if (e.cellCode == 'zzs_2_30_3') {
					this.changetableval(
						'zzs_2_29_3',
						'tableDataII_III',
						this.gettableval('zzs_2_30_3', 'tableDataII_III') +
						this.gettableval('zzs_2_31_3', 'tableDataII_III') +
						this.gettableval('zzs_2_32_3', 'tableDataII_III') +
						this.gettableval('zzs_2_33_3', 'tableDataII_III')
					);
				}
				if (e.cellCode == 'zzs_2_31_1') {
					this.changetableval(
						'zzs_2_29_1',
						'tableDataII_III',
						this.gettableval('zzs_2_30_1', 'tableDataII_III') +
						this.gettableval('zzs_2_31_1', 'tableDataII_III') +
						this.gettableval('zzs_2_32_1', 'tableDataII_III') +
						this.gettableval('zzs_2_33_1', 'tableDataII_III')
					);
				}
				if (e.cellCode == 'zzs_2_31_2') {
					this.changetableval(
						'zzs_2_29_2',
						'tableDataII_III',
						this.gettableval('zzs_2_30_2', 'tableDataII_III') +
						this.gettableval('zzs_2_31_2', 'tableDataII_III') +
						this.gettableval('zzs_2_32_2', 'tableDataII_III') +
						this.gettableval('zzs_2_33_2', 'tableDataII_III')
					);
				}
				if (e.cellCode == 'zzs_2_31_3') {
					this.changetableval(
						'zzs_2_29_3',
						'tableDataII_III',
						this.gettableval('zzs_2_30_3', 'tableDataII_III') +
						this.gettableval('zzs_2_31_3', 'tableDataII_III') +
						this.gettableval('zzs_2_32_3', 'tableDataII_III') +
						this.gettableval('zzs_2_33_3', 'tableDataII_III')
					);
				}
				if (e.cellCode == 'zzs_2_32_1') {
					this.changetableval(
						'zzs_2_29_1',
						'tableDataII_III',
						this.gettableval('zzs_2_30_1', 'tableDataII_III') +
						this.gettableval('zzs_2_31_1', 'tableDataII_III') +
						this.gettableval('zzs_2_32_1', 'tableDataII_III') +
						this.gettableval('zzs_2_33_1', 'tableDataII_III')
					);
				}
				if (e.cellCode == 'zzs_2_32_2') {
					this.changetableval(
						'zzs_2_29_2',
						'tableDataII_III',
						this.gettableval('zzs_2_30_2', 'tableDataII_III') +
						this.gettableval('zzs_2_31_2', 'tableDataII_III') +
						this.gettableval('zzs_2_32_2', 'tableDataII_III') +
						this.gettableval('zzs_2_33_2', 'tableDataII_III')
					);
				}
				if (e.cellCode == 'zzs_2_32_3') {
					this.changetableval(
						'zzs_2_29_3',
						'tableDataII_III',
						this.gettableval('zzs_2_30_3', 'tableDataII_III') +
						this.gettableval('zzs_2_31_3', 'tableDataII_III') +
						this.gettableval('zzs_2_32_3', 'tableDataII_III') +
						this.gettableval('zzs_2_33_3', 'tableDataII_III')
					);
				}
				if (e.cellCode == 'zzs_2_33_1') {
					this.changetableval(
						'zzs_2_29_1',
						'tableDataII_III',
						this.gettableval('zzs_2_30_1', 'tableDataII_III') +
						this.gettableval('zzs_2_31_1', 'tableDataII_III') +
						this.gettableval('zzs_2_32_1', 'tableDataII_III') +
						this.gettableval('zzs_2_33_1', 'tableDataII_III')
					);
				}
				if (e.cellCode == 'zzs_2_33_2') {
					this.changetableval(
						'zzs_2_29_2',
						'tableDataII_III',
						this.gettableval('zzs_2_30_2', 'tableDataII_III') +
						this.gettableval('zzs_2_31_2', 'tableDataII_III') +
						this.gettableval('zzs_2_32_2', 'tableDataII_III') +
						this.gettableval('zzs_2_33_2', 'tableDataII_III')
					);
				}
				if (e.cellCode == 'zzs_2_33_3') {
					this.changetableval(
						'zzs_2_29_3',
						'tableDataII_III',
						this.gettableval('zzs_2_30_3', 'tableDataII_III') +
						this.gettableval('zzs_2_31_3', 'tableDataII_III') +
						this.gettableval('zzs_2_32_3', 'tableDataII_III') +
						this.gettableval('zzs_2_33_3', 'tableDataII_III')
					);
				}
				if (e.cellCode == 'zzs_3_1_1') {
					// if ((this.gettableval("zzs_3_1_5", 'tableDataIII') > this.gettableval("zzs_3_1_1", 'tableDataIII')) ||
					// 	(this.gettableval("zzs_3_1_5", 'tableDataIII') > this.gettableval("zzs_3_1_4", 'tableDataIII'))) {
					// 	this.$message.error("zzs_3_1_5格子逻辑不正确")
					// }
				}
				if (e.cellCode == 'zzs_3_1_2') {
					this.changetableval(
						'zzs_3_1_4',
						'tableDataIII',
						this.gettableval('zzs_3_1_2', 'tableDataIII') + this.gettableval('zzs_3_1_3', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_1_3') {
					this.changetableval(
						'zzs_3_1_4',
						'tableDataIII',
						this.gettableval('zzs_3_1_2', 'tableDataIII') + this.gettableval('zzs_3_1_3', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_1_4') {
					// if ((this.gettableval("zzs_3_1_5", 'tableDataIII') > this.gettableval("zzs_3_1_1", 'tableDataIII')) ||
					// 	(this.gettableval("zzs_3_1_5", 'tableDataIII') > this.gettableval("zzs_3_1_4", 'tableDataIII'))) {
					// 	this.$message.error("zzs_3_1_5格子逻辑不正确")
					// }
					this.changetableval(
						'zzs_3_1_6',
						'tableDataIII',
						this.gettableval('zzs_3_1_4', 'tableDataIII') - this.gettableval('zzs_3_1_5', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_1_5') {
					// if ((this.gettableval("zzs_3_1_5", 'tableDataIII') > this.gettableval("zzs_3_1_1", 'tableDataIII')) ||
					// 	(this.gettableval("zzs_3_1_5", 'tableDataIII') > this.gettableval("zzs_3_1_4", 'tableDataIII'))) {
					// 	this.$message.error("zzs_3_1_5格子逻辑不正确")
					// }
					this.changetableval('zzs_1_2_12', 'tableDataI', this.gettableval('zzs_3_1_5', 'tableDataIII'));
					this.changetableval(
						'zzs_3_1_6',
						'tableDataIII',
						this.gettableval('zzs_3_1_4', 'tableDataIII') - this.gettableval('zzs_3_1_5', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_1_6') {
					this.changetableval('zzs_3_1_2', 'tableDataIII', this.gettableval('zzs_3_1_6', 'tableDataI', 'old'));
				}
				if (e.cellCode == 'zzs_3_2_1') {
					// if ((this.gettableval("zzs_3_2_5", 'tableDataIII') > this.gettableval("zzs_3_2_1", 'tableDataIII')) ||
					// 	(this.gettableval("zzs_3_2_5", 'tableDataIII') > this.gettableval("zzs_3_2_4", 'tableDataIII'))) {
					// 	this.$message.error("zzs_3_2_5格子逻辑不正确")
					// }
				}
				if (e.cellCode == 'zzs_3_2_2') {
					this.changetableval(
						'zzs_3_2_4',
						'tableDataIII',
						this.gettableval('zzs_3_2_2', 'tableDataIII') + this.gettableval('zzs_3_2_3', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_2_3') {
					this.changetableval(
						'zzs_3_2_4',
						'tableDataIII',
						this.gettableval('zzs_3_2_2', 'tableDataIII') + this.gettableval('zzs_3_2_3', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_2_4') {
					// if ((this.gettableval("zzs_3_2_5", 'tableDataIII') > this.gettableval("zzs_3_2_1", 'tableDataIII')) ||
					// 	(this.gettableval("zzs_3_2_5", 'tableDataIII') > this.gettableval("zzs_3_2_4", 'tableDataIII'))) {
					// 	this.$message.error("zzs_3_2_5格子逻辑不正确")
					// }
					this.changetableval(
						'zzs_3_2_6',
						'tableDataIII',
						this.gettableval('zzs_3_2_4', 'tableDataIII') - this.gettableval('zzs_3_2_5', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_2_5') {
					// if ((this.gettableval("zzs_3_2_5", 'tableDataIII') > this.gettableval("zzs_3_2_1", 'tableDataIII')) ||
					// 	(this.gettableval("zzs_3_2_5", 'tableDataIII') > this.gettableval("zzs_3_2_4", 'tableDataIII'))) {
					// 	this.$message.error("zzs_3_2_5格子逻辑不正确")
					// }
					this.changetableval('zzs_1_4_12', 'tableDataI', this.gettableval('zzs_3_2_5', 'tableDataIII'));
					this.changetableval(
						'zzs_3_2_6',
						'tableDataIII',
						this.gettableval('zzs_3_2_4', 'tableDataIII') - this.gettableval('zzs_3_2_5', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_2_6') {
					this.changetableval('zzs_3_2_2', 'tableDataIII', this.gettableval('zzs_3_2_6', 'tableDataI', 'old'));
				}
				if (e.cellCode == 'zzs_3_3_1') {
					// if ((this.gettableval("zzs_3_3_5", 'tableDataIII') > this.gettableval("zzs_3_3_1", 'tableDataIII')) ||
					// 	(this.gettableval("zzs_3_3_5", 'tableDataIII') > this.gettableval("zzs_3_3_4", 'tableDataIII'))) {
					// 	this.$message.error("zzs_3_2_5格子逻辑不正确")
					// }
					// if (this.gettableval("zzs_3_3_1", 'tableDataIII') + this.gettableval("zzs_3_4_1", 'tableDataIII') !=
					// 	this.gettableval("zzs_1_5_11", 'tableDataI')) {
					// 	this.$message.error("zzs_3_3_1格子逻辑不正确")
					// }
				}
				if (e.cellCode == 'zzs_3_3_2') {
					this.changetableval(
						'zzs_3_3_4',
						'tableDataIII',
						this.gettableval('zzs_3_3_2', 'tableDataIII') + this.gettableval('zzs_3_3_3', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_3_3') {
					this.changetableval(
						'zzs_3_3_4',
						'tableDataIII',
						this.gettableval('zzs_3_3_2', 'tableDataIII') + this.gettableval('zzs_3_3_3', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_3_4') {
					// if ((this.gettableval("zzs_3_3_5", 'tableDataIII') > this.gettableval("zzs_3_3_1", 'tableDataIII')) ||
					// 	(this.gettableval("zzs_3_3_5", 'tableDataIII') > this.gettableval("zzs_3_3_4", 'tableDataIII'))) {
					// 	this.$message.error("zzs_3_3_5格子逻辑不正确")
					// }
					this.changetableval(
						'zzs_3_3_6',
						'tableDataIII',
						this.gettableval('zzs_3_3_4', 'tableDataIII') - this.gettableval('zzs_3_3_5', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_3_5') {
					// if ((this.gettableval("zzs_3_3_5", 'tableDataIII') > this.gettableval("zzs_3_3_1", 'tableDataIII')) ||
					// 	(this.gettableval("zzs_3_3_5", 'tableDataIII') > this.gettableval("zzs_3_3_4", 'tableDataIII'))) {
					// 	this.$message.error("zzs_3_3_5格子逻辑不正确")
					// }
					this.changetableval(
						'zzs_1_5_12',
						'tableDataI',
						this.gettableval('zzs_3_3_5', 'tableDataIII') + this.gettableval('zzs_3_4_5', 'tableDataIII')
					);
					this.changetableval(
						'zzs_3_3_6',
						'tableDataIII',
						this.gettableval('zzs_3_3_4', 'tableDataIII') - this.gettableval('zzs_3_3_5', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_3_6') {
					this.changetableval('zzs_3_3_2', 'tableDataIII', this.gettableval('zzs_3_3_6', 'tableDataIII', 'old'));
				}
				if (e.cellCode == 'zzs_3_4_1') {
					// if (this.gettableval("zzs_3_3_1", 'tableDataIII') + this.gettableval("zzs_3_4_1", 'tableDataIII') !=
					// 	this.gettableval("zzs_1_5_11", 'tableDataI')) {
					// 	this.$message.error("zzs_3_3_1格子逻辑不正确")
					// }
					// if ((this.gettableval("zzs_3_4_5", 'tableDataIII') > this.gettableval("zzs_3_4_1", 'tableDataIII')) ||
					// 	(this.gettableval("zzs_3_4_5", 'tableDataIII') > this.gettableval("zzs_3_4_4", 'tableDataIII'))) {
					// 	this.$message.error("zzs_3_4_5格子逻辑不正确")
					// }
				}
				if (e.cellCode == 'zzs_3_4_2') {
					this.changetableval(
						'zzs_3_4_4',
						'tableDataIII',
						this.gettableval('zzs_3_4_2', 'tableDataIII') + this.gettableval('zzs_3_4_3', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_4_3') {
					this.changetableval(
						'zzs_3_4_4',
						'tableDataIII',
						this.gettableval('zzs_3_4_2', 'tableDataIII') + this.gettableval('zzs_3_4_3', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_4_4') {
					// if ((this.gettableval("zzs_3_4_5", 'tableDataIII') > this.gettableval("zzs_3_4_1", 'tableDataIII')) ||
					// 	(this.gettableval("zzs_3_4_5", 'tableDataIII') > this.gettableval("zzs_3_4_4", 'tableDataIII'))) {
					// 	this.$message.error("zzs_3_4_5格子逻辑不正确")
					// }
					this.changetableval(
						'zzs_3_4_6',
						'tableDataIII',
						this.gettableval('zzs_3_4_4', 'tableDataIII') - this.gettableval('zzs_3_4_5', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_4_5') {
					// if ((this.gettableval("zzs_3_4_5", 'tableDataIII') > this.gettableval("zzs_3_4_1", 'tableDataIII')) ||
					// 	(this.gettableval("zzs_3_4_5", 'tableDataIII') > this.gettableval("zzs_3_4_4", 'tableDataIII'))) {
					// 	this.$message.error("zzs_3_4_5格子逻辑不正确")
					// }
					this.changetableval(
						'zzs_1_5_12',
						'tableDataI',
						this.gettableval('zzs_3_3_5', 'tableDataIII') + this.gettableval('zzs_3_4_5', 'tableDataIII')
					);
					this.changetableval(
						'zzs_3_4_6',
						'tableDataIII',
						this.gettableval('zzs_3_4_4', 'tableDataIII') - this.gettableval('zzs_3_4_5', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_4_6') {
					if (this.suosq.substring(5, 6) < 2) {
						this.changetableval('zzs_3_4_2', 'tableDataIII', 0);
					}
					this.changetableval('zzs_3_4_2', 'tableDataIII', this.gettableval('zzs_3_4_6', 'tableDataIII', 'old'));
				}
				if (e.cellCode == 'zzs_3_5_1') {
					// if ((this.gettableval("zzs_3_5_5", 'tableDataIII') > this.gettableval("zzs_3_5_1", 'tableDataIII')) ||
					// 	(this.gettableval("zzs_3_5_5", 'tableDataIII') > this.gettableval("zzs_3_5_4", 'tableDataIII'))) {
					// 	this.$message.error("zzs_3_5_5格子逻辑不正确")
					// }
				}
				if (e.cellCode == 'zzs_3_5_2') {
					this.changetableval(
						'zzs_3_5_4',
						'tableDataIII',
						this.gettableval('zzs_3_5_2', 'tableDataIII') + this.gettableval('zzs_3_5_3', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_5_3') {
					this.changetableval(
						'zzs_3_5_4',
						'tableDataIII',
						this.gettableval('zzs_3_5_2', 'tableDataIII') + this.gettableval('zzs_3_5_3', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_5_4') {
					// if ((this.gettableval("zzs_3_5_5", 'tableDataIII') > this.gettableval("zzs_3_5_1", 'tableDataIII')) ||
					// 	(this.gettableval("zzs_3_5_5", 'tableDataIII') > this.gettableval("zzs_3_5_4", 'tableDataIII'))) {
					// 	this.$message.error("zzs_3_5_5格子逻辑不正确")
					// }
					this.changetableval(
						'zzs_3_5_6',
						'tableDataIII',
						this.gettableval('zzs_3_5_4', 'tableDataIII') - this.gettableval('zzs_3_5_5', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_5_5') {
					// if ((this.gettableval("zzs_3_5_5", 'tableDataIII') > this.gettableval("zzs_3_5_1", 'tableDataIII')) ||
					// 	(this.gettableval("zzs_3_5_5", 'tableDataIII') > this.gettableval("zzs_3_5_4", 'tableDataIII'))) {
					// 	this.$message.error("zzs_3_5_5格子逻辑不正确")
					// }
					this.changetableval('zzs_1_9b_12', 'tableDataI', this.gettableval('zzs_3_5_5', 'tableDataIII'));
					this.changetableval(
						'zzs_3_5_6',
						'tableDataIII',
						this.gettableval('zzs_3_5_4', 'tableDataIII') - this.gettableval('zzs_3_5_5', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_5_6') {
					this.changetableval('zzs_3_5_2', 'tableDataIII', this.gettableval('zzs_3_5_6', 'tableDataIII', 'old'));
				}
				if (e.cellCode == 'zzs_3_6_1') {
					// if ((this.gettableval("zzs_3_6_5", 'tableDataIII') > this.gettableval("zzs_3_6_1", 'tableDataIII')) ||
					// 	(this.gettableval("zzs_3_6_5", 'tableDataIII') > this.gettableval("zzs_3_6_4", 'tableDataIII'))) {
					// 	this.$message.error("zzs_3_6_5格子逻辑不正确")
					// }
				}
				if (e.cellCode == 'zzs_3_6_2') {
					this.changetableval(
						'zzs_3_6_4',
						'tableDataIII',
						this.gettableval('zzs_3_6_2', 'tableDataIII') + this.gettableval('zzs_3_6_3', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_6_3') {
					this.changetableval(
						'zzs_3_6_4',
						'tableDataIII',
						this.gettableval('zzs_3_6_2', 'tableDataIII') + this.gettableval('zzs_3_6_3', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_6_4') {
					// if ((this.gettableval("zzs_3_6_5", 'tableDataIII') > this.gettableval("zzs_3_6_1", 'tableDataIII')) ||
					// 	(this.gettableval("zzs_3_6_5", 'tableDataIII') > this.gettableval("zzs_3_6_4", 'tableDataIII'))) {
					// 	this.$message.error("zzs_3_6_5格子逻辑不正确")
					// }
					this.changetableval(
						'zzs_3_6_6',
						'tableDataIII',
						this.gettableval('zzs_3_6_4', 'tableDataIII') - this.gettableval('zzs_3_6_5', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_6_5') {
					// if ((this.gettableval("zzs_3_6_5", 'tableDataIII') > this.gettableval("zzs_3_6_1", 'tableDataIII')) ||
					// 	(this.gettableval("zzs_3_6_5", 'tableDataIII') > this.gettableval("zzs_3_6_4", 'tableDataIII'))) {
					// 	this.$message.error("zzs_3_6_5格子逻辑不正确")
					// }
					this.changetableval('zzs_1_12_12', 'tableDataI', this.gettableval('zzs_3_6_5', 'tableDataIII'));
					this.changetableval(
						'zzs_3_6_6',
						'tableDataIII',
						this.gettableval('zzs_3_6_4', 'tableDataIII') - this.gettableval('zzs_3_6_5', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_6_6') {
					this.changetableval('zzs_3_6_2', 'tableDataIII', this.gettableval('zzs_3_6_6', 'tableDataIII', 'old'));
				}
				if (e.cellCode == 'zzs_3_7_1') {
					// if ((this.gettableval("zzs_3_7_5", 'tableDataIII') > this.gettableval("zzs_3_7_1", 'tableDataIII')) ||
					// 	(this.gettableval("zzs_3_7_5", 'tableDataIII') > this.gettableval("zzs_3_7_4", 'tableDataIII'))) {
					// 	this.$message.error("zzs_3_7_5格子逻辑不正确")
					// }
				}
				if (e.cellCode == 'zzs_3_7_2') {
					this.changetableval(
						'zzs_3_7_4',
						'tableDataIII',
						this.gettableval('zzs_3_7_2', 'tableDataIII') + this.gettableval('zzs_3_7_3', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_7_3') {
					this.changetableval(
						'zzs_3_7_4',
						'tableDataIII',
						this.gettableval('zzs_3_7_2', 'tableDataIII') + this.gettableval('zzs_3_7_3', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_7_4') {
					// if ((this.gettableval("zzs_3_7_5", 'tableDataIII') > this.gettableval("zzs_3_7_1", 'tableDataIII')) ||
					// 	(this.gettableval("zzs_3_7_5", 'tableDataIII') > this.gettableval("zzs_3_7_4", 'tableDataIII'))) {
					// 	this.$message.error("zzs_3_7_5格子逻辑不正确")
					// }
					this.changetableval(
						'zzs_3_7_6',
						'tableDataIII',
						this.gettableval('zzs_3_7_4', 'tableDataIII') - this.gettableval('zzs_3_7_5', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_7_5') {
					// if ((this.gettableval("zzs_3_7_5", 'tableDataIII') > this.gettableval("zzs_3_7_1", 'tableDataIII')) ||
					// 	(this.gettableval("zzs_3_7_5", 'tableDataIII') > this.gettableval("zzs_3_7_4", 'tableDataIII'))) {
					// 	this.$message.error("zzs_3_7_5格子逻辑不正确")
					// }
					this.changetableval('zzs_1_17_12', 'tableDataI', this.gettableval('zzs_3_7_5', 'tableDataIII'));
					this.changetableval(
						'zzs_3_7_6',
						'tableDataIII',
						this.gettableval('zzs_3_7_4', 'tableDataIII') - this.gettableval('zzs_3_7_5', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_7_6') {
					this.changetableval('zzs_3_7_2', 'tableDataIII', this.gettableval('zzs_3_7_6', 'tableDataIII', 'old'));
				}
				if (e.cellCode == 'zzs_3_8_1') {
					// if ((this.gettableval("zzs_3_8_5", 'tableDataIII') > this.gettableval("zzs_3_8_1", 'tableDataIII')) ||
					// 	(this.gettableval("zzs_3_8_5", 'tableDataIII') > this.gettableval("zzs_3_8_4", 'tableDataIII'))) {
					// 	this.$message.error("zzs_3_8_5格子逻辑不正确")
					// }
				}
				if (e.cellCode == 'zzs_3_8_2') {
					this.changetableval(
						'zzs_3_8_4',
						'tableDataIII',
						this.gettableval('zzs_3_8_2', 'tableDataIII') + this.gettableval('zzs_3_8_3', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_8_3') {
					this.changetableval(
						'zzs_3_8_4',
						'tableDataIII',
						this.gettableval('zzs_3_8_2', 'tableDataIII') + this.gettableval('zzs_3_8_3', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_8_4') {
					// if ((this.gettableval("zzs_3_8_5", 'tableDataIII') > this.gettableval("zzs_3_8_1", 'tableDataIII')) ||
					// 	(this.gettableval("zzs_3_8_5", 'tableDataIII') > this.gettableval("zzs_3_8_4", 'tableDataIII'))) {
					// 	this.$message.error("zzs_3_8_5格子逻辑不正确")
					// }
					this.changetableval(
						'zzs_3_8_6',
						'tableDataIII',
						this.gettableval('zzs_3_8_4', 'tableDataIII') - this.gettableval('zzs_3_8_5', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_8_5') {
					// if ((this.gettableval("zzs_3_8_5", 'tableDataIII') > this.gettableval("zzs_3_8_1", 'tableDataIII')) ||
					// 	(this.gettableval("zzs_3_8_5", 'tableDataIII') > this.gettableval("zzs_3_8_4", 'tableDataIII'))) {
					// 	this.$message.error("zzs_3_8_5格子逻辑不正确")
					// }
					this.changetableval('zzs_1_19_12', 'tableDataI', this.gettableval('zzs_3_8_5', 'tableDataIII'));
					this.changetableval(
						'zzs_3_8_6',
						'tableDataIII',
						this.gettableval('zzs_3_8_4', 'tableDataIII') - this.gettableval('zzs_3_8_5', 'tableDataIII')
					);
				}
				if (e.cellCode == 'zzs_3_8_6') {
					this.changetableval('zzs_3_8_2', 'tableDataIII', this.gettableval('zzs_3_8_6', 'tableDataIII', 'old'));
				}
				//附表4关系
				if (e.cellCode == 'zzs_4_1_1') {
					this.changetableval(
						'zzs_4_1_3',
						'tableDataIV_I',
						this.gettableval('zzs_4_1_1', 'tableDataIV_I') + this.gettableval('zzs_4_1_2', 'tableDataIV_I')
					);
				}
				if (e.cellCode == 'zzs_4_1_2') {
					this.changetableval(
						'zzs_4_1_3',
						'tableDataIV_I',
						this.gettableval('zzs_4_1_1', 'tableDataIV_I') + this.gettableval('zzs_4_1_2', 'tableDataIV_I')
					);
				}
				if (e.cellCode == 'zzs_4_1_3') {
					this.changetableval(
						'zzs_4_1_5',
						'tableDataIV_I',
						this.gettableval('zzs_4_1_3', 'tableDataIV_I') - this.gettableval('zzs_4_1_4', 'tableDataIV_I')
					);

					// if (this.gettableval("zzs_4_1_4", 'tableDataIV_I') > this.gettableval("zzs_4_1_3",
					// 		'tableDataIV_I')) {
					// 	this.$message.error("zzs_4_1_4格子校验不正确")
					// 	return false
					// }
				}
				if (e.cellCode == 'zzs_4_1_4') {
					// if (this.gettableval("zzs_4_1_4", 'tableDataIV_I') > this.gettableval("zzs_4_1_3",
					// 		'tableDataIV_I')) {
					// 	this.$message.error("zzs_4_1_4格子校验不正确")
					// 	return false
					// }
					this.changetableval(
						'zzs_4_1_5',
						'tableDataIV_I',
						this.gettableval('zzs_4_1_3', 'tableDataIV_I') - this.gettableval('zzs_4_1_4', 'tableDataIV_I')
					);
				}

				if (e.cellCode == 'zzs_4_2_1') {
					this.changetableval(
						'zzs_4_2_3',
						'tableDataIV_I',
						this.gettableval('zzs_4_2_1', 'tableDataIV_I') + this.gettableval('zzs_4_2_2', 'tableDataIV_I')
					);
				}
				if (e.cellCode == 'zzs_4_2_2') {
					this.changetableval(
						'zzs_4_2_3',
						'tableDataIV_I',
						this.gettableval('zzs_4_2_1', 'tableDataIV_I') + this.gettableval('zzs_4_2_2', 'tableDataIV_I')
					);
				}
				if (e.cellCode == 'zzs_4_2_3') {
					this.changetableval(
						'zzs_4_2_5',
						'tableDataIV_I',
						this.gettableval('zzs_4_2_3', 'tableDataIV_I') - this.gettableval('zzs_4_2_4', 'tableDataIV_I')
					);
					// if (this.gettableval("zzs_4_2_4", 'tableDataIV_I') > this.gettableval("zzs_4_2_3",
					// 		'tableDataIV_I')) {
					// 	this.$message.error("zzs_4_2_4格子校验不正确")
					// }
				}
				if (e.cellCode == 'zzs_4_2_4') {
					// if (this.gettableval("zzs_4_2_4", 'tableDataIV_I') > this.gettableval("zzs_4_2_3",
					// 		'tableDataIV_I')) {
					// 	this.$message.error("zzs_4_2_4格子校验不正确")
					// }
					this.changetableval(
						'zzs_0_28_1',
						'tableDataZero',
						this.gettableval('zzs_4_2_4', 'tableDataIV_I') +
						this.gettableval('zzs_4_3_4', 'tableDataIV_I') +
						this.gettableval('zzs_4_4_4', 'tableDataIV_I') +
						this.gettableval('zzs_4_5_4', 'tableDataIV_I')
					);
					this.changetableval(
						'zzs_4_2_5',
						'tableDataIV_I',
						this.gettableval('zzs_4_2_3', 'tableDataIV_I') - this.gettableval('zzs_4_2_4', 'tableDataIV_I')
					);
				}

				if (e.cellCode == 'zzs_4_3_1') {
					this.changetableval(
						'zzs_4_3_3',
						'tableDataIV_I',
						this.gettableval('zzs_4_3_1', 'tableDataIV_I') + this.gettableval('zzs_4_3_2', 'tableDataIV_I')
					);
				}
				if (e.cellCode == 'zzs_4_3_2') {
					this.changetableval(
						'zzs_4_3_3',
						'tableDataIV_I',
						this.gettableval('zzs_4_3_1', 'tableDataIV_I') + this.gettableval('zzs_4_3_2', 'tableDataIV_I')
					);
				}
				if (e.cellCode == 'zzs_4_3_3') {
					// if (this.gettableval("zzs_4_3_4", 'tableDataIV_I') > this.gettableval("zzs_4_3_3",
					// 		'tableDataIV_I')) {
					// 	this.$message.error("zzs_4_3_4格子校验不正确")
					// }

					if (
						(this.params.companyCode == '1100' ||
							this.params.companyCode == '1200' ||
							this.params.companyCode == '1130' ||
							this.params.companyCode == '4300') &&
						this.gettableval('zzs_4_3_3', 'tableDataIV_I') > 0 &&
						this.gettableval('zzs_0_24_1', 'tableDataZero') > 0 &&
						config.company == 'hls' &&
						this.tableDataIV_I[2].zzs_4_x_4.cellType == '0'
					) {
						if (this.gettableval('zzs_4_3_3', 'tableDataIV_I') > this.gettableval('zzs_0_24_1',
								'tableDataZero')) {
							this.changetableval('zzs_4_3_4', 'tableDataIV_I', this.gettableval('zzs_0_24_1',
								'tableDataZero'));
						} else {
							this.changetableval('zzs_4_3_4', 'tableDataIV_I', this.gettableval('zzs_4_3_3',
								'tableDataIV_I'));
						}
					}
					this.changetableval(
						'zzs_4_3_5',
						'tableDataIV_I',
						this.gettableval('zzs_4_3_3', 'tableDataIV_I') - this.gettableval('zzs_4_3_4', 'tableDataIV_I')
					);
				}
				if (e.cellCode == 'zzs_4_3_4') {
					this.changetableval(
						'zzs_0_28_1',
						'tableDataZero',
						this.gettableval('zzs_4_2_4', 'tableDataIV_I') +
						this.gettableval('zzs_4_3_4', 'tableDataIV_I') +
						this.gettableval('zzs_4_4_4', 'tableDataIV_I') +
						this.gettableval('zzs_4_5_4', 'tableDataIV_I')
					);
					// if (this.gettableval("zzs_4_3_4", 'tableDataIV_I') > this.gettableval("zzs_4_3_3",
					// 		'tableDataIV_I')) {
					// 	this.$message.error("zzs_4_3_4格子校验不正确")
					// }
					this.changetableval(
						'zzs_4_3_5',
						'tableDataIV_I',
						this.gettableval('zzs_4_3_3', 'tableDataIV_I') - this.gettableval('zzs_4_3_4', 'tableDataIV_I')
					);
				}

				if (e.cellCode == 'zzs_4_4_1') {
					this.changetableval(
						'zzs_4_4_3',
						'tableDataIV_I',
						this.gettableval('zzs_4_4_1', 'tableDataIV_I') + this.gettableval('zzs_4_4_2', 'tableDataIV_I')
					);
				}
				if (e.cellCode == 'zzs_4_4_2') {
					this.changetableval(
						'zzs_4_4_3',
						'tableDataIV_I',
						this.gettableval('zzs_4_4_1', 'tableDataIV_I') + this.gettableval('zzs_4_4_2', 'tableDataIV_I')
					);
				}
				if (e.cellCode == 'zzs_4_4_3') {
					// if (this.gettableval("zzs_4_4_4", 'tableDataIV_I') > this.gettableval("zzs_4_4_3",
					// 		'tableDataIV_I')) {
					// 	this.$message.error("zzs_4_4_4格子校验不正确")
					// }
					this.changetableval(
						'zzs_4_4_5',
						'tableDataIV_I',
						this.gettableval('zzs_4_4_3', 'tableDataIV_I') - this.gettableval('zzs_4_4_4', 'tableDataIV_I')
					);
				}
				if (e.cellCode == 'zzs_4_4_4') {
					this.changetableval(
						'zzs_0_28_1',
						'tableDataZero',
						this.gettableval('zzs_4_2_4', 'tableDataIV_I') +
						this.gettableval('zzs_4_3_4', 'tableDataIV_I') +
						this.gettableval('zzs_4_4_4', 'tableDataIV_I') +
						this.gettableval('zzs_4_5_4', 'tableDataIV_I')
					);
					// if (this.gettableval("zzs_4_4_4", 'tableDataIV_I') > this.gettableval("zzs_4_4_3",
					// 		'tableDataIV_I')) {
					// 	this.$message.error("zzs_4_4_4格子校验不正确")
					// }
					this.changetableval(
						'zzs_4_4_5',
						'tableDataIV_I',
						this.gettableval('zzs_4_4_3', 'tableDataIV_I') - this.gettableval('zzs_4_4_4', 'tableDataIV_I')
					);
				}

				if (e.cellCode == 'zzs_4_5_1') {
					this.changetableval(
						'zzs_4_5_3',
						'tableDataIV_I',
						this.gettableval('zzs_4_5_1', 'tableDataIV_I') + this.gettableval('zzs_4_5_2', 'tableDataIV_I')
					);
				}
				if (e.cellCode == 'zzs_4_5_2') {
					this.changetableval(
						'zzs_4_5_3',
						'tableDataIV_I',
						this.gettableval('zzs_4_5_1', 'tableDataIV_I') + this.gettableval('zzs_4_5_2', 'tableDataIV_I')
					);
				}
				if (e.cellCode == 'zzs_4_5_3') {
					// if (this.gettableval("zzs_4_5_4", 'tableDataIV_I') > this.gettableval("zzs_4_5_3",
					// 		'tableDataIV_I')) {
					// 	this.$message.error("zzs_4_5_4格子校验不正确")
					// }
					this.changetableval(
						'zzs_4_5_5',
						'tableDataIV_I',
						this.gettableval('zzs_4_5_3', 'tableDataIV_I') - this.gettableval('zzs_4_5_4', 'tableDataIV_I')
					);
				}
				if (e.cellCode == 'zzs_4_5_4') {
					this.changetableval(
						'zzs_0_28_1',
						'tableDataZero',
						this.gettableval('zzs_4_2_4', 'tableDataIV_I') +
						this.gettableval('zzs_4_3_4', 'tableDataIV_I') +
						this.gettableval('zzs_4_4_4', 'tableDataIV_I') +
						this.gettableval('zzs_4_5_4', 'tableDataIV_I')
					);
					// if (this.gettableval("zzs_4_5_4", 'tableDataIV_I') > this.gettableval("zzs_4_5_3",
					// 		'tableDataIV_I')) {
					// 	this.$message.error("zzs_4_5_4格子校验不正确")
					// }
					this.changetableval(
						'zzs_4_5_5',
						'tableDataIV_I',
						this.gettableval('zzs_4_5_3', 'tableDataIV_I') - this.gettableval('zzs_4_5_4', 'tableDataIV_I')
					);
				}

				if (e.cellCode == 'zzs_4_6_1') {
					this.changetableval(
						'zzs_4_6_4',
						'tableDataIV_II',
						this.gettableval('zzs_4_6_1', 'tableDataIV_II') +
						this.gettableval('zzs_4_6_2', 'tableDataIV_II') -
						this.gettableval('zzs_4_6_3', 'tableDataIV_II')
					);
					this.changetableval(
						'zzs_4_8_1',
						'tableDataIV_II',
						this.gettableval('zzs_4_6_1', 'tableDataIV_II') + this.gettableval('zzs_4_7_1',
							'tableDataIV_II')
					);
				}
				if (e.cellCode == 'zzs_4_6_2') {
					this.changetableval(
						'zzs_4_6_4',
						'tableDataIV_II',
						this.gettableval('zzs_4_6_1', 'tableDataIV_II') +
						this.gettableval('zzs_4_6_2', 'tableDataIV_II') -
						this.gettableval('zzs_4_6_3', 'tableDataIV_II')
					);
					this.changetableval(
						'zzs_4_8_2',
						'tableDataIV_II',
						this.gettableval('zzs_4_6_2', 'tableDataIV_II') + this.gettableval('zzs_4_7_2',
							'tableDataIV_II')
					);
				}
				if (e.cellCode == 'zzs_4_6_3') {
					this.changetableval(
						'zzs_4_6_4',
						'tableDataIV_II',
						this.gettableval('zzs_4_6_1', 'tableDataIV_II') +
						this.gettableval('zzs_4_6_2', 'tableDataIV_II') -
						this.gettableval('zzs_4_6_3', 'tableDataIV_II')
					);
					this.changetableval(
						'zzs_4_8_3',
						'tableDataIV_II',
						this.gettableval('zzs_4_6_3', 'tableDataIV_II') + this.gettableval('zzs_4_7_3',
							'tableDataIV_II')
					);
				}
				if (e.cellCode == 'zzs_4_6_4') {
					if (
						(this.gettableval('zzs_4_6_4', 'tableDataIV_II') > 0 || this.gettableval('zzs_4_6_4',
							'tableDataIV_II') == 0) &&
						this.gettableval('zzs_4_6_4', 'tableDataIV_II') <
						this.gettableval('zzs_0_11_1', 'tableDataZero') - this.gettableval('zzs_0_18_1', 'tableDataZero')
					) {
						this.changetableval('zzs_4_6_5', 'tableDataIV_II', this.gettableval('zzs_4_6_4',
							'tableDataIV_II'));
					}
					if (
						!(
							this.gettableval('zzs_4_6_4', 'tableDataIV_II') <
							this.gettableval('zzs_0_11_1', 'tableDataZero') - this.gettableval('zzs_0_18_1',
								'tableDataZero')
						)
					) {
						this.changetableval(
							'zzs_4_6_5',
							'tableDataIV_II',
							this.gettableval('zzs_0_11_1', 'tableDataZero') - this.gettableval('zzs_0_18_1',
								'tableDataZero')
						);
					}
					if (this.gettableval('zzs_4_6_4', 'tableDataIV_II') < 0) {
						this.changetableval('zzs_4_6_5', 'tableDataIV_II', 0);
					}

					this.changetableval(
						'zzs_4_6_6',
						'tableDataIV_II',
						this.gettableval('zzs_4_6_4', 'tableDataIV_II') - this.gettableval('zzs_4_6_5',
							'tableDataIV_II')
					);

					this.changetableval(
						'zzs_4_8_4',
						'tableDataIV_II',
						this.gettableval('zzs_4_6_4', 'tableDataIV_II') + this.gettableval('zzs_4_7_4',
							'tableDataIV_II')
					);
				}
				if (e.cellCode == 'zzs_4_6_5') {
					this.changetableval(
						'zzs_0_19_1',
						'tableDataZero',
						this.gettableval('zzs_0_11_1', 'tableDataZero') -
						this.gettableval('zzs_0_18_1', 'tableDataZero') -
						this.gettableval('zzs_4_6_5', 'tableDataIV_II')
					);
					this.changetableval(
						'zzs_4_6_6',
						'tableDataIV_II',
						this.gettableval('zzs_4_6_4', 'tableDataIV_II') - this.gettableval('zzs_4_6_5',
							'tableDataIV_II')
					);
					this.changetableval(
						'zzs_4_8_5',
						'tableDataIV_II',
						this.gettableval('zzs_4_6_5', 'tableDataIV_II') + this.gettableval('zzs_4_7_5',
							'tableDataIV_II')
					);
				}
				if (e.cellCode == 'zzs_4_6_6') {
					// this.changetableval('zzs_4_6_1', 'tableDataIV_II', this.gettableval('zzs_4_6_6', 'tableDataIV_II',
					// 	'old'));
					this.changetableval(
						'zzs_4_8_6',
						'tableDataIV_II',
						this.gettableval('zzs_4_6_6', 'tableDataIV_II') + this.gettableval('zzs_4_7_6',
							'tableDataIV_II')
					);
				}

				if (e.cellCode == 'zzs_4_7_1') {
					this.changetableval(
						'zzs_4_7_4',
						'tableDataIV_II',
						this.gettableval('zzs_4_7_1', 'tableDataIV_II') +
						this.gettableval('zzs_4_7_2', 'tableDataIV_II') -
						this.gettableval('zzs_4_7_3', 'tableDataIV_II')
					);
					this.changetableval(
						'zzs_4_8_1',
						'tableDataIV_II',
						this.gettableval('zzs_4_6_1', 'tableDataIV_II') + this.gettableval('zzs_4_7_1',
							'tableDataIV_II')
					);
				}
				if (e.cellCode == 'zzs_4_7_2') {
					this.changetableval(
						'zzs_4_7_4',
						'tableDataIV_II',
						this.gettableval('zzs_4_7_1', 'tableDataIV_II') +
						this.gettableval('zzs_4_7_2', 'tableDataIV_II') -
						this.gettableval('zzs_4_7_3', 'tableDataIV_II')
					);
					this.changetableval(
						'zzs_4_8_2',
						'tableDataIV_II',
						this.gettableval('zzs_4_6_2', 'tableDataIV_II') + this.gettableval('zzs_4_7_2',
							'tableDataIV_II')
					);
				}
				if (e.cellCode == 'zzs_4_7_3') {
					this.changetableval(
						'zzs_4_8_3',
						'tableDataIV_II',
						this.gettableval('zzs_4_6_3', 'tableDataIV_II') + this.gettableval('zzs_4_7_3',
							'tableDataIV_II')
					);
					this.changetableval(
						'zzs_4_7_4',
						'tableDataIV_II',
						this.gettableval('zzs_4_7_1', 'tableDataIV_II') +
						this.gettableval('zzs_4_7_2', 'tableDataIV_II') -
						this.gettableval('zzs_4_7_3', 'tableDataIV_II')
					);
				}
				if (e.cellCode == 'zzs_4_7_4') {
					var val = '';
					if (
						!(this.gettableval('zzs_4_7_4', 'tableDataIV_II') < 0) &&
						this.gettableval('zzs_4_7_4', 'tableDataIV_II') <
						this.gettableval('zzs_0_11_3', 'tableDataZero') - this.gettableval('zzs_0_18_3', 'tableDataZero')
					) {
						val = this.gettableval('zzs_4_7_4', 'tableDataIV_II');
					} else if (
						!(
							this.gettableval('zzs_4_7_4', 'tableDataIV_II') <
							this.gettableval('zzs_0_11_3', 'tableDataZero') - this.gettableval('zzs_0_18_3',
								'tableDataZero')
						)
					) {
						val = this.gettableval('zzs_0_11_3', 'tableDataZero') - this.gettableval('zzs_0_18_3',
							'tableDataZero');
					}
					if (this.gettableval('zzs_4_7_4', 'tableDataIV_II') < 0) {
						val = 0;
					}
					this.changetableval('zzs_4_7_5', 'tableDataIV_II', val);
					this.changetableval(
						'zzs_4_7_6',
						'tableDataIV_II',
						this.gettableval('zzs_4_7_4', 'tableDataIV_II') - this.gettableval('zzs_4_7_5',
							'tableDataIV_II')
					);
					this.changetableval(
						'zzs_4_8_4',
						'tableDataIV_II',
						this.gettableval('zzs_4_6_4', 'tableDataIV_II') + this.gettableval('zzs_4_7_4',
							'tableDataIV_II')
					);
				}
				if (e.cellCode == 'zzs_4_7_5') {
					this.changetableval(
						'zzs_0_19_3',
						'tableDataZero',
						this.gettableval('zzs_0_11_3', 'tableDataZero') -
						this.gettableval('zzs_0_18_3', 'tableDataZero') -
						this.gettableval('zzs_4_7_5', 'tableDataIV_II')
					);
					this.changetableval(
						'zzs_4_7_6',
						'tableDataIV_II',
						this.gettableval('zzs_4_7_4', 'tableDataIV_II') - this.gettableval('zzs_4_7_5',
							'tableDataIV_II')
					);
					this.changetableval(
						'zzs_4_8_5',
						'tableDataIV_II',
						this.gettableval('zzs_4_6_5', 'tableDataIV_II') + this.gettableval('zzs_4_7_5',
							'tableDataIV_II')
					);
				}
				if (e.cellCode == 'zzs_4_7_6') {
					this.changetableval('zzs_4_7_1', 'tableDataIV_II', this.gettableval('zzs_4_7_6', 'tableDataIV_II',
						'old'));
					this.changetableval(
						'zzs_4_8_6',
						'tableDataIV_II',
						this.gettableval('zzs_4_6_6', 'tableDataIV_II') + this.gettableval('zzs_4_7_6',
							'tableDataIV_II')
					);
				}

				//附表5关系
				if (e.cellCode == 'zzs_5_1_1') {
					this.changezzs_5_1_4();
					this.changetableval(
						'zzs_5_1_6',
						'tableDataV_I',
						(this.gettableval('zzs_5_1_1', 'tableDataV_I') +
							this.gettableval('zzs_5_1_2', 'tableDataV_I') +
							this.gettableval('zzs_5_1_3', 'tableDataV_I') -
							this.gettableval('zzs_5_1_4', 'tableDataV_I')) *
						(this.gettableval('zzs_5_1_5', 'tableDataV_I') * 0.01)
					);
				}
				if (e.cellCode == 'zzs_5_1_2') {
					this.changezzs_5_1_4();
					this.changetableval(
						'zzs_5_1_6',
						'tableDataV_I',
						(this.gettableval('zzs_5_1_1', 'tableDataV_I') +
							this.gettableval('zzs_5_1_2', 'tableDataV_I') +
							this.gettableval('zzs_5_1_3', 'tableDataV_I') -
							this.gettableval('zzs_5_1_4', 'tableDataV_I')) *
						(this.gettableval('zzs_5_1_5', 'tableDataV_I') * 0.01)
					);
				}
				if (e.cellCode == 'zzs_5_1_3') {
					this.changetableval(
						'zzs_5_1_6',
						'tableDataV_I',
						(this.gettableval('zzs_5_1_1', 'tableDataV_I') +
							this.gettableval('zzs_5_1_2', 'tableDataV_I') +
							this.gettableval('zzs_5_1_3', 'tableDataV_I') -
							this.gettableval('zzs_5_1_4', 'tableDataV_I')) *
						(this.gettableval('zzs_5_1_5', 'tableDataV_I') * 0.01)
					);
				}
				if (e.cellCode == 'zzs_5_1_4') {
					this.changetableval(
						'zzs_5_1_6',
						'tableDataV_I',
						(this.gettableval('zzs_5_1_1', 'tableDataV_I') +
							this.gettableval('zzs_5_1_2', 'tableDataV_I') +
							this.gettableval('zzs_5_1_3', 'tableDataV_I') -
							this.gettableval('zzs_5_1_4', 'tableDataV_I')) *
						(this.gettableval('zzs_5_1_5', 'tableDataV_I') * 0.01)
					);

					this.changetableval(
						'zzs_5_10_1',
						'tableDataV_II',
						this.gettableval('zzs_5_8_1', 'tableDataV_II') +
						this.gettableval('zzs_5_9_1', 'tableDataV_II') -
						this.gettableval('zzs_5_1_4', 'tableDataV_I')

					);
				}
				if (e.cellCode == 'zzs_5_1_5') {
					this.changetableval(
						'zzs_5_1_6',
						'tableDataV_I',
						(this.gettableval('zzs_5_1_1', 'tableDataV_I') +
							this.gettableval('zzs_5_1_2', 'tableDataV_I') +
							this.gettableval('zzs_5_1_3', 'tableDataV_I') -
							this.gettableval('zzs_5_1_4', 'tableDataV_I')) *
						(this.gettableval('zzs_5_1_5', 'tableDataV_I') * 0.01)
					);
				}
				if (e.cellCode == 'zzs_5_1_6') {
					this.changetableval(
						'zzs_5_1_14',
						'tableDataV_I',
						this.gettableval('zzs_5_1_6', 'tableDataV_I') -
						this.gettableval('zzs_5_1_8', 'tableDataV_I') -
						this.gettableval('zzs_5_1_10', 'tableDataV_I') -
						this.gettableval('zzs_5_1_12', 'tableDataV_I') -
						this.gettableval('zzs_5_1_13', 'tableDataV_I')
					);
					this.changetableval(
						'zzs_5_4_6',
						'tableDataV_I',
						this.gettableval('zzs_5_1_6', 'tableDataV_I') +
						this.gettableval('zzs_5_2_6', 'tableDataV_I') +
						this.gettableval('zzs_5_3_6', 'tableDataV_I')
					);
					this.changetableval(
						'zzs_5_1_10',
						'tableDataV_I',
						this.$toFixed_3(
							(this.gettableval('zzs_5_1_6', 'tableDataV_I') - this.gettableval('zzs_5_1_8',
								'tableDataV_I')) * this.gettableval('zzs_5_1_9', 'tableDataV_I'))
					);
				}
				if (e.cellCode == 'zzs_5_1_8') {
					this.changetableval(
						'zzs_5_1_14',
						'tableDataV_I',
						this.gettableval('zzs_5_1_6', 'tableDataV_I') -
						this.gettableval('zzs_5_1_8', 'tableDataV_I') -
						this.gettableval('zzs_5_1_10', 'tableDataV_I') -
						this.gettableval('zzs_5_1_12', 'tableDataV_I') -
						this.gettableval('zzs_5_1_13', 'tableDataV_I')
					);
					this.changetableval(
						'zzs_5_4_8',
						'tableDataV_I',
						this.gettableval('zzs_5_1_8', 'tableDataV_I') +
						this.gettableval('zzs_5_2_8', 'tableDataV_I') +
						this.gettableval('zzs_5_3_8', 'tableDataV_I')
					);
					this.changetableval(
						'zzs_5_1_10',
						'tableDataV_I',
						this.$toFixed_3((this.gettableval('zzs_5_1_6', 'tableDataV_I') - this.gettableval('zzs_5_1_8',
							'tableDataV_I')) * this.gettableval('zzs_5_1_9', 'tableDataV_I'))
					);
				}
				if (e.cellCode == 'zzs_5_1_9') {
					this.changetableval(
						'zzs_5_1_10',
						'tableDataV_I',
						this.$toFixed_3((this.gettableval('zzs_5_1_6', 'tableDataV_I') - this.gettableval('zzs_5_1_8',
							'tableDataV_I')) * this.gettableval('zzs_5_1_9', 'tableDataV_I'))
					);
				}
				if (e.cellCode == 'zzs_5_1_10') {
					this.changetableval(
						'zzs_5_1_14',
						'tableDataV_I',
						this.gettableval('zzs_5_1_6', 'tableDataV_I') -
						this.gettableval('zzs_5_1_8', 'tableDataV_I') -
						this.gettableval('zzs_5_1_10', 'tableDataV_I') -
						this.gettableval('zzs_5_1_12', 'tableDataV_I') -
						this.gettableval('zzs_5_1_13', 'tableDataV_I')
					);
					this.changetableval(
						'zzs_5_4_10',
						'tableDataV_I',
						this.gettableval('zzs_5_1_10', 'tableDataV_I') +
						this.gettableval('zzs_5_2_10', 'tableDataV_I') +
						this.gettableval('zzs_5_3_10', 'tableDataV_I')
					);
				}
				if (e.cellCode == 'zzs_5_1_12') {
					this.changetableval(
						'zzs_5_1_14',
						'tableDataV_I',
						this.gettableval('zzs_5_1_6', 'tableDataV_I') -
						this.gettableval('zzs_5_1_8', 'tableDataV_I') -
						this.gettableval('zzs_5_1_10', 'tableDataV_I') -
						this.gettableval('zzs_5_1_12', 'tableDataV_I') -
						this.gettableval('zzs_5_1_13', 'tableDataV_I')
					);
					this.changetableval(
						'zzs_5_4_12',
						'tableDataV_I',
						this.gettableval('zzs_5_1_12', 'tableDataV_I') +
						this.gettableval('zzs_5_2_12', 'tableDataV_I') +
						this.gettableval('zzs_5_3_12', 'tableDataV_I')
					);
				}
				if (e.cellCode == 'zzs_5_1_13') {
					this.changetableval(
						'zzs_5_1_14',
						'tableDataV_I',
						this.gettableval('zzs_5_1_6', 'tableDataV_I') -
						this.gettableval('zzs_5_1_8', 'tableDataV_I') -
						this.gettableval('zzs_5_1_10', 'tableDataV_I') -
						this.gettableval('zzs_5_1_12', 'tableDataV_I') -
						this.gettableval('zzs_5_1_13', 'tableDataV_I')
					);
					this.changetableval(
						'zzs_5_4_13',
						'tableDataV_I',
						this.gettableval('zzs_5_1_13', 'tableDataV_I') +
						this.gettableval('zzs_5_2_13', 'tableDataV_I') +
						this.gettableval('zzs_5_3_13', 'tableDataV_I')
					);
				}
				if (e.cellCode == 'zzs_5_1_14') {
					// if (this.gettableval("zzs_5_1_14", "tableDataV_I") != this.gettableval("zzs_0_39_1",
					// 	"tableDataZero")) {
					// 	this.$message.error("zzs_0_39_1校验不正确")
					// }
					//格子
					this.changetableval('zzs_0_39_1', 'tableDataZero', this.gettableval('zzs_5_1_14', 'tableDataV_I'));
					this.changetableval(
						'zzs_5_4_14',
						'tableDataV_I',
						this.gettableval('zzs_5_1_14', 'tableDataV_I') +
						this.gettableval('zzs_5_2_14', 'tableDataV_I') +
						this.gettableval('zzs_5_3_14', 'tableDataV_I')
					);
				}
				if (e.cellCode == 'zzs_5_2_1') {
					this.changezzs_5_2_4();
					this.changetableval(
						'zzs_5_2_6',
						'tableDataV_I',
						(this.gettableval('zzs_5_2_1', 'tableDataV_I') +
							this.gettableval('zzs_5_2_2', 'tableDataV_I') +
							this.gettableval('zzs_5_2_3', 'tableDataV_I') -
							this.gettableval('zzs_5_2_4', 'tableDataV_I')) *
						(this.gettableval('zzs_5_2_5', 'tableDataV_I') * 0.01)
					);
				}
				if (e.cellCode == 'zzs_5_2_2') {
					this.changezzs_5_2_4();
					this.changetableval(
						'zzs_5_2_6',
						'tableDataV_I',
						(this.gettableval('zzs_5_2_1', 'tableDataV_I') +
							this.gettableval('zzs_5_2_2', 'tableDataV_I') +
							this.gettableval('zzs_5_2_3', 'tableDataV_I') -
							this.gettableval('zzs_5_2_4', 'tableDataV_I')) *
						(this.gettableval('zzs_5_2_5', 'tableDataV_I') * 0.01)
					);
				}
				if (e.cellCode == 'zzs_5_2_3') {
					this.changetableval(
						'zzs_5_2_6',
						'tableDataV_I',
						(this.gettableval('zzs_5_2_1', 'tableDataV_I') +
							this.gettableval('zzs_5_2_2', 'tableDataV_I') +
							this.gettableval('zzs_5_2_3', 'tableDataV_I') -
							this.gettableval('zzs_5_2_4', 'tableDataV_I')) *
						(this.gettableval('zzs_5_2_5', 'tableDataV_I') * 0.01)
					);
				}
				if (e.cellCode == 'zzs_5_2_4') {
					this.changetableval(
						'zzs_5_2_6',
						'tableDataV_I',
						(this.gettableval('zzs_5_2_1', 'tableDataV_I') +
							this.gettableval('zzs_5_2_2', 'tableDataV_I') +
							this.gettableval('zzs_5_2_3', 'tableDataV_I') -
							this.gettableval('zzs_5_2_4', 'tableDataV_I')) *
						(this.gettableval('zzs_5_2_5', 'tableDataV_I') * 0.01)
					);
					this.changetableval(
						'zzs_5_10_1',
						'tableDataV_II',
						this.gettableval('zzs_5_8_1', 'tableDataV_II') +
						this.gettableval('zzs_5_9_1', 'tableDataV_II') -
						this.gettableval('zzs_5_1_4', 'tableDataV_I')
					);
				}
				if (e.cellCode == 'zzs_5_2_5') {
					this.changetableval(
						'zzs_5_2_6',
						'tableDataV_I',
						(this.gettableval('zzs_5_2_1', 'tableDataV_I') +
							this.gettableval('zzs_5_2_2', 'tableDataV_I') +
							this.gettableval('zzs_5_2_3', 'tableDataV_I') -
							this.gettableval('zzs_5_2_4', 'tableDataV_I')) *
						(this.gettableval('zzs_5_2_5', 'tableDataV_I') * 0.01)
					);
				}
				if (e.cellCode == 'zzs_5_2_6') {
					this.changetableval(
						'zzs_5_2_14',
						'tableDataV_I',
						this.gettableval('zzs_5_2_6', 'tableDataV_I') -
						this.gettableval('zzs_5_2_8', 'tableDataV_I') -
						this.gettableval('zzs_5_2_10', 'tableDataV_I') -
						this.gettableval('zzs_5_2_12', 'tableDataV_I') -
						this.gettableval('zzs_5_2_13', 'tableDataV_I')
					);
					this.changetableval(
						'zzs_5_2_10',
						'tableDataV_I',
						this.$toFixed_3(
							(this.gettableval('zzs_5_2_6', 'tableDataV_I') - this.gettableval('zzs_5_2_8',
								'tableDataV_I')) * this.gettableval('zzs_5_2_9', 'tableDataV_I'))
					);
					this.changetableval(
						'zzs_5_4_6',
						'tableDataV_I',
						this.gettableval('zzs_5_1_6', 'tableDataV_I') +
						this.gettableval('zzs_5_2_6', 'tableDataV_I') +
						this.gettableval('zzs_5_3_6', 'tableDataV_I')
					);
				}
				if (e.cellCode == 'zzs_5_2_8') {
					this.changetableval(
						'zzs_5_2_14',
						'tableDataV_I',
						this.gettableval('zzs_5_2_6', 'tableDataV_I') -
						this.gettableval('zzs_5_2_8', 'tableDataV_I') -
						this.gettableval('zzs_5_2_10', 'tableDataV_I') -
						this.gettableval('zzs_5_2_12', 'tableDataV_I') -
						this.gettableval('zzs_5_2_13', 'tableDataV_I')
					);
					this.changetableval(
						'zzs_5_4_8',
						'tableDataV_I',
						this.gettableval('zzs_5_1_8', 'tableDataV_I') +
						this.gettableval('zzs_5_2_8', 'tableDataV_I') +
						this.gettableval('zzs_5_3_8', 'tableDataV_I')
					);
					this.changetableval(
						'zzs_5_2_10',
						'tableDataV_I',
						this.$toFixed_3(
							(this.gettableval('zzs_5_2_6', 'tableDataV_I') - this.gettableval('zzs_5_2_8',
								'tableDataV_I')) * this.gettableval('zzs_5_2_9', 'tableDataV_I'))
					);
				}
				if (e.cellCode == 'zzs_5_2_9') {
					this.changetableval(
						'zzs_5_2_10',
						'tableDataV_I',
						this.$toFixed_3((this.gettableval('zzs_5_2_6', 'tableDataV_I') - this.gettableval('zzs_5_2_8',
							'tableDataV_I')) * this.gettableval('zzs_5_2_9', 'tableDataV_I'))
					);
				}
				if (e.cellCode == 'zzs_5_2_10') {
					this.changetableval(
						'zzs_5_2_14',
						'tableDataV_I',
						this.gettableval('zzs_5_2_6', 'tableDataV_I') -
						this.gettableval('zzs_5_2_8', 'tableDataV_I') -
						this.gettableval('zzs_5_2_10', 'tableDataV_I') -
						this.gettableval('zzs_5_2_12', 'tableDataV_I') -
						this.gettableval('zzs_5_2_13', 'tableDataV_I')
					);
					this.changetableval(
						'zzs_5_4_10',
						'tableDataV_I',
						this.gettableval('zzs_5_1_10', 'tableDataV_I') +
						this.gettableval('zzs_5_2_10', 'tableDataV_I') +
						this.gettableval('zzs_5_3_10', 'tableDataV_I')
					);
				}
				if (e.cellCode == 'zzs_5_2_12') {
					this.changetableval(
						'zzs_5_2_14',
						'tableDataV_I',
						this.gettableval('zzs_5_2_6', 'tableDataV_I') -
						this.gettableval('zzs_5_2_8', 'tableDataV_I') -
						this.gettableval('zzs_5_2_10', 'tableDataV_I') -
						this.gettableval('zzs_5_2_12', 'tableDataV_I') -
						this.gettableval('zzs_5_2_13', 'tableDataV_I')
					);
					this.changetableval(
						'zzs_5_4_12',
						'tableDataV_I',
						this.gettableval('zzs_5_1_12', 'tableDataV_I') +
						this.gettableval('zzs_5_2_12', 'tableDataV_I') +
						this.gettableval('zzs_5_3_12', 'tableDataV_I')
					);
				}
				if (e.cellCode == 'zzs_5_2_13') {
					this.changetableval(
						'zzs_5_2_14',
						'tableDataV_I',
						this.gettableval('zzs_5_2_6', 'tableDataV_I') -
						this.gettableval('zzs_5_2_8', 'tableDataV_I') -
						this.gettableval('zzs_5_2_10', 'tableDataV_I') -
						this.gettableval('zzs_5_2_12', 'tableDataV_I') -
						this.gettableval('zzs_5_2_13', 'tableDataV_I')
					);
					this.changetableval(
						'zzs_5_4_13',
						'tableDataV_I',
						this.gettableval('zzs_5_1_13', 'tableDataV_I') +
						this.gettableval('zzs_5_2_13', 'tableDataV_I') +
						this.gettableval('zzs_5_3_13', 'tableDataV_I')
					);
				}
				if (e.cellCode == 'zzs_5_2_14') {
					// if (this.gettableval("zzs_5_2_14", "tableDataV_I") != this.gettableval("zzs_0_40_1",
					// 	"tableDataZero")) {
					// 	this.$message.error("zzs_0_40_1校验不正确")
					// }
					//格子
					this.changetableval('zzs_0_40_1', 'tableDataZero', this.gettableval('zzs_5_2_14', 'tableDataV_I'));
					this.changetableval(
						'zzs_5_4_14',
						'tableDataV_I',
						this.gettableval('zzs_5_1_14', 'tableDataV_I') +
						this.gettableval('zzs_5_2_14', 'tableDataV_I') +
						this.gettableval('zzs_5_3_14', 'tableDataV_I')
					);
				}
				if (e.cellCode == 'zzs_5_3_1') {
					this.changetableval(
						'zzs_5_3_6',
						'tableDataV_I',
						(this.gettableval('zzs_5_3_1', 'tableDataV_I') +
							this.gettableval('zzs_5_3_2', 'tableDataV_I') +
							this.gettableval('zzs_5_3_3', 'tableDataV_I') -
							this.gettableval('zzs_5_3_4', 'tableDataV_I')) *
						(this.gettableval('zzs_5_3_5', 'tableDataV_I') * 0.01)
					);
					this.changezzs_5_3_4();
				}
				if (e.cellCode == 'zzs_5_3_2') {
					this.changezzs_5_3_4();

					this.changetableval(
						'zzs_5_3_6',
						'tableDataV_I',
						(this.gettableval('zzs_5_3_1', 'tableDataV_I') +
							this.gettableval('zzs_5_3_2', 'tableDataV_I') +
							this.gettableval('zzs_5_3_3', 'tableDataV_I') -
							this.gettableval('zzs_5_3_4', 'tableDataV_I')) *
						(this.gettableval('zzs_5_3_5', 'tableDataV_I') * 0.01)
					);
				}
				if (e.cellCode == 'zzs_5_3_3') {
					this.changetableval(
						'zzs_5_3_6',
						'tableDataV_I',
						(this.gettableval('zzs_5_3_1', 'tableDataV_I') +
							this.gettableval('zzs_5_3_2', 'tableDataV_I') +
							this.gettableval('zzs_5_3_3', 'tableDataV_I') -
							this.gettableval('zzs_5_3_4', 'tableDataV_I')) *
						(this.gettableval('zzs_5_3_5', 'tableDataV_I') * 0.01)
					);
				}
				if (e.cellCode == 'zzs_5_3_4') {
					this.changetableval(
						'zzs_5_3_6',
						'tableDataV_I',
						(this.gettableval('zzs_5_3_1', 'tableDataV_I') +
							this.gettableval('zzs_5_3_2', 'tableDataV_I') +
							this.gettableval('zzs_5_3_3', 'tableDataV_I') -
							this.gettableval('zzs_5_3_4', 'tableDataV_I')) *
						(this.gettableval('zzs_5_3_5', 'tableDataV_I') * 0.01)
					);
					this.changetableval(
						'zzs_5_10_1',
						'tableDataV_II',
						this.gettableval('zzs_5_8_1', 'tableDataV_II') +
						this.gettableval('zzs_5_9_1', 'tableDataV_II') -
						this.gettableval('zzs_5_1_4', 'tableDataV_I')
					);
				}
				if (e.cellCode == 'zzs_5_3_5') {
					this.changetableval(
						'zzs_5_3_6',
						'tableDataV_I',
						(this.gettableval('zzs_5_3_1', 'tableDataV_I') +
							this.gettableval('zzs_5_3_2', 'tableDataV_I') +
							this.gettableval('zzs_5_3_3', 'tableDataV_I') -
							this.gettableval('zzs_5_3_4', 'tableDataV_I')) *
						(this.gettableval('zzs_5_3_5', 'tableDataV_I') * 0.01)
					);
				}
				if (e.cellCode == 'zzs_5_3_6') {
					this.changetableval(
						'zzs_5_3_14',
						'tableDataV_I',
						this.gettableval('zzs_5_3_6', 'tableDataV_I') -
						this.gettableval('zzs_5_3_8', 'tableDataV_I') -
						this.gettableval('zzs_5_3_10', 'tableDataV_I') -
						this.gettableval('zzs_5_3_12', 'tableDataV_I') -
						this.gettableval('zzs_5_3_13', 'tableDataV_I')
					);
					this.changetableval(
						'zzs_5_4_6',
						'tableDataV_I',
						this.gettableval('zzs_5_1_6', 'tableDataV_I') +
						this.gettableval('zzs_5_2_6', 'tableDataV_I') +
						this.gettableval('zzs_5_3_6', 'tableDataV_I')
					);
					this.changetableval(
						'zzs_5_3_10',
						'tableDataV_I',
						this.$toFixed_3((this.gettableval('zzs_5_3_6', 'tableDataV_I') - this.gettableval('zzs_5_3_8',
							'tableDataV_I')) * this.gettableval('zzs_5_3_9', 'tableDataV_I'))
					);
				}
				if (e.cellCode == 'zzs_5_3_8') {
					this.changetableval(
						'zzs_5_3_14',
						'tableDataV_I',
						this.gettableval('zzs_5_3_6', 'tableDataV_I') -
						this.gettableval('zzs_5_3_8', 'tableDataV_I') -
						this.gettableval('zzs_5_3_10', 'tableDataV_I') -
						this.gettableval('zzs_5_3_12', 'tableDataV_I') -
						this.gettableval('zzs_5_3_13', 'tableDataV_I')
					);
					this.changetableval(
						'zzs_5_4_8',
						'tableDataV_I',
						this.gettableval('zzs_5_1_8', 'tableDataV_I') +
						this.gettableval('zzs_5_2_8', 'tableDataV_I') +
						this.gettableval('zzs_5_3_8', 'tableDataV_I')
					);
					this.changetableval(
						'zzs_5_3_10',
						'tableDataV_I',
						this.$toFixed_3((this.gettableval('zzs_5_3_6', 'tableDataV_I') - this.gettableval('zzs_5_3_8',
							'tableDataV_I')) * this.gettableval('zzs_5_3_9', 'tableDataV_I'))
					);
				}
				if (e.cellCode == 'zzs_5_3_9') {
					this.changetableval(
						'zzs_5_3_10',
						'tableDataV_I',
						this.$toFixed_3((this.gettableval('zzs_5_3_6', 'tableDataV_I') - this.gettableval('zzs_5_3_8',
							'tableDataV_I')) * this.gettableval('zzs_5_3_9', 'tableDataV_I'))
					);
				}
				if (e.cellCode == 'zzs_5_3_10') {
					this.changetableval(
						'zzs_5_3_14',
						'tableDataV_I',
						this.gettableval('zzs_5_3_6', 'tableDataV_I') -
						this.gettableval('zzs_5_3_8', 'tableDataV_I') -
						this.gettableval('zzs_5_3_10', 'tableDataV_I') -
						this.gettableval('zzs_5_3_12', 'tableDataV_I') -
						this.gettableval('zzs_5_3_13', 'tableDataV_I')
					);
					this.changetableval(
						'zzs_5_4_10',
						'tableDataV_I',
						this.gettableval('zzs_5_1_10', 'tableDataV_I') +
						this.gettableval('zzs_5_2_10', 'tableDataV_I') +
						this.gettableval('zzs_5_3_10', 'tableDataV_I')
					);
				}
				if (e.cellCode == 'zzs_5_3_12') {
					this.changetableval(
						'zzs_5_3_14',
						'tableDataV_I',
						this.gettableval('zzs_5_3_6', 'tableDataV_I') -
						this.gettableval('zzs_5_3_8', 'tableDataV_I') -
						this.gettableval('zzs_5_3_10', 'tableDataV_I') -
						this.gettableval('zzs_5_3_12', 'tableDataV_I') -
						this.gettableval('zzs_5_3_13', 'tableDataV_I')
					);
					this.changetableval(
						'zzs_5_4_12',
						'tableDataV_I',
						this.gettableval('zzs_5_1_12', 'tableDataV_I') +
						this.gettableval('zzs_5_2_12', 'tableDataV_I') +
						this.gettableval('zzs_5_3_12', 'tableDataV_I')
					);
				}
				if (e.cellCode == 'zzs_5_3_13') {
					this.changetableval(
						'zzs_5_3_14',
						'tableDataV_I',
						this.gettableval('zzs_5_3_6', 'tableDataV_I') -
						this.gettableval('zzs_5_3_8', 'tableDataV_I') -
						this.gettableval('zzs_5_3_10', 'tableDataV_I') -
						this.gettableval('zzs_5_3_12', 'tableDataV_I') -
						this.gettableval('zzs_5_3_13', 'tableDataV_I')
					);
					this.changetableval(
						'zzs_5_4_13',
						'tableDataV_I',
						this.gettableval('zzs_5_1_13', 'tableDataV_I') +
						this.gettableval('zzs_5_2_13', 'tableDataV_I') +
						this.gettableval('zzs_5_3_13', 'tableDataV_I')
					);
				}
				if (e.cellCode == 'zzs_5_3_14') {
					// if (this.gettableval("zzs_5_3_14", "tableDataV_I") != this.gettableval("zzs_0_41_1",
					// 	"tableDataZero")) {
					// 	this.$message.error("zzs_0_41_1校验不正确")
					// }//格子
					this.changetableval('zzs_0_41_1', 'tableDataZero', this.gettableval('zzs_5_3_14', 'tableDataV_I'));
					this.changetableval(
						'zzs_5_4_14',
						'tableDataV_I',
						this.gettableval('zzs_5_1_14', 'tableDataV_I') +
						this.gettableval('zzs_5_2_14', 'tableDataV_I') +
						this.gettableval('zzs_5_3_14', 'tableDataV_I')
					);
				}
				if (e.cellCode == 'zzs_5_8_1') {
					this.changezzs_5_1_4();
					this.changezzs_5_2_4();
					this.changezzs_5_3_4();
					this.changetableval(
						'zzs_5_10_1',
						'tableDataV_II',
						this.gettableval('zzs_5_8_1', 'tableDataV_II') +
						this.gettableval('zzs_5_9_1', 'tableDataV_II') -
						this.gettableval('zzs_5_1_4', 'tableDataV_I')
					);
				}
				if (e.cellCode == 'zzs_5_9_1') {
					this.changezzs_5_1_4();
					this.changezzs_5_2_4();
					this.changezzs_5_3_4();
					this.changetableval(
						'zzs_5_10_1',
						'tableDataV_II',
						this.gettableval('zzs_5_8_1', 'tableDataV_II') +
						this.gettableval('zzs_5_9_1', 'tableDataV_II') -
						this.gettableval('zzs_5_1_4', 'tableDataV_I')

					);
				}
				if (e.cellCode == 'zzs_5_10_1') {
					this.changetableval('zzs_5_9_1', 'tableDataV_II', this.gettableval('zzs_5_10_1', 'tableDataV_II',
						'old'));
				}
				if (e.cellCode == 'zzs_6_1_4') {
					if (
						!(
							this.gettableval('zzs_6_1_4', 'tableDataTax_I') <
							this.gettableval('zzs_0_19_1', 'tableDataZero') + this.gettableval('zzs_0_21_1',
								'tableDataZero')
						)
					) {
						this.changetableval(
							'zzs_0_23_1',
							'tableDataZero',
							this.gettableval('zzs_0_19_1', 'tableDataZero') + this.gettableval('zzs_0_21_1',
								'tableDataZero')
						);
					} else {
						this.changetableval('zzs_0_23_1', 'tableDataZero', this.gettableval('zzs_6_1_4',
							'tableDataTax_I'));
					}
				}
				if (e.cellCode == 'zzs_6_2_0' || e.cellCode == 'zzs_4_1_1') {
					if (this.gettableval('zzs_6_2_0', 'tableDataTax_I') == '0001129914|SXA031900185') {
						this.changetableval('zzs_6_2_1', 'tableDataTax_I', this.gettableval('zzs_4_1_1', 'tableDataIV_I'));
					} else {
						this.changetableval('zzs_6_2_1', 'tableDataTax_I', 0);
					}
				}
				if (e.cellCode == 'zzs_6_3_0' || e.cellCode == 'zzs_4_1_1') {
					if (this.gettableval('zzs_6_3_0', 'tableDataTax_I') == '0001129914|SXA031900185') {
						this.changetableval('zzs_6_3_1', 'tableDataTax_I', this.gettableval('zzs_4_1_1', 'tableDataIV_I'));
					} else {
						this.changetableval('zzs_6_3_1', 'tableDataTax_I', 0);
					}
				}
				if (e.cellCode == 'zzs_6_4_0' || e.cellCode == 'zzs_4_1_1') {
					if (this.gettableval('zzs_6_4_0', 'tableDataTax_I') == '0001129914|SXA031900185') {
						this.changetableval('zzs_6_4_1', 'tableDataTax_I', this.gettableval('zzs_4_1_1', 'tableDataIV_I'));
					} else {
						this.changetableval('zzs_6_4_1', 'tableDataTax_I', 0);
					}
				}
				if (e.cellCode == 'zzs_6_5_0' || e.cellCode == 'zzs_4_1_1') {
					if (this.gettableval('zzs_6_5_0', 'tableDataTax_I') == '0001129914|SXA031900185') {
						this.changetableval('zzs_6_5_1', 'tableDataTax_I', this.gettableval('zzs_4_1_1', 'tableDataIV_I'));
					} else {
						this.changetableval('zzs_6_5_1', 'tableDataTax_I', 0);
					}
				}
				if (e.cellCode == 'zzs_6_6_0' || e.cellCode == 'zzs_4_1_1') {
					if (this.gettableval('zzs_6_6_0', 'tableDataTax_I') == '0001129914|SXA031900185') {
						this.changetableval('zzs_6_6_1', 'tableDataTax_I', this.gettableval('zzs_4_1_1', 'tableDataIV_I'));
					} else {
						this.changetableval('zzs_6_6_1', 'tableDataTax_I', 0);
					}
				}
				//增值税减免税申报明细表关系tableDataTax_I tableDataTax_II
				if (e.cellCode == 'zzs_6_2_1') {
					this.changetableval(
						'zzs_6_1_1',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_1', 'tableDataTax_I') +
						this.gettableval('zzs_6_3_1', 'tableDataTax_I') +
						this.gettableval('zzs_6_4_1', 'tableDataTax_I') +
						this.gettableval('zzs_6_5_1', 'tableDataTax_I') +
						this.gettableval('zzs_6_6_1', 'tableDataTax_I')
					);
					this.changetableval(
						'zzs_6_2_3',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_1', 'tableDataTax_I') + this.gettableval('zzs_6_2_2',
							'tableDataTax_I')
					);
				}
				if (e.cellCode == 'zzs_6_2_2') {
					this.changetableval(
						'zzs_6_1_2',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_2', 'tableDataTax_I') +
						this.gettableval('zzs_6_3_2', 'tableDataTax_I') +
						this.gettableval('zzs_6_4_2', 'tableDataTax_I') +
						this.gettableval('zzs_6_5_2', 'tableDataTax_I') +
						this.gettableval('zzs_6_6_2', 'tableDataTax_I')
					);
					this.changetableval(
						'zzs_6_2_3',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_1', 'tableDataTax_I') + this.gettableval('zzs_6_2_2',
							'tableDataTax_I')
					);
				}
				if (e.cellCode == 'zzs_6_2_3') {
					// if (this.gettableval("zzs_6_2_3", "tableDataTax_I") < this.gettableval("zzs_6_2_4",
					// 		"tableDataTax_I")) {
					// 	this.$message.error("zzs_6_2_4格子校验不正确")
					// }
					this.changetableval(
						'zzs_6_1_3',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_3', 'tableDataTax_I') +
						this.gettableval('zzs_6_3_3', 'tableDataTax_I') +
						this.gettableval('zzs_6_4_3', 'tableDataTax_I') +
						this.gettableval('zzs_6_5_3', 'tableDataTax_I') +
						this.gettableval('zzs_6_6_3', 'tableDataTax_I')
					);
					this.changetableval(
						'zzs_6_2_5',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_3', 'tableDataTax_I') - this.gettableval('zzs_6_2_4',
							'tableDataTax_I')
					);
				}
				if (e.cellCode == 'zzs_6_2_4') {
					// if (this.gettableval("zzs_6_2_3", "tableDataTax_I") < this.gettableval("zzs_6_2_4",
					// 		"tableDataTax_I")) {
					// 	this.$message.error("zzs_6_2_4格子校验不正确")
					// }
					this.changetableval(
						'zzs_6_2_5',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_3', 'tableDataTax_I') - this.gettableval('zzs_6_2_4',
							'tableDataTax_I')
					);
					this.changetableval(
						'zzs_6_1_4',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_4', 'tableDataTax_I') +
						this.gettableval('zzs_6_3_4', 'tableDataTax_I') +
						this.gettableval('zzs_6_4_4', 'tableDataTax_I') +
						this.gettableval('zzs_6_5_4', 'tableDataTax_I') +
						this.gettableval('zzs_6_6_4', 'tableDataTax_I')
					);
				}
				if (e.cellCode == 'zzs_6_2_5') {
					this.changetableval(
						'zzs_6_1_5',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_5', 'tableDataTax_I') +
						this.gettableval('zzs_6_3_5', 'tableDataTax_I') +
						this.gettableval('zzs_6_4_5', 'tableDataTax_I') +
						this.gettableval('zzs_6_5_5', 'tableDataTax_I') +
						this.gettableval('zzs_6_6_5', 'tableDataTax_I')
					);
					if (this.$emptyandnull(this.gettableval('zzs_6_2_0', 'tableDataTax_I'))) {
						this.changetableval('zzs_6_2_1', 'tableDataTax_I', this.gettableval('zzs_6_2_5', 'tableDataTax_I',
							'old'));
					}
				}
				if (e.cellCode == 'zzs_6_3_1') {
					this.changetableval(
						'zzs_6_1_1',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_1', 'tableDataTax_I') +
						this.gettableval('zzs_6_3_1', 'tableDataTax_I') +
						this.gettableval('zzs_6_4_1', 'tableDataTax_I') +
						this.gettableval('zzs_6_5_1', 'tableDataTax_I') +
						this.gettableval('zzs_6_6_1', 'tableDataTax_I')
					);
					this.changetableval(
						'zzs_6_3_3',
						'tableDataTax_I',
						this.gettableval('zzs_6_3_1', 'tableDataTax_I') + this.gettableval('zzs_6_3_2',
							'tableDataTax_I')
					);
				}
				if (e.cellCode == 'zzs_6_3_2') {
					this.changetableval(
						'zzs_6_1_2',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_2', 'tableDataTax_I') +
						this.gettableval('zzs_6_3_2', 'tableDataTax_I') +
						this.gettableval('zzs_6_4_2', 'tableDataTax_I') +
						this.gettableval('zzs_6_5_2', 'tableDataTax_I') +
						this.gettableval('zzs_6_6_2', 'tableDataTax_I')
					);
					this.changetableval(
						'zzs_6_3_3',
						'tableDataTax_I',
						this.gettableval('zzs_6_3_1', 'tableDataTax_I') + this.gettableval('zzs_6_3_2',
							'tableDataTax_I')
					);
				}
				if (e.cellCode == 'zzs_6_3_3') {
					// if (this.gettableval("zzs_6_3_4", "tableDataTax_I") > this.gettableval("zzs_6_3_3",
					// 		"tableDataTax_I")) {
					// 	this.$message.error("zzs_6_3_4格子校验不正确")
					// }

					this.changetableval(
						'zzs_6_1_3',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_3', 'tableDataTax_I') +
						this.gettableval('zzs_6_3_3', 'tableDataTax_I') +
						this.gettableval('zzs_6_4_3', 'tableDataTax_I') +
						this.gettableval('zzs_6_5_3', 'tableDataTax_I') +
						this.gettableval('zzs_6_6_3', 'tableDataTax_I')
					);
					this.changetableval(
						'zzs_6_3_5',
						'tableDataTax_I',
						this.gettableval('zzs_6_3_3', 'tableDataTax_I') - this.gettableval('zzs_6_3_4',
							'tableDataTax_I')
					);
				}
				if (e.cellCode == 'zzs_6_3_4') {
					// if (this.gettableval("zzs_6_3_4", "tableDataTax_I") > this.gettableval("zzs_6_3_3",
					// 		"tableDataTax_I")) {
					// 	this.$message.error("zzs_6_3_4格子校验不正确")
					// }
					this.changetableval(
						'zzs_6_3_5',
						'tableDataTax_I',
						this.gettableval('zzs_6_3_3', 'tableDataTax_I') - this.gettableval('zzs_6_3_4',
							'tableDataTax_I')
					);
					this.changetableval(
						'zzs_6_1_4',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_4', 'tableDataTax_I') +
						this.gettableval('zzs_6_3_4', 'tableDataTax_I') +
						this.gettableval('zzs_6_4_4', 'tableDataTax_I') +
						this.gettableval('zzs_6_5_4', 'tableDataTax_I') +
						this.gettableval('zzs_6_6_4', 'tableDataTax_I')
					);
				}
				if (e.cellCode == 'zzs_6_3_5') {
					this.changetableval(
						'zzs_6_1_5',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_5', 'tableDataTax_I') +
						this.gettableval('zzs_6_3_5', 'tableDataTax_I') +
						this.gettableval('zzs_6_4_5', 'tableDataTax_I') +
						this.gettableval('zzs_6_5_5', 'tableDataTax_I') +
						this.gettableval('zzs_6_6_5', 'tableDataTax_I')
					);
					if (this.$emptyandnull(this.gettableval('zzs_6_3_0', 'tableDataTax_I'))) {
						this.changetableval('zzs_6_3_1', 'tableDataTax_I', this.gettableval('zzs_6_3_5', 'tableDataTax_I',
							'old'));
					}
				}
				if (e.cellCode == 'zzs_6_4_1') {
					this.changetableval(
						'zzs_6_1_1',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_1', 'tableDataTax_I') +
						this.gettableval('zzs_6_3_1', 'tableDataTax_I') +
						this.gettableval('zzs_6_4_1', 'tableDataTax_I') +
						this.gettableval('zzs_6_5_1', 'tableDataTax_I') +
						this.gettableval('zzs_6_6_1', 'tableDataTax_I')
					);

					this.changetableval(
						'zzs_6_4_3',
						'tableDataTax_I',
						this.gettableval('zzs_6_4_1', 'tableDataTax_I') + this.gettableval('zzs_6_4_2',
							'tableDataTax_I')
					);
				}
				if (e.cellCode == 'zzs_6_4_2') {
					this.changetableval(
						'zzs_6_1_2',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_2', 'tableDataTax_I') +
						this.gettableval('zzs_6_3_2', 'tableDataTax_I') +
						this.gettableval('zzs_6_4_2', 'tableDataTax_I') +
						this.gettableval('zzs_6_5_2', 'tableDataTax_I') +
						this.gettableval('zzs_6_6_2', 'tableDataTax_I')
					);
					this.changetableval(
						'zzs_6_4_3',
						'tableDataTax_I',
						this.gettableval('zzs_6_4_1', 'tableDataTax_I') + this.gettableval('zzs_6_4_2',
							'tableDataTax_I')
					);
				}
				if (e.cellCode == 'zzs_6_4_3') {
					// if (this.gettableval("zzs_6_4_4", "tableDataTax_I") > this.gettableval("zzs_6_4_3",
					// 		"tableDataTax_I")) {
					// 	this.$message.error("zzs_6_4_4格子校验不正确")
					// }

					this.changetableval(
						'zzs_6_1_3',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_3', 'tableDataTax_I') +
						this.gettableval('zzs_6_3_3', 'tableDataTax_I') +
						this.gettableval('zzs_6_4_3', 'tableDataTax_I') +
						this.gettableval('zzs_6_5_3', 'tableDataTax_I') +
						this.gettableval('zzs_6_6_3', 'tableDataTax_I')
					);
					this.changetableval(
						'zzs_6_4_5',
						'tableDataTax_I',
						this.gettableval('zzs_6_4_3', 'tableDataTax_I') - this.gettableval('zzs_6_4_4',
							'tableDataTax_I')
					);
				}
				if (e.cellCode == 'zzs_6_4_4') {
					// if (this.gettableval("zzs_6_4_4", "tableDataTax_I") > this.gettableval("zzs_6_4_3",
					// 		"tableDataTax_I")) {
					// 	this.$message.error("zzs_6_4_4格子校验不正确")
					// }
					this.changetableval(
						'zzs_6_4_5',
						'tableDataTax_I',
						this.gettableval('zzs_6_4_3', 'tableDataTax_I') - this.gettableval('zzs_6_4_4',
							'tableDataTax_I')
					);
					this.changetableval(
						'zzs_6_1_4',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_4', 'tableDataTax_I') +
						this.gettableval('zzs_6_3_4', 'tableDataTax_I') +
						this.gettableval('zzs_6_4_4', 'tableDataTax_I') +
						this.gettableval('zzs_6_5_4', 'tableDataTax_I') +
						this.gettableval('zzs_6_6_4', 'tableDataTax_I')
					);
				}
				if (e.cellCode == 'zzs_6_4_5') {
					this.changetableval(
						'zzs_6_1_5',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_5', 'tableDataTax_I') +
						this.gettableval('zzs_6_3_5', 'tableDataTax_I') +
						this.gettableval('zzs_6_4_5', 'tableDataTax_I') +
						this.gettableval('zzs_6_5_5', 'tableDataTax_I') +
						this.gettableval('zzs_6_6_5', 'tableDataTax_I')
					);
					if (this.$emptyandnull(this.gettableval('zzs_6_4_0', 'tableDataTax_I'))) {
						this.changetableval('zzs_6_4_1', 'tableDataTax_I', this.gettableval('zzs_6_4_5', 'tableDataTax_I',
							'old'));
					}
				}
				if (e.cellCode == 'zzs_6_5_1') {
					this.changetableval(
						'zzs_6_1_1',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_1', 'tableDataTax_I') +
						this.gettableval('zzs_6_3_1', 'tableDataTax_I') +
						this.gettableval('zzs_6_4_1', 'tableDataTax_I') +
						this.gettableval('zzs_6_5_1', 'tableDataTax_I') +
						this.gettableval('zzs_6_6_1', 'tableDataTax_I')
					);

					this.changetableval(
						'zzs_6_5_3',
						'tableDataTax_I',
						this.gettableval('zzs_6_5_1', 'tableDataTax_I') + this.gettableval('zzs_6_5_2',
							'tableDataTax_I')
					);
				}
				if (e.cellCode == 'zzs_6_5_2') {
					this.changetableval(
						'zzs_6_1_2',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_2', 'tableDataTax_I') +
						this.gettableval('zzs_6_3_2', 'tableDataTax_I') +
						this.gettableval('zzs_6_4_2', 'tableDataTax_I') +
						this.gettableval('zzs_6_5_2', 'tableDataTax_I') +
						this.gettableval('zzs_6_6_2', 'tableDataTax_I')
					);
					this.changetableval(
						'zzs_6_5_3',
						'tableDataTax_I',
						this.gettableval('zzs_6_5_1', 'tableDataTax_I') + this.gettableval('zzs_6_5_2',
							'tableDataTax_I')
					);
				}
				if (e.cellCode == 'zzs_6_5_3') {
					// if (this.gettableval("zzs_6_5_4", "tableDataTax_I") > this.gettableval("zzs_6_5_3",
					// 		"tableDataTax_I")) {
					// 	this.$message.error("zzs_6_5_4格子校验不正确")
					// }

					this.changetableval(
						'zzs_6_1_3',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_3', 'tableDataTax_I') +
						this.gettableval('zzs_6_3_3', 'tableDataTax_I') +
						this.gettableval('zzs_6_4_3', 'tableDataTax_I') +
						this.gettableval('zzs_6_5_3', 'tableDataTax_I') +
						this.gettableval('zzs_6_6_3', 'tableDataTax_I')
					);
					this.changetableval(
						'zzs_6_5_5',
						'tableDataTax_I',
						this.gettableval('zzs_6_5_3', 'tableDataTax_I') - this.gettableval('zzs_6_5_4',
							'tableDataTax_I')
					);
				}
				if (e.cellCode == 'zzs_6_5_4') {
					// if (this.gettableval("zzs_6_5_4", "tableDataTax_I") > this.gettableval("zzs_6_5_3",
					// 		"tableDataTax_I")) {
					// 	this.$message.error("zzs_6_5_4格子校验不正确")
					// }
					this.changetableval(
						'zzs_6_5_5',
						'tableDataTax_I',
						this.gettableval('zzs_6_5_3', 'tableDataTax_I') - this.gettableval('zzs_6_5_4',
							'tableDataTax_I')
					);
					this.changetableval(
						'zzs_6_1_4',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_4', 'tableDataTax_I') +
						this.gettableval('zzs_6_3_4', 'tableDataTax_I') +
						this.gettableval('zzs_6_4_4', 'tableDataTax_I') +
						this.gettableval('zzs_6_5_4', 'tableDataTax_I') +
						this.gettableval('zzs_6_6_4', 'tableDataTax_I')
					);
				}
				if (e.cellCode == 'zzs_6_5_5') {
					this.changetableval(
						'zzs_6_1_5',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_5', 'tableDataTax_I') +
						this.gettableval('zzs_6_3_5', 'tableDataTax_I') +
						this.gettableval('zzs_6_4_5', 'tableDataTax_I') +
						this.gettableval('zzs_6_5_5', 'tableDataTax_I') +
						this.gettableval('zzs_6_6_5', 'tableDataTax_I')
					);
					if (this.$emptyandnull(this.gettableval('zzs_6_5_0', 'tableDataTax_I'))) {
						this.changetableval('zzs_6_5_1', 'tableDataTax_I', this.gettableval('zzs_6_5_5', 'tableDataTax_I',
							'old'));
					}
				}
				if (e.cellCode == 'zzs_6_6_1') {
					this.changetableval(
						'zzs_6_1_1',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_1', 'tableDataTax_I') +
						this.gettableval('zzs_6_3_1', 'tableDataTax_I') +
						this.gettableval('zzs_6_4_1', 'tableDataTax_I') +
						this.gettableval('zzs_6_5_1', 'tableDataTax_I') +
						this.gettableval('zzs_6_6_1', 'tableDataTax_I')
					);

					this.changetableval(
						'zzs_6_6_3',
						'tableDataTax_I',
						this.gettableval('zzs_6_6_1', 'tableDataTax_I') + this.gettableval('zzs_6_6_2',
							'tableDataTax_I')
					);
				}
				if (e.cellCode == 'zzs_6_6_2') {
					this.changetableval(
						'zzs_6_1_2',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_2', 'tableDataTax_I') +
						this.gettableval('zzs_6_3_2', 'tableDataTax_I') +
						this.gettableval('zzs_6_4_2', 'tableDataTax_I') +
						this.gettableval('zzs_6_5_2', 'tableDataTax_I') +
						this.gettableval('zzs_6_6_2', 'tableDataTax_I')
					);
					this.changetableval(
						'zzs_6_6_3',
						'tableDataTax_I',
						this.gettableval('zzs_6_6_1', 'tableDataTax_I') + this.gettableval('zzs_6_6_2',
							'tableDataTax_I')
					);
				}
				if (e.cellCode == 'zzs_6_6_3') {
					// if (this.gettableval("zzs_6_6_4", "tableDataTax_I") > this.gettableval("zzs_6_6_3",
					// 		"tableDataTax_I")) {
					// 	this.$message.error("zzs_6_6_4格子校验不正确")
					// }

					this.changetableval(
						'zzs_6_1_3',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_3', 'tableDataTax_I') +
						this.gettableval('zzs_6_3_3', 'tableDataTax_I') +
						this.gettableval('zzs_6_4_3', 'tableDataTax_I') +
						this.gettableval('zzs_6_5_3', 'tableDataTax_I') +
						this.gettableval('zzs_6_6_3', 'tableDataTax_I')
					);
					this.changetableval(
						'zzs_6_6_5',
						'tableDataTax_I',
						this.gettableval('zzs_6_6_3', 'tableDataTax_I') - this.gettableval('zzs_6_6_4',
							'tableDataTax_I')
					);
				}
				if (e.cellCode == 'zzs_6_6_4') {
					// if (this.gettableval("zzs_6_6_4", "tableDataTax_I") > this.gettableval("zzs_6_6_3",
					// 		"tableDataTax_I")) {
					// 	this.$message.error("zzs_6_6_4格子校验不正确")
					// }
					this.changetableval(
						'zzs_6_6_5',
						'tableDataTax_I',
						this.gettableval('zzs_6_6_3', 'tableDataTax_I') - this.gettableval('zzs_6_6_4',
							'tableDataTax_I')
					);
					this.changetableval(
						'zzs_6_1_4',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_4', 'tableDataTax_I') +
						this.gettableval('zzs_6_3_4', 'tableDataTax_I') +
						this.gettableval('zzs_6_4_4', 'tableDataTax_I') +
						this.gettableval('zzs_6_5_4', 'tableDataTax_I') +
						this.gettableval('zzs_6_6_4', 'tableDataTax_I')
					);
				}
				if (e.cellCode == 'zzs_6_6_5') {
					this.changetableval(
						'zzs_6_1_5',
						'tableDataTax_I',
						this.gettableval('zzs_6_2_5', 'tableDataTax_I') +
						this.gettableval('zzs_6_3_5', 'tableDataTax_I') +
						this.gettableval('zzs_6_4_5', 'tableDataTax_I') +
						this.gettableval('zzs_6_5_5', 'tableDataTax_I') +
						this.gettableval('zzs_6_6_5', 'tableDataTax_I')
					);

					this.changetableval('zzs_6_6_1', 'tableDataTax_I', this.gettableval('zzs_6_6_5', 'tableDataTax_I',
						'old'));
				}
				if (e.cellCode == 'zzs_6_8_1') {
					this.changetableval(
						'zzs_6_7_1',
						'tableDataTax_II',
						this.gettableval('zzs_6_8_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_9_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_10_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_1', 'tableDataTax_II')
					);
				}
				if (e.cellCode == 'zzs_6_9_1') {
					this.changetableval(
						'zzs_6_7_1',
						'tableDataTax_II',
						this.gettableval('zzs_6_8_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_9_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_10_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_1', 'tableDataTax_II')
					);
				}
				if (e.cellCode == 'zzs_6_10_1') {
					this.changetableval(
						'zzs_6_10_3',
						'tableDataTax_II',
						this.gettableval('zzs_6_10_1', 'tableDataTax_II') - this.gettableval('zzs_6_10_2',
							'tableDataTax_II')
					);
					this.changetableval(
						'zzs_6_7_1',
						'tableDataTax_II',
						this.gettableval('zzs_6_8_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_9_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_10_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_1', 'tableDataTax_II')
					);
				}
				if (e.cellCode == 'zzs_6_10_2') {
					this.changetableval(
						'zzs_6_7_2',
						'tableDataTax_II',
						this.gettableval('zzs_6_10_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_2', 'tableDataTax_II')
					);
					this.changetableval(
						'zzs_6_10_3',
						'tableDataTax_II',
						this.gettableval('zzs_6_10_1', 'tableDataTax_II') - this.gettableval('zzs_6_10_2',
							'tableDataTax_II')
					);
				}
				if (e.cellCode == 'zzs_6_10_3') {
					this.changetableval(
						'zzs_6_7_3',
						'tableDataTax_II',
						this.gettableval('zzs_6_10_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_3', 'tableDataTax_II')
					);
				}
				if (e.cellCode == 'zzs_6_10_5') {
					this.changetableval(
						'zzs_6_7_5',
						'tableDataTax_II',
						this.gettableval('zzs_6_10_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_5', 'tableDataTax_II')
					);
				}
				if (e.cellCode == 'zzs_6_11_1') {
					this.changetableval(
						'zzs_6_11_3',
						'tableDataTax_II',
						this.gettableval('zzs_6_11_1', 'tableDataTax_II') - this.gettableval('zzs_6_11_2',
							'tableDataTax_II')
					);
					this.changetableval(
						'zzs_6_7_1',
						'tableDataTax_II',
						this.gettableval('zzs_6_8_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_9_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_10_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_1', 'tableDataTax_II')
					);
				}
				if (e.cellCode == 'zzs_6_11_2') {
					this.changetableval(
						'zzs_6_7_2',
						'tableDataTax_II',
						this.gettableval('zzs_6_10_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_2', 'tableDataTax_II')
					);
					this.changetableval(
						'zzs_6_11_3',
						'tableDataTax_II',
						this.gettableval('zzs_6_11_1', 'tableDataTax_II') - this.gettableval('zzs_6_11_2',
							'tableDataTax_II')
					);
				}
				if (e.cellCode == 'zzs_6_11_3') {
					this.changetableval(
						'zzs_6_7_3',
						'tableDataTax_II',
						this.gettableval('zzs_6_10_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_3', 'tableDataTax_II')
					);
				}
				if (e.cellCode == 'zzs_6_11_5') {
					this.changetableval(
						'zzs_6_7_5',
						'tableDataTax_II',
						this.gettableval('zzs_6_10_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_5', 'tableDataTax_II')
					);
				}
				if (e.cellCode == 'zzs_6_12_1') {
					this.changetableval(
						'zzs_6_12_3',
						'tableDataTax_II',
						this.gettableval('zzs_6_12_1', 'tableDataTax_II') - this.gettableval('zzs_6_12_2',
							'tableDataTax_II')
					);
					this.changetableval(
						'zzs_6_7_1',
						'tableDataTax_II',
						this.gettableval('zzs_6_8_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_9_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_10_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_1', 'tableDataTax_II')
					);
				}
				if (e.cellCode == 'zzs_6_12_2') {
					this.changetableval(
						'zzs_6_7_2',
						'tableDataTax_II',
						this.gettableval('zzs_6_10_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_2', 'tableDataTax_II')
					);
					this.changetableval(
						'zzs_6_12_3',
						'tableDataTax_II',
						this.gettableval('zzs_6_12_1', 'tableDataTax_II') - this.gettableval('zzs_6_12_2',
							'tableDataTax_II')
					);
				}
				if (e.cellCode == 'zzs_6_12_3') {
					this.changetableval(
						'zzs_6_7_3',
						'tableDataTax_II',
						this.gettableval('zzs_6_10_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_3', 'tableDataTax_II')
					);
				}
				if (e.cellCode == 'zzs_6_12_5') {
					this.changetableval(
						'zzs_6_7_5',
						'tableDataTax_II',
						this.gettableval('zzs_6_10_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_5', 'tableDataTax_II')
					);
				}

				if (e.cellCode == 'zzs_6_13_1') {
					this.changetableval(
						'zzs_6_13_3',
						'tableDataTax_II',
						this.gettableval('zzs_6_13_1', 'tableDataTax_II') - this.gettableval('zzs_6_13_2',
							'tableDataTax_II')
					);
					this.changetableval(
						'zzs_6_7_1',
						'tableDataTax_II',
						this.gettableval('zzs_6_8_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_9_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_10_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_1', 'tableDataTax_II')
					);
				}
				if (e.cellCode == 'zzs_6_13_2') {
					this.changetableval(
						'zzs_6_7_2',
						'tableDataTax_II',
						this.gettableval('zzs_6_10_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_2', 'tableDataTax_II')
					);
					this.changetableval(
						'zzs_6_13_3',
						'tableDataTax_II',
						this.gettableval('zzs_6_13_1', 'tableDataTax_II') - this.gettableval('zzs_6_13_2',
							'tableDataTax_II')
					);
				}
				if (e.cellCode == 'zzs_6_13_3') {
					this.changetableval(
						'zzs_6_7_3',
						'tableDataTax_II',
						this.gettableval('zzs_6_10_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_3', 'tableDataTax_II')
					);
				}
				if (e.cellCode == 'zzs_6_13_5') {
					this.changetableval(
						'zzs_6_7_5',
						'tableDataTax_II',
						this.gettableval('zzs_6_10_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_5', 'tableDataTax_II')
					);
				}

				if (e.cellCode == 'zzs_6_14_1') {
					this.changetableval(
						'zzs_6_14_3',
						'tableDataTax_II',
						this.gettableval('zzs_6_14_1', 'tableDataTax_II') - this.gettableval('zzs_6_14_2',
							'tableDataTax_II')
					);
					this.changetableval(
						'zzs_6_7_1',
						'tableDataTax_II',
						this.gettableval('zzs_6_8_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_9_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_10_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_1', 'tableDataTax_II')
					);
				}
				if (e.cellCode == 'zzs_6_14_2') {
					this.changetableval(
						'zzs_6_7_2',
						'tableDataTax_II',
						this.gettableval('zzs_6_10_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_2', 'tableDataTax_II')
					);
					this.changetableval(
						'zzs_6_14_3',
						'tableDataTax_II',
						this.gettableval('zzs_6_14_1', 'tableDataTax_II') - this.gettableval('zzs_6_14_2',
							'tableDataTax_II')
					);
				}
				if (e.cellCode == 'zzs_6_14_3') {
					this.changetableval(
						'zzs_6_7_3',
						'tableDataTax_II',
						this.gettableval('zzs_6_10_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_3', 'tableDataTax_II')
					);
				}
				if (e.cellCode == 'zzs_6_14_5') {
					this.changetableval(
						'zzs_6_7_5',
						'tableDataTax_II',
						this.gettableval('zzs_6_10_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_5', 'tableDataTax_II')
					);
				}

				if (e.cellCode == 'zzs_6_15_1') {
					this.changetableval(
						'zzs_6_15_3',
						'tableDataTax_II',
						this.gettableval('zzs_6_15_1', 'tableDataTax_II') - this.gettableval('zzs_6_15_2',
							'tableDataTax_II')
					);
					this.changetableval(
						'zzs_6_7_1',
						'tableDataTax_II',
						this.gettableval('zzs_6_8_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_9_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_10_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_1', 'tableDataTax_II')
					);
				}
				if (e.cellCode == 'zzs_6_15_2') {
					this.changetableval(
						'zzs_6_7_2',
						'tableDataTax_II',
						this.gettableval('zzs_6_10_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_2', 'tableDataTax_II')
					);
					this.changetableval(
						'zzs_6_15_3',
						'tableDataTax_II',
						this.gettableval('zzs_6_15_1', 'tableDataTax_II') - this.gettableval('zzs_6_15_2',
							'tableDataTax_II')
					);
				}
				if (e.cellCode == 'zzs_6_15_3') {
					this.changetableval(
						'zzs_6_7_3',
						'tableDataTax_II',
						this.gettableval('zzs_6_10_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_3', 'tableDataTax_II')
					);
				}
				if (e.cellCode == 'zzs_6_15_5') {
					this.changetableval(
						'zzs_6_7_5',
						'tableDataTax_II',
						this.gettableval('zzs_6_10_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_5', 'tableDataTax_II')
					);
				}
				if (e.cellCode == 'zzs_6_16_1') {
					this.changetableval(
						'zzs_6_16_3',
						'tableDataTax_II',
						this.gettableval('zzs_6_16_1', 'tableDataTax_II') - this.gettableval('zzs_6_16_2',
							'tableDataTax_II')
					);
					this.changetableval(
						'zzs_6_7_1',
						'tableDataTax_II',
						this.gettableval('zzs_6_8_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_9_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_10_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_1', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_1', 'tableDataTax_II')
					);
				}
				if (e.cellCode == 'zzs_6_16_2') {
					this.changetableval(
						'zzs_6_7_2',
						'tableDataTax_II',
						this.gettableval('zzs_6_10_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_2', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_2', 'tableDataTax_II')
					);
					this.changetableval(
						'zzs_6_16_3',
						'tableDataTax_II',
						this.gettableval('zzs_6_16_1', 'tableDataTax_II') - this.gettableval('zzs_6_16_2',
							'tableDataTax_II')
					);
				}
				if (e.cellCode == 'zzs_6_16_3') {
					this.changetableval(
						'zzs_6_7_3',
						'tableDataTax_II',
						this.gettableval('zzs_6_10_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_3', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_3', 'tableDataTax_II')
					);
				}
				if (e.cellCode == 'zzs_6_16_5') {
					this.changetableval(
						'zzs_6_7_5',
						'tableDataTax_II',
						this.gettableval('zzs_6_10_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_11_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_12_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_13_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_14_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_15_5', 'tableDataTax_II') +
						this.gettableval('zzs_6_16_5', 'tableDataTax_II')
					);
				}
				if (e.cellCode.substring(0, 5) == 'zzs_7' && e.cellCode != 'zzs_7_1000_0' && e.cellCode.substr(e.cellCode
						.length - 1) == '6') {
					this.getdkdj();
				}
				if (e.cellCode.split('_')[2] > 0 && e.cellCode.split('_')[3] >= 3 && e.cellCode.substring(0, 5) ==
					'zzs_8') {
					this.gethzns(e.cellCode);
				}
				// if (e.cellCode == "zzs_5_11a_5") {
				// 	this.changetableval("zzs_5_11a_7", 'tableDataV_III', this.gettableval("zzs_5_11a_5",
				// 		"tableDataV_III") *
				// 		'tableDataV_III', this.gettableval("zzs_5_11a_6", "tableDataV_III"))
				// }
				// if (e.cellCode == "zzs_5_11a_6") {
				// 	this.changetableval("zzs_5_11a_7", 'tableDataV_III', this.gettableval("zzs_5_11a_5",
				// 		"tableDataV_III") *
				// 		'tableDataV_III', this.gettableval("zzs_5_11a_6", "tableDataV_III"))
				// }
				// if (e.cellCode == "zzs_5_11b_5") {
				// 	this.changetableval("zzs_5_11b_7", 'tableDataV_III', this.gettableval("zzs_5_11b_5",
				// 		"tableDataV_III") *
				// 		'tableDataV_III', this.gettableval("zzs_5_11b_6", "tableDataV_III"))
				// }
				// if (e.cellCode == "zzs_5_11b_6") {
				// 	this.changetableval("zzs_5_11b_7", 'tableDataV_III', this.gettableval("zzs_5_11b_5",
				// 		"tableDataV_III") *
				// 		'tableDataV_III', this.gettableval("zzs_5_11b_6", "tableDataV_III"))
				// }
				// if (e.cellCode == "zzs_5_11c_5") {
				// 	this.changetableval("zzs_5_11c_7", 'tableDataV_III', this.gettableval("zzs_5_11c_5",
				// 		"tableDataV_III") *
				// 		'tableDataV_III', this.gettableval("zzs_5_11c_6", "tableDataV_III"))
				// }
				// if (e.cellCode == "zzs_5_11c_6") {
				// 	this.changetableval("zzs_5_11c_7", 'tableDataV_III', this.gettableval("zzs_5_11c_5",
				// 		"tableDataV_III") *
				// 		'tableDataV_III', this.gettableval("zzs_5_11c_6", "tableDataV_III"))
				// }
				if (e.cellCode == 'zzs_9_1_1') {
					this.changetableval(
						'zzs_9_5_1',
						'tableDataOTDC_I',
						this.gettableval('zzs_9_1_1', 'tableDataOTDC_I') + this.gettableval('zzs_9_2_1',
							'tableDataOTDC_I')
					);
				}
				if (e.cellCode == 'zzs_9_2_1') {
					this.changetableval(
						'zzs_9_5_1',
						'tableDataOTDC_I',
						this.gettableval('zzs_9_1_1', 'tableDataOTDC_I') + this.gettableval('zzs_9_2_1',
							'tableDataOTDC_I')
					);
				}
				if (e.cellCode == 'zzs_9_1_2') {
					this.changetableval(
						'zzs_9_5_2',
						'tableDataOTDC_I',
						this.gettableval('zzs_9_1_2', 'tableDataOTDC_I') + this.gettableval('zzs_9_2_2',
							'tableDataOTDC_I')
					);
				}
				if (e.cellCode == 'zzs_9_2_2') {
					this.changetableval(
						'zzs_9_5_2',
						'tableDataOTDC_I',
						this.gettableval('zzs_9_1_2', 'tableDataOTDC_I') + this.gettableval('zzs_9_2_2',
							'tableDataOTDC_I')
					);
				}
				if (e.cellCode == 'zzs_9_1_3') {
					this.changetableval(
						'zzs_9_5_3',
						'tableDataOTDC_I',
						this.gettableval('zzs_9_1_3', 'tableDataOTDC_I') +
						this.gettableval('zzs_9_2_3', 'tableDataOTDC_I') +
						this.gettableval('zzs_9_3_3', 'tableDataOTDC_I') +
						this.gettableval('zzs_9_4_3', 'tableDataOTDC_I')
					);
				}
				if (e.cellCode == 'zzs_9_2_3') {
					this.changetableval(
						'zzs_9_5_3',
						'tableDataOTDC_I',
						this.gettableval('zzs_9_1_3', 'tableDataOTDC_I') +
						this.gettableval('zzs_9_2_3', 'tableDataOTDC_I') +
						this.gettableval('zzs_9_3_3', 'tableDataOTDC_I') +
						this.gettableval('zzs_9_4_3', 'tableDataOTDC_I')
					);
				}
				if (e.cellCode == 'zzs_9_3_3') {
					this.changetableval(
						'zzs_9_5_3',
						'tableDataOTDC_I',
						this.gettableval('zzs_9_1_3', 'tableDataOTDC_I') +
						this.gettableval('zzs_9_2_3', 'tableDataOTDC_I') +
						this.gettableval('zzs_9_3_3', 'tableDataOTDC_I') +
						this.gettableval('zzs_9_4_3', 'tableDataOTDC_I')
					);
				}
				if (e.cellCode == 'zzs_9_4_3') {
					this.changetableval(
						'zzs_9_5_3',
						'tableDataOTDC_I',
						this.gettableval('zzs_9_1_3', 'tableDataOTDC_I') +
						this.gettableval('zzs_9_2_3', 'tableDataOTDC_I') +
						this.gettableval('zzs_9_3_3', 'tableDataOTDC_I') +
						this.gettableval('zzs_9_4_3', 'tableDataOTDC_I')
					);
				}
			},
			changezzs_5_1_4() {
				let list = 0;
				if (
					(this.params.companyCode == '1100' ||
						this.params.companyCode == '1200' ||
						this.params.companyCode == '1130' ||
						this.params.companyCode == '4300') &&
					config.company == 'hls'
				) {
					list = this.gettableval('zzs_0_21_1', 'tableDataZero');
				}

				if (
					this.gettableval('zzs_5_8_1', 'tableDataV_II') + this.gettableval('zzs_5_9_1', 'tableDataV_II') >
					this.gettableval('zzs_5_1_1', 'tableDataV_I') + this.gettableval('zzs_5_1_2', 'tableDataV_I')
				) {
					this.changetableval(
						'zzs_5_1_4',
						'tableDataV_I',
						this.gettableval('zzs_5_1_1', 'tableDataV_I') + this.gettableval('zzs_5_1_2', 'tableDataV_I') -
						list
					);
				}
				if (
					0 < this.gettableval('zzs_5_8_1', 'tableDataV_II') + this.gettableval('zzs_5_9_1', 'tableDataV_II') &&
					!(
						this.gettableval('zzs_5_8_1', 'tableDataV_II') + this.gettableval('zzs_5_9_1', 'tableDataV_II') >
						this.gettableval('zzs_5_1_1', 'tableDataV_I') + this.gettableval('zzs_5_1_2', 'tableDataV_I')
					)
				) {
					this.changetableval(
						'zzs_5_1_4',
						'tableDataV_I',
						this.gettableval('zzs_5_8_1', 'tableDataV_II') + this.gettableval('zzs_5_9_1',
							'tableDataV_II') - list
					);
				}
				if (
					!(this.gettableval('zzs_5_8_1', 'tableDataV_II') + this.gettableval('zzs_5_9_1', 'tableDataV_II') >
						0) &&
					!(
						this.gettableval('zzs_5_8_1', 'tableDataV_II') + this.gettableval('zzs_5_9_1', 'tableDataV_II') >
						this.gettableval('zzs_5_1_1', 'tableDataV_I') + this.gettableval('zzs_5_1_2', 'tableDataV_I')
					)
				) {
					this.changetableval('zzs_5_1_4', 'tableDataV_I', 0);
				}
			},
			changezzs_5_2_4() {
				let list = 0;
				if (
					(this.params.companyCode == '1100' ||
						this.params.companyCode == '1200' ||
						this.params.companyCode == '1130' ||
						this.params.companyCode == '4300') &&
					config.company == 'hls'
				) {
					list = this.gettableval('zzs_0_21_1', 'tableDataZero');
				}
				if (
					this.gettableval('zzs_5_8_1', 'tableDataV_II') + this.gettableval('zzs_5_9_1', 'tableDataV_II') >
					this.gettableval('zzs_5_2_1', 'tableDataV_I') + this.gettableval('zzs_5_2_2', 'tableDataV_I')
				) {
					this.changetableval(
						'zzs_5_2_4',
						'tableDataV_I',
						this.gettableval('zzs_5_2_1', 'tableDataV_I') + this.gettableval('zzs_5_2_2', 'tableDataV_I') -
						list
					);
				}
				if (
					(0 < this.gettableval('zzs_5_8_1', 'tableDataV_II') + this.gettableval('zzs_5_9_1', 'tableDataV_II')) &
					!(
						this.gettableval('zzs_5_8_1', 'tableDataV_II') + this.gettableval('zzs_5_9_1', 'tableDataV_II') >
						this.gettableval('zzs_5_2_1', 'tableDataV_I') + this.gettableval('zzs_5_2_2', 'tableDataV_I')
					)
				) {
					this.changetableval(
						'zzs_5_2_4',
						'tableDataV_I',
						this.gettableval('zzs_5_8_1', 'tableDataV_II') + this.gettableval('zzs_5_9_1',
							'tableDataV_II') - list
					);
				}
				if (
					!(this.gettableval('zzs_5_8_1', 'tableDataV_II') + this.gettableval('zzs_5_9_1', 'tableDataV_II') >
						0) &&
					!(
						this.gettableval('zzs_5_8_1', 'tableDataV_II') + this.gettableval('zzs_5_9_1', 'tableDataV_II') >
						this.gettableval('zzs_5_2_1', 'tableDataV_I') + this.gettableval('zzs_5_2_2', 'tableDataV_I')
					)
				) {
					this.changetableval('zzs_5_2_4', 'tableDataV_I', 0);
				}
			},
			changezzs_5_3_4() {
				let list = 0;
				if (
					(this.params.companyCode == '1100' ||
						this.params.companyCode == '1200' ||
						this.params.companyCode == '1130' ||
						this.params.companyCode == '4300') &&
					config.company == 'hls'
				) {
					list = this.gettableval('zzs_0_21_1', 'tableDataZero');
				}
				if (
					this.gettableval('zzs_5_8_1', 'tableDataV_II') + this.gettableval('zzs_5_9_1', 'tableDataV_II') >
					this.gettableval('zzs_5_3_1', 'tableDataV_I') + this.gettableval('zzs_5_3_2', 'tableDataV_I')
				) {
					this.changetableval(
						'zzs_5_3_4',
						'tableDataV_I',
						this.gettableval('zzs_5_3_1', 'tableDataV_I') + this.gettableval('zzs_5_3_2', 'tableDataV_I') -
						list
					);
					console.log(111);
				}
				if (
					0 < this.gettableval('zzs_5_8_1', 'tableDataV_II') + this.gettableval('zzs_5_9_1', 'tableDataV_II') &&
					!(
						this.gettableval('zzs_5_8_1', 'tableDataV_II') + this.gettableval('zzs_5_9_1', 'tableDataV_II') >
						this.gettableval('zzs_5_3_1', 'tableDataV_I') + this.gettableval('zzs_5_3_2', 'tableDataV_I')
					)
				) {
					this.changetableval(
						'zzs_5_3_4',
						'tableDataV_I',
						this.gettableval('zzs_5_8_1', 'tableDataV_II') + this.gettableval('zzs_5_9_1',
							'tableDataV_II') - list
					);
				}
				if (
					!(this.gettableval('zzs_5_8_1', 'tableDataV_II') + this.gettableval('zzs_5_9_1', 'tableDataV_II') >
						0) &&
					!(
						this.gettableval('zzs_5_8_1', 'tableDataV_II') + this.gettableval('zzs_5_9_1', 'tableDataV_II') >
						this.gettableval('zzs_5_3_1', 'tableDataV_I') + this.gettableval('zzs_5_3_2', 'tableDataV_I')
					)
				) {
					this.changetableval('zzs_5_3_4', 'tableDataV_I', 0);
				}
			},
			getdkdj() {
				let total = 0;
				let all = this.filternums(this.tableDatahold, this.holdHead);
				all.forEach((item) => {
					if (item.cellCode != 'zzs_7_1000_0' && item.cellCode.substr(-1) == '6' && item.cellVal != '') {
						total = parseFloat(item.cellVal) + total;
					}
				});
				this.changetableval('zzs_7_1000_0', 'tableDatahold', total);
			}, //
			gethzns(e) {
				let total = 0;
				let all = this.filternums(this.tableDataSummary_II, this.SummaryHead);
				all.forEach((item) => {
					if (item.cellCode.split('_')[3] == e.split('_')[3] && item.cellVal != '' && item.cellCode
						.split('_')[2] != '1000') {
						total = parseFloat(item.cellVal) + total;
					}
				});
				this.changetableval(`zzs_8_1000_${e.split('_')[3]}`, 'tableDataSummary_II', total);
			},
			gettableval(changecode, table, old) {
				var head = '';
				if (table == 'tableDataZero') {
					head = 'ZeroHead';
				}
				if (table == 'tableDataI') {
					head = 'IHead';
				}
				if (table == 'tableDataII_I' || table == 'tableDataII_II' || table == 'tableDataII_III' || table ==
					'tableDataII_IV') {
					head = 'IIHead';
				}
				if (table == 'tableDataIII') {
					head = 'IIIHead';
				}
				if (table == 'tableDataIV_I' || table == 'tableDataIV_II') {
					head = 'IVHead';
				}
				if (table == 'tableDataV_I' || table == 'tableDataV_II') {
					head = 'VHead';
				}
				if (table == 'tableDataTax_I' || table == 'tableDataTax_II') {
					head = 'TaxHead';
				}
				if (table == 'tableDatahold') {
					head = 'holdHead';
				}
				if (table == 'tableDataOTDC_I') {
					head = 'OTDCHead';
				}
				if (table == 'tableDataSummary_I') {
					head = 'SummaryHeadII';
				}
				if (table == 'tableDataSummary_II') {
					head = 'SummaryHead';
				}
				var a;
				if (this[table] && this[head]) {
					for (let i = 0; i < this[table].length; i++) {
						for (let j = 0; j < this[head].length; j++) {
							if (
								this[table][i][this[head][j]] &&
								this[table][i][this[head][j]].cellCode &&
								this[table][i][this[head][j]].cellVal &&
								this[table][i][this[head][j]].cellCode == changecode
							) {
								if (old) {
									if (this.$emptyandnull(this[table][i][this[head][j]].goujgxValue)) {
										a = 0;
									} else {
										a = parseFloat(this[table][i][this[head][j]].goujgxValue);
									}
								} else {
									if (this[table][i][this[head][j]].cellVal == '- -') {
										a = 0;
									} else {
										if (
											changecode != 'zzs_6_2_0' &&
											changecode != 'zzs_6_3_0' &&
											changecode != 'zzs_6_4_0' &&
											changecode != 'zzs_6_5_0' &&
											changecode != 'zzs_6_6_0'
										) {
											a = parseFloat(this[table][i][this[head][j]].cellVal || 0);
										} else {
											a = this[table][i][this[head][j]].cellVal;
										}
									}
								}
								break;
							}
						}
					}
				}

				a = a || 0;
				if (changecode == 'zzs_5_1_9' || changecode == 'zzs_5_2_9' || changecode == 'zzs_5_3_9') {
					if (a > 1) {
						a = this.$numMulti(a, 0.01);
					}
				}
				return a;
			},

			changetableval(changecode, table, newval, checkq, restart) {
				if (this.ruleNum == 'Hollysys-Beijing') {
					if (this.Hollysys_Beijing_Code.includes(changecode) && !restart) {
						return false;
					}
				}
				if (this.ruleNum == 'Hollysys-shandon') {
					if (this.Hollysys_shandon_Code.includes(changecode) && !restart) {
						return false;
					}
				}
				if (this.ruleNum == 'Hollysys-HangZhou') {
					if (this.Hollysys_HangZhou_Code.includes(changecode) && !restart) {
						return false;
					}
				}
				var newval = newval || 0;
				newval = (Math.round(newval * 100) / 100).toFixed(2); //this.toFixed(newval, 2);
				var head = '';
				if (table == 'tableDataZero') {
					head = 'ZeroHead';
				}
				if (table == 'tableDataI') {
					head = 'IHead';
				}
				if (table == 'tableDataII_I' || table == 'tableDataII_II' || table == 'tableDataII_III' || table ==
					'tableDataII_IV') {
					head = 'IIHead';
				}
				if (table == 'tableDataIII') {
					head = 'IIIHead';
				}
				if (table == 'tableDataIV_I' || table == 'tableDataIV_II') {
					head = 'IVHead';
				}
				if (table == 'tableDataV_I' || table == 'tableDataV_II') {
					head = 'VHead';
				}
				if (table == 'tableDataTax_I' || table == 'tableDataTax_II') {
					head = 'TaxHead';
				}
				if (table == 'tableDatahold') {
					head = 'holdHead';
				}
				if (table == 'tableDataOTDC_I') {
					head = 'OTDCHead';
				}
				if (table == 'tableDataSummary_I') {
					head = 'SummaryHeadII';
				}
				if (table == 'tableDataSummary_II') {
					head = 'SummaryHead';
				}

				for (let i = 0; i < this[table].length; i++) {
					for (let j = 0; j < this[head].length; j++) {
						if (
							this[table][i][this[head][j]] &&
							this[table][i][this[head][j]].cellCode &&
							typeof this[table][i][this[head][j]].cellVal != 'undefined' &&
							typeof this[table][i][this[head][j]].cellVal != undefined &&
							this[table][i][this[head][j]].cellCode == changecode
						) {
							if (this[table][i][this[head][j]].cellVal != newval) {
								// if (this.suosq.substring(4, 6) < 5 && checkq) {
								// 	this[table][i][this[head][j]].cellVal = ""
								// } else {
								this[table][i][this[head][j]].cellVal = newval + '';
								// }
								this.inputblur({
									cellCode: changecode,
									cellVal: newval
								});
								break;
							}
						}
					}
				}
			},
      // 获取加计抵减比例
      getAddTheDeductionRatio(){
        let params = {
          companyId: this.params.companyId,
          shuiBNameCode: this.params.sbbm,
          shuibId: this.params.shuibId
        };
        zzs(params).then((res) => {
          if (res.data.code === 1) {
            let item = res.data.data.find(item => item.shuiBDetailId === 5);
            this.jiaJDkBl = item.jiaJDkBl;
          } else {
            this.$message.error(res.data.msg);
          }
        });
      },
      // 出口业务情况
      exportBusinessSituation() {
        this.exportBusinessSituationKey += 1;
        this.exportBusinessSituationDiag = true;
      },
      closeExportBusinessSituationDiag(e) {
        this.exportBusinessSituationDiag = false;
      },
      confirmExportBusinessSituation(e) {
        this.exportBusinessSituationDiag = false;
      }
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
</style>